import {
  Box,
  Flex,
  Text,
  SimpleGrid,
  Td,
  Tr,
  Menu,
  MenuButton,
  MenuItem,
  Image,
  MenuList,
  Spacer,
  RadioGroup,
  Stack,
  Checkbox,
  Divider,
  Radio,
  Th,
  Collapse,
  useDisclosure,
  Heading,
  Textarea,
  VStack,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  IconButton,
  Button,
  Badge,
} from "@chakra-ui/react";
import { Global, css } from "@emotion/react";
import React, { useState, useEffect, useRef } from "react";
import MiniSideBar from "../../components/mini-sidebar";
import SecondaryNav from "../../components/seconday-nav";
import useLoader from "../../components/loader/loaderstates";
import Loader from "../../components/loader/loader";
import { useNavigate } from "react-router-dom";
import DoctorCard from "../../components/doctor-card";
import ModalRight from "../../components/modal-right";
import { DropdownInput, PrimaryButton, PrimaryInput, SearchBar, Toaster } from "../../components";
import DynamicModal from "../../components/dynamic-modal";
import moment from "moment";
import SimpleTable from "../../components/simple-table";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css"; // core Swiper styles
import "swiper/css/navigation"; // navigation module styles
import { getCountry } from "../../middleware/services/country";
import { downloadDocument, formatDate_DD_MM_YYYY, formatDate_Do_MMM_YYYY, formatDate_Do_MMM_YYYY_Time, formatDate_YYYY_MM_DD, getBranchId, getHospitalId, getLoginID, useScreenType } from "../../auth";
import DatePicker from "../../components/date-picker";
import { format } from "date-fns";
import { COLORS } from "../../components/styles/colors";
import { BookAppointment, DischargeSummaryLogs, documentProcessingStatus, FetchCategories, FetchFilteredFollowupsList, FetchFilteredPrescriptionsList, FetchLogsData, FetchPrescriptionViewDetails, GetFollowupsList, GetImagingList, GetOrderList, GetOrderVaccinationList, getProcedureCategoryData, GetProceduresList, saveImagingNotification, saveLabNotification, saveNotification, saveProcedureNotification, saveVaccinationNotification, SubmitLabReport } from "../../middleware/services/prescriptions";
import MobileNavbar from "../../components/mobile-navbar";
import MobileSecondaryNav from "../../components/mobile-secondary-navbar";
import SimpleTableLabs from "../../components/simple-table-labs";
import { GetLabList } from "../../middleware/services/billing";
import { CopyIcon } from "@chakra-ui/icons";
import { CgRemove } from "react-icons/cg";
import { getProfile } from "../../middleware/services/profile";

const PrescriptionViewIndex = () => {
  const { isLoading, showLoader, dismissLoader } = useLoader();
  const [activeTab, setActiveTab] = useState("prescriptions");
  const navigate = useNavigate();
  const [adminid, setAdminID] = useState("");
  const [doctorid, setLoginID] = useState("");
  const [surgeriesData, setSurgeriesData] = useState(null);
  var [conditionsList, setConditionsList] = useState([]);
  var [conditionsListMerge, setConditionsListMerge] = useState(null);
  const { showSuccessToast, showErrorToast } = Toaster();
  const [searchValue, setSearchValue] = useState("");
  const [searchValuemerge, setSearchValueMerge] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: 'codevalue', direction: 'ascending' });
  const [isNextDisabled, setIsNextDisabled] = useState();

  var [paymentsList, setPaymentsList] = useState([]);
  var [prescriptionViewdata, setPrescriptionViewdata] = useState([]);
  var [followupViewData, setFollowupViewData] = useState([]);
  var [labsViewdata, setLabsViewdata] = useState([]);
  var [vaccinationsViewData, setVaccinationsViewData] = useState([]);
  var [imagingViewdata, setImagingViewdata] = useState([]);
  var [procedureViewdata, setProcedureViewdata] = useState([]);
  var [procedureNotificationData, setProcedureNotificationData] = useState([]);
  var [userName, setUserName] = useState('');
  var [email, setEmail] = useState('');
  var [mobile, setMobile] = useState('');
  var [userType, setUserType] = useState('');
  var [fromDate, setFromDate] = useState(null);
  var [toDate, setToDate] = useState(null);
  const [toDateMinMax, setToDateMinMax] = useState("")
  const [fromDateMinMax, setFromDateMinMax] = useState("")
  const [initialRender, setInitialRender] = useState(true)
  const [summaryStatus, setSummaryStatus] = useState(null)


  let itemPerPageCommonValue = 30;

  let [pagesize, setPagesize] = useState(itemPerPageCommonValue);
  let [pageno, setPageno] = useState(1);

  // states for item count display
  let [countTo, setCountTo] = useState(itemPerPageCommonValue);
  let [countFrom, setCountFrom] = useState(1);
  let [totalExceedsPageCount, setTotalExceedsPageCount] = useState(false);


  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItemCount, setTotalItemCount] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [showFilterCount, setShowFilterCount] = useState(false);
  var [logsData, setLogsData] = useState(null);
  const showLabLogs = useRef()
  const showImagingLogs = useRef()
  const showProcedureLogs = useRef()
  const tableRef = useRef()
  const screenType = useScreenType()
  const { isOpen, onToggle } = useDisclosure()
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return moment(dateString).format("Do MMM, YYYY");
  };

  const tabChanged = (tab) => {

    setSearchValue("")
    if (tab === "prescriptions") {
      setActiveTab("prescriptions");
      setCountFrom(1)
      setCountTo(itemPerPageCommonValue)
      setCurrentPage(1)
      fetchPrescriptionsList()
    } else if (tab === "followups") {
      setActiveTab("followups");
      setCountFrom(1)
      setCountTo(itemPerPageCommonValue)
      setCurrentPage(1)
      fetchFollowupsList();
    } else if (tab === "labs") {
      setActiveTab("labs");
      setCountFrom(1)
      setCountTo(itemPerPageCommonValue)
      setCurrentPage(1)
      fetchLabsList();
    } else if (tab === "imaging") {
      setActiveTab("imaging");
      setCountFrom(1)
      setCountTo(itemPerPageCommonValue)
      setCurrentPage(1)
      fetchImagingsList();
    } else if (tab === "procedures") {
      setActiveTab("procedures");
      setCountFrom(1)
      setCountTo(itemPerPageCommonValue)
      setCurrentPage(1)
      fetchProceduresList();
    } else if (tab === "discharge") {
      // const getDischargeSummaryStatus = localStorage.getItem('saveDischarge');
      // setSummaryStatus(getDischargeSummaryStatus)

      getDoctorProfile();
      fetchDischargeLogs();
      setActiveTab("discharge");
    } else if (tab === "vaccinations") {
      setActiveTab("vaccinations");
      setCountFrom(1)
      setCountTo(itemPerPageCommonValue)
      setCurrentPage(1)
      fetchVaccinationsList();
    } 
  };

  const [dischargeDisplaySettings, setDischargeDisplaySettings] = useState(null)
    const getDoctorProfile = async () => {
      showLoader();
      try {
        var result = await getProfile({});
        if (result && result.dischargesettingsdata) {
          // setShareReportDoctorEmail(result.ProfileOutput?.email);
          console.log('result.dischargesettingsdata:', result.dischargesettingsdata)
          setDischargeDisplaySettings(result.dischargesettingsdata)
        }
        // if (result && result.ProfileOutput) {
        //   setShareReportDoctorEmail(result.ProfileOutput?.email);
        //   console.log('result.dischargesettingsdata:', result.dischargesettingsdata)
        //   setDischargeDisplaySettings(result.dischargesettingsdata)
        // }
      } catch (error) {
        console.log(error, "Something went wrong in doctor profile");
      } 
      // finally {
      //   dismissLoader();
      // }
    };

  // ------------------------------ Prescriptions Functionality start --------------
  var [userNamePrescription, setUserNamePrescription] = useState('');
  var [prescriptionEmail, setPrescriptionEmail] = useState('');

  const handleChangePrescriptionName = (event) => {
    let inputValue = event.target.value;
    inputValue = inputValue.replace(/[^A-Za-z\s]/g, '').slice(0, 50);
    event.target.value = inputValue;
    setUserNamePrescription(event.target.value);
  };
  const handleChangePrescriptionEmail = (event) => {
    const sanitizedValue = event.target.value.replace(/[^\x00-\x7F]/g, '')
    setPrescriptionEmail(sanitizedValue);
  };
  const handleFromDate = (selectedDate) => {
    const formattedDate = format(selectedDate, "dd-MM-yyyy");
    // console.log('formattedDAte: ', formattedDate)
    setFromDate(formattedDate);

    setFromDateMinMax(selectedDate);
  };
  const handleToDate = (selectedDate) => {
    const formattedDate = format(selectedDate, "dd-MM-yyyy");
    setToDate(formattedDate);

    setToDateMinMax(selectedDate);
  };

  var fetchPrescriptionsList = async () => {
    showLoader();
    try {
      var result = await FetchPrescriptionViewDetails({
        "doctorid": getLoginID(),
        'pageno': 1,
        pagesize
      });

      if (result?.data) {
        setPrescriptionViewdata(result.data);
        let count = result?.count;
        let pageno = result?.pageno;
        let pagesize = result?.pagesize;
        setTotalItemCount(count)
        let totalPagesCalc = count / pagesize;
        let totalPagesCount = Math.ceil(totalPagesCalc);

        setTotalPages(totalPagesCount);

        setTotalItemCount(count)
        if (result && result.count < itemPerPageCommonValue) {
          setCountTo(result.count)
          setTotalExceedsPageCount(true)
        } else if (count > itemPerPageCommonValue && pageno == 1) {
          setCountTo(itemPerPageCommonValue);
          setTotalExceedsPageCount(false);
        }

      } else {
        setPrescriptionViewdata([])
      }
    } catch (error) {
      console.error("Error in home:", error);
    }
    dismissLoader();
  };

  const getPrescriptionsFilteredResults = () => {
    // if(!name && !email && !specialization && (!status || status== '')){
    //       showErrorToast('Please enter the inputs to filter.')
    //       return;
    //     }
    const tableContainer = document.querySelector('.tableContainer');
    if (tableContainer) {
      tableContainer.scrollTop = 0;
    }
    showLoader();
    var input = {
      "doctorid": getLoginID(),
      "searchtext": userNamePrescription,
      "useremail": prescriptionEmail,
      // "username": userNamePrescription,
      "fromdate": formatDate_YYYY_MM_DD(fromDate),
      "todate": formatDate_YYYY_MM_DD(toDate),
      "pageno": pageno,
      pagesize
    };
    var getPrescriptionsList = async () => {
      try {
        var result = await FetchFilteredPrescriptionsList(input);

        if (result?.data) {
          setPrescriptionViewdata(result.data);
          let count = result?.count;
          let pageno = result?.pageno;
          let pagesize = result?.pagesize;
          setTotalItemCount(count)
          let totalPagesCalc = count / pagesize;
          let totalPagesCount = Math.ceil(totalPagesCalc);
          // alert(totalPages)
          setTotalPages(totalPagesCount);
          // setFilteredData(result.data);
          setTotalItemCount(result.count)
          if (result && result.count < itemPerPageCommonValue) {
            setCountTo(result.count)
            setTotalExceedsPageCount(true)
          } else if (count > itemPerPageCommonValue && pageno == 1) {
            setCountTo(itemPerPageCommonValue);
            setTotalExceedsPageCount(false);
          }
        } else {
          setPrescriptionViewdata([])
        }
      } catch (error) {
        console.log(error, "error in getDoctorsList");
      }
      dismissLoader();
    };

    getPrescriptionsList();
  };

  const handlePrescriptionsApplyFilters = () => {
    // if(!patientName && !email && !mobile && (!plan || plan== '')){
    //   showErrorToast('Please enter the inputs to filter.')
    //   return;
    // }
    if (!userNamePrescription && !prescriptionEmail && !fromDate && !toDate) {
      showErrorToast('Please enter the inputs to filter.')
      return;
    }
    setCountFrom(1)
    setShowFilterCount(true);
    setPageno(1)
    setCurrentPage(1)
    getPrescriptionsFilteredResults();
  };

  const prescriptionResetFields = () => {
    setFromDate('')
    setToDate('')
    setFromDateMinMax(null)
    setToDateMinMax(null)
    setUserNamePrescription('')
    setPrescriptionEmail('')
    setUserType('')
    setMobile('')
    setCurrentPage(1);
    setPageno(1);
    // setPagesize(30);
    //clear states for correct item count
    setPagesize(itemPerPageCommonValue);
    setCountFrom(1)
    setCountTo(itemPerPageCommonValue)
    setCurrentPage(1)
    setShowFilterCount(false);
    fetchPrescriptionsList();

    setRefresh(!refresh);
  };

  const handleApplyFilters = () => {
    // if(!patientName && !email && !mobile && (!plan || plan== '')){
    //   showErrorToast('Please enter the inputs to filter.')
    //   return;
    // }
    setShowFilterCount(true);
    setPageno(1)
    setCurrentPage(1)
    // getFilteredResults();
    getPrescriptionsFilteredResults();
  };
  // ------------------------------ Prescriptions Functionality end --------------


  // ------------------------------ Followups Functionality start --------------
  const followupNotification = useRef();
  var [userNameFollowup, setUserNameFollowup] = useState('');
  var [fromDateFollowup, setFromDateFollowup] = useState(null);
  var [toDateFollowup, setToDateFollowup] = useState(null);
  const [toDateMinMaxFollowup, setToDateMinMaxFollowup] = useState("")
  const [fromDateMinMaxFollowup, setFromDateMinMaxFollowup] = useState("")

  const handleChangeFollowupName = (event) => {
    let inputValue = event.target.value;
    inputValue = inputValue.replace(/[^A-Za-z\s]/g, '').slice(0, 50);
    event.target.value = inputValue;
    setUserNameFollowup(event.target.value);
  };
  const handleFollowupFromDate = (selectedDate) => {
    const formattedDate = format(selectedDate, "dd-MM-yyyy");
    // console.log('formattedDAte: ', formattedDate)
    setFromDateFollowup(formattedDate);

    setFromDateMinMaxFollowup(selectedDate);
  };
  const handleFollowupToDate = (selectedDate) => {
    const formattedDate = format(selectedDate, "dd-MM-yyyy");
    setToDateFollowup(formattedDate);

    setToDateMinMaxFollowup(selectedDate);
  };

  var fetchFollowupsList = async () => {
    showLoader();
    try {
      var result = await GetFollowupsList({
        "doctorid": getLoginID(),
        'pageno': 1,
        pagesize
      });

      if (result?.data) {
        setFollowupViewData(result.data);
        let count = result?.count;
        let pageno = result?.pageno;
        let pagesize = result?.pagesize;
        setTotalItemCount(count)
        let totalPagesCalc = count / pagesize;
        let totalPagesCount = Math.ceil(totalPagesCalc);

        setTotalPages(totalPagesCount);

        setTotalItemCount(count)
        if (result && result.count < itemPerPageCommonValue) {
          setCountTo(result.count)
          setTotalExceedsPageCount(true)
        } else if (count > itemPerPageCommonValue && pageno == 1) {
          setCountTo(itemPerPageCommonValue);
          setTotalExceedsPageCount(false);
        }

      } else {
        setFollowupViewData([])
      }
    } catch (error) {
      console.error("Error in home:", error);
    }
    dismissLoader();
  };

  const getFollowupsFilteredResults = () => {
    const tableContainer = document.querySelector('.tableContainer');
    if (tableContainer) {
      tableContainer.scrollTop = 0;
    }
    showLoader();
    var input = {
      "doctorid": getLoginID(),
      "searchtext": userNameFollowup,
      "startdate": formatDate_YYYY_MM_DD(fromDateFollowup),
      "enddate": formatDate_YYYY_MM_DD(toDateFollowup),
      "pageno": pageno,
      pagesize
    };
    var getFollowupsList = async () => {
      try {
        var result = await FetchFilteredFollowupsList(input);

        if (result?.data) {
          setFollowupViewData(result.data);
          let count = result?.count;
          let pageno = result?.pageno;
          let pagesize = result?.pagesize;
          setTotalItemCount(count)
          let totalPagesCalc = count / pagesize;
          let totalPagesCount = Math.ceil(totalPagesCalc);
          // alert(totalPages)
          setTotalPages(totalPagesCount);
          // setFilteredData(result.data);
          setTotalItemCount(result.count)
          if (result && result.count < itemPerPageCommonValue) {
            setCountTo(result.count)
            setTotalExceedsPageCount(true)
          } else if (count > itemPerPageCommonValue && pageno == 1) {
            setCountTo(itemPerPageCommonValue);
            setTotalExceedsPageCount(false);
          }
        } else {
          setFollowupViewData([])
        }
      } catch (error) {
        console.log(error, "error in getDoctorsList");
      }
      dismissLoader();
    };

    getFollowupsList();
  };

  const handleFollowupsApplyFilters = () => {
    // if(!patientName && !email && !mobile && (!plan || plan== '')){
    //   showErrorToast('Please enter the inputs to filter.')
    //   return;
    // }
    if (!userNameFollowup && !fromDateFollowup && !toDateFollowup) {
      showErrorToast('Please enter the inputs to filter.')
      return;
    }
    setCountFrom(1)
    setShowFilterCount(true);
    setPageno(1)
    setCurrentPage(1)
    getFollowupsFilteredResults();
  };

  const followupResetFields = () => {
    setFromDateFollowup('')
    setToDateFollowup('')
    setFromDateMinMaxFollowup(null)
    setToDateMinMaxFollowup(null)
    setUserNameFollowup('')
    setCurrentPage(1);
    setPageno(1);
    // setPagesize(30);
    //clear states for correct item count
    setPagesize(itemPerPageCommonValue);
    setCountFrom(1)
    setCountTo(itemPerPageCommonValue)
    setCurrentPage(1)
    setShowFilterCount(false);
    fetchFollowupsList();

    setRefresh(!refresh);
  };

  const [followupDoctor, setFollowupDoctor] = useState(null);
  const [followupDoctorId, setFollowupDoctorId] = useState(null);
  const [followupAppointmentId, setFollowupAppointmentId] = useState(null);
  const [followupfcmToken, setFollowupfcmToken] = useState(null);
  const [followupPatientId, setFollowupPatientId] = useState(null);
  const [followupPatientName, setFollowupPatientName] = useState(null);
  const [followupDate, setFollowupDate] = useState(null);
  const [followupOriginalDate, setFollowupOriginalDate] = useState(null);

  const openNotificationModal = (patientDetails) => {
    // console.log('patientdetials: ', patientDetails)
    const formatedDate = formatDate_Do_MMM_YYYY_Time(patientDetails.followupdate)
    // console.log(formatedDate, 'formaterdDated')

    setFollowupDoctor(patientDetails.doctorname)
    setFollowupAppointmentId(patientDetails.orderid)
    setFollowupfcmToken(patientDetails.patientfcmtoken)
    setFollowupPatientId(patientDetails.patientid)
    setFollowupPatientName(patientDetails.patientname)
    setFollowupDoctorId(patientDetails.doctorid)
    setFollowupDate(formatedDate)
    setFollowupOriginalDate(patientDetails.followupdate)

    followupNotification.current.openModal();
  }

  const sendFollowupNotification = async () => {
    const input = [{
      'doctorname': followupDoctor,
      'fcmtoken': followupfcmToken,
      'procedurename': '',
      'patientid': followupPatientId,
      'doctorid': followupDoctorId,
      'patientname': followupPatientName,
      'type': '',
      'aicontent': '',
      'notificationcategoryid': 4,
      'orderid': followupAppointmentId,
      title: "Follow-up Reminder",
      description: `Your follow-up visit is recommended on ${followupDate}. Please schedule your appointment at your convenience. Stay on top of your health!`,
      "followupdate": followupOriginalDate ,
      "branchid": getBranchId(),
      "hospitalid": getHospitalId()
  }];
    showLoader();
    try {
      const result = await saveNotification(input);
      if(result && result.output.result === 'success'){
        showSuccessToast('Notification sent successfully');
        followupNotification.current.closeModal();
        fetchFollowupsList();
      }

    } catch (error) {
      console.error("Error in Sending Followup Notification: ", error)
    }
  }
  // ------------------------------ Followups Functionality end --------------

  // ------------------------------------------------------
  // Pagination Functionality & Page load
  useEffect(() => {
    showLoader();
    if (activeTab == 'prescriptions') {
      fetchPrescriptionsList();
    } else if (activeTab == 'followups') {
      fetchFollowupsList();
    } else if (activeTab == 'labs') {
      fetchLabsList();
    } else if (activeTab == 'imaging') {
      fetchImagingsList();
    } else if (activeTab == 'procedures') {
      fetchProceduresList();
    } else if (activeTab == 'discharge') {
      // const getDischargeSummaryStatus = localStorage.getItem('saveDischarge');
      // console.log('getDischarSummaruyStart', getDischargeSummaryStatus)
      // setSummaryStatus(getDischargeSummaryStatus)
      fetchDischargeLogs();
    } else if (activeTab == 'vaccinations') {
      fetchVaccinationsList();
    }
  }, [refresh])

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      // console.log('Enter key pressed');
      // handleApplyFilters();
      if (activeTab == 'prescriptions') {
        handleApplyFilters();
      } else if (activeTab == 'followups') {
        // handleFollowupsApplyFilters();
        handleLabsApplyFilters();
      } else if (activeTab == 'labs') {
        handleLabsApplyFilters();
      } else if (activeTab == 'imaging') {
        handleImagingApplyFilters();
      } else if (activeTab == 'procedures') {
        handleProcedureApplyFilters();
      } else if (activeTab == 'discharge') {
        handleDischargeApplyFilters();
      } else if (activeTab == 'vaccinations') {
        handleVaccinationsApplyFilters();
      }
    }
  };

  useEffect(() => {
    if (pageno && !initialRender) {
      if (activeTab == 'prescriptions') {
        getPrescriptionsFilteredResults();
      } else if (activeTab == 'followups') {
        // getFollowupsFilteredResults();
        getLabsFilteredResults();
      } else if (activeTab == 'labs') {
        getLabsFilteredResults();
      } else if (activeTab == 'imaging') {
        getImagingFilteredResults();
      } else if (activeTab == 'procedures') {
        getProcedureFilteredResults();
      } else if (activeTab == 'discharge') {
        getDischargeFilteredResults();
      } else if (activeTab == 'vaccinations') {
        getVaccinationsFilteredResults();
      }
    }
    setInitialRender(false)
  }, [pageno])

  const handleNextClick = () => {
    let page = pageno + 1;
    //  alert(page)
    setPageno(page);
    setCurrentPage(currentPage + 1);
    // getFilteredResults();

    // item count logic for next
    if (countTo + pagesize < totalItemCount) {
      setCountTo(countTo + pagesize)
    } else {
      setCountTo(totalItemCount)
    }

    setCountFrom(countFrom + pagesize)
  };
  const handlePreviousClick = () => {
    let page = pageno - 1;
    //alert(page)
    setPageno(page);
    // setPageno(pageno - 1);
    setCurrentPage(currentPage - 1);
    // getFilteredResults();
    // item count logic for previous

    setCurrentPage(currentPage - 1);
    if (countTo == totalItemCount) {
      //setCountTo(Math.floor(totalItemCount / 10) * 10)
      let updatedCountUnroundedValue = totalItemCount - pagesize;
      setCountTo(Math.ceil(updatedCountUnroundedValue / 10) * 10)

    } else {
      setCountTo(countTo - pagesize)
    }

    setCountFrom(countFrom - pagesize)
  };

  // --------------------------- Labs Functionality start ----------------------------
  var [userNameLab, setUserNameLab] = useState('');
  var [ageGroupType, setAgeGroupType] = useState('');
  var [ageGroupTypeId, setAgeGroupTypeId] = useState('');
  var [labStatusType, setLabStatusType] = useState('');
  var [labStatusTypeId, setLabStatusTypeId] = useState('');
  var [timeFactor, setTimeFactor] = useState('');
  var [labsFromDate, setLabsFromDate] = useState('');
  var [labsToDate, setLabsToDate] = useState('');

  const handleChangelabName = (event) => {
    let inputValue = event.target.value;
    inputValue = inputValue.replace(/[^A-Za-z\s]/g, '').slice(0, 50);
    event.target.value = inputValue;
    setUserNameLab(event.target.value);
  };
  const handleChangeAgeGroup = (value) => {
    if (value == "1-5") {
      setAgeGroupType("1-5")
      setAgeGroupTypeId("1")
    } else if (value == "6-10") {
      setAgeGroupType("6-10")
      setAgeGroupTypeId("2")
    } else if (value == "11-15") {
      setAgeGroupType("11-15")
      setAgeGroupTypeId("3")
    } else if (value == "16-20") {
      setAgeGroupType("16-20")
      setAgeGroupTypeId("4")
    } else if (value == "21-25") {
      setAgeGroupType("21-25")
      setAgeGroupType("5")
    } else if (value == "26-30") {
      setAgeGroupType("26-30")
      setAgeGroupTypeId("6")
    } else if (value == "31-35") {
      setAgeGroupType("31-35")
      setAgeGroupTypeId("7")
    } else if (value == "36-40") {
      setAgeGroupType("36-40")
      setAgeGroupTypeId("8")
    } else if (value == "46+") {
      setAgeGroupType("46+")
      setAgeGroupTypeId("9")
    }
  }
  const handleChangeTimeFactor = (value) => {
    var today = new Date();
    if (value == "Last 15 Days") {
      setTimeFactor("Last 15 Days")
      setLabsFromDate(moment().subtract(15, 'days').format('YYYY-MM-DD'))
      // setLabsToDate(moment().format('YYYY-MM-DD'))
      setLabsToDate(today)
    } else if (value == "Last 30 Days") {
      setTimeFactor("Last 30 Days")
      setLabsFromDate(moment().subtract(30, 'days').format('YYYY-MM-DD'))
      setLabsToDate(today)
    } else if (value == "Last 45 Days") {
      setTimeFactor("Last 45 Days")
      setLabsFromDate(moment().subtract(45, 'days').format('YYYY-MM-DD'))
      setLabsToDate(today)
    } else if (value == "Last 60 Days") {
      setTimeFactor("Last 60 Days")
      setLabsFromDate(moment().subtract(60, 'days').format('YYYY-MM-DD'))
      setLabsToDate(today)
    } else if (value == "Last 75 Days") {
      setTimeFactor("Last 75 Days")
      setLabsFromDate(moment().subtract(75, 'days').format('YYYY-MM-DD'))
      setLabsToDate(today)
    } else if (value == "Last 90 Days") {
      setTimeFactor("Last 90 Days")
      setLabsFromDate(moment().subtract(90, 'days').format('YYYY-MM-DD'))
      setLabsToDate(today)
    }
  }
  const handleLabChangeStatus = (value) => {
    if (value == "Prescribed") {
      setLabStatusType("Prescribed")
      setLabStatusTypeId("1")
    } else if (value == "Registered") {
      setLabStatusType("Registered")
      setLabStatusTypeId("2")
    } else if (value == "Sample Collected") {
      setLabStatusType("Sample Collected")
      setLabStatusTypeId("3")
    } else if (value == "In Transit") {
      setLabStatusType("In Transit")
      setLabStatusTypeId("4")
    } else if (value == "Processing") {
      setLabStatusType("Processing")
      setLabStatusTypeId("5")
    } else if (value == "Validation Pending") {
      setLabStatusType("Validation Pending")
      setLabStatusTypeId("6")
    } else if (value == "Under Review") {
      setLabStatusType("Under Review")
      setLabStatusTypeId("7")
    } else if (value == "Provisional Report Ready") {
      setLabStatusType("Provisional Report Ready")
      setLabStatusTypeId("8")
    } else if (value == "Signed Off") {
      setLabStatusType("Signed Off")
      setLabStatusTypeId("9")
    } else if (value == "Report Available") {
      setLabStatusType("Report Available")
      setLabStatusTypeId("10")
    } else if (value == "Notified") {
      setLabStatusType("Notified")
      setLabStatusTypeId("11")
    }
  }

  var fetchLabsList = async () => {
    showLoader();
    try {
      var result = await GetOrderList({
        "doctorid": getLoginID(),
        'pageno': 1,
        pagesize
      });
      // console.log('resultLabData: ', result.data)  

      if (result?.data) {
        setLabsViewdata(result.data);
        let count = result?.count;
        let pageno = result?.pageno;
        let pagesize = result?.pagesize;
        setTotalItemCount(count)
        let totalPagesCalc = count / pagesize;
        let totalPagesCount = Math.ceil(totalPagesCalc);

        setTotalPages(totalPagesCount);

        setTotalItemCount(count)
        if (result && result.count < itemPerPageCommonValue) {
          setCountTo(result.count)
          setTotalExceedsPageCount(true)
        } else if (count > itemPerPageCommonValue && pageno == 1) {
          setCountTo(itemPerPageCommonValue);
          setTotalExceedsPageCount(false);
        }

      } else {
        setLabsViewdata([])
      }
    } catch (error) {
      console.error("Error in home:", error);
    }
    dismissLoader();
  };

  const getLabsFilteredResults = () => {
    // if(!name && !email && !specialization && (!status || status== '')){
    //       showErrorToast('Please enter the inputs to filter.')
    //       return;
    //     }
    const tableContainer = document.querySelector('.tableContainer');
    if (tableContainer) {
      tableContainer.scrollTop = 0;
    }
    showLoader();
    var input = {
      "doctorid": getLoginID(),
      "searchtext": userNameLab,
      // "username": userNameLab,
      'agenumber': ageGroupTypeId,
      // "fromdate": formatDate_YYYY_MM_DD(labsFromDate),
      "startdate": labsFromDate,
      "status": labStatusTypeId,
      "enddate": formatDate_YYYY_MM_DD(labsToDate),
      "pageno": pageno,
      pagesize
    };
    var getLabsList = async () => {
      try {
        var result = await GetOrderList(input);

        if (result?.data) {
          setLabsViewdata(result.data);
          let count = result?.count;
          let pageno = result?.pageno;
          let pagesize = result?.pagesize;
          setTotalItemCount(count)
          let totalPagesCalc = count / pagesize;
          let totalPagesCount = Math.ceil(totalPagesCalc);
          // alert(totalPages)
          setTotalPages(totalPagesCount);
          // setFilteredData(result.data);
          setTotalItemCount(result.count)
          if (result && result.count < itemPerPageCommonValue) {
            setCountTo(result.count)
            setTotalExceedsPageCount(true)
          } else if (count > itemPerPageCommonValue && pageno == 1) {
            setCountTo(itemPerPageCommonValue);
            setTotalExceedsPageCount(false);
          }
        } else {
          setLabsViewdata([])
        }
      } catch (error) {
        console.log(error, "error in getDoctorsList");
      }
      dismissLoader();
    };

    getLabsList();
  };

  const handleLabsApplyFilters = () => {
    if (!userNameLab && !ageGroupType && !timeFactor && !labStatusType) {
      showErrorToast('Please enter the inputs to filter.')
      return;
    }
    setCountFrom(1)
    setShowFilterCount(true);
    setPageno(1)
    setCurrentPage(1)
    getLabsFilteredResults();
  };

  const labResetFields = () => {
    setUserNameLab('')
    setAgeGroupType('')
    setAgeGroupTypeId('')
    setLabStatusType('')
    setLabStatusTypeId('')
    setLabsFromDate('')
    setLabsToDate('')
    setTimeFactor('')
    setCurrentPage(1);
    setPageno(1);
    // setPagesize(30);
    //clear states for correct item count
    setPagesize(itemPerPageCommonValue);
    setCountFrom(1)
    setCountTo(itemPerPageCommonValue)
    setCurrentPage(1)
    setShowFilterCount(false);
    fetchLabsList();

    setRefresh(!refresh);
  };

  // --------------------------- Labs Functionality end ----------------------------

  // --------------------------- Imaging Functionality start ----------------------------
  var [userNameImaging, setUserNameImaging] = useState('');
  var [imagingAgeGroup, setImagingAgeGroup] = useState('');
  var [imagingAgeGroupTypeId, setImagingAgeGroupTypeId] = useState('');
  var [imagingStatusType, setImagingStatusType] = useState('');
  var [imagingStatusTypeId, setImagingStatusTypeId] = useState('');
  var [imagingTimeFactor, setImagingTimeFactor] = useState('');
  var [imagingsFromDate, setImagingsFromDate] = useState('');
  var [imagingsToDate, setImagingsToDate] = useState('');

  const handleChangeImagingName = (event) => {
    let inputValue = event.target.value;
    inputValue = inputValue.replace(/[^A-Za-z\s]/g, '').slice(0, 50);
    event.target.value = inputValue;
    setUserNameImaging(event.target.value);
  };
  const handleImagingAgeGroup = (value) => {
    if (value == "1-5") {
      setImagingAgeGroup("1-5")
      setImagingAgeGroupTypeId("1")
    } else if (value == "6-10") {
      setImagingAgeGroup("6-10")
      setImagingAgeGroupTypeId("2")
    } else if (value == "11-15") {
      setImagingAgeGroup("11-15")
      setImagingAgeGroupTypeId("3")
    } else if (value == "16-20") {
      setImagingAgeGroup("16-20")
      setImagingAgeGroupTypeId("4")
    } else if (value == "21-25") {
      setImagingAgeGroup("21-25")
      setImagingAgeGroupTypeId("5")
    } else if (value == "26-30") {
      setImagingAgeGroup("26-30")
      setImagingAgeGroupTypeId("6")
    } else if (value == "31-35") {
      setImagingAgeGroup("31-35")
      setImagingAgeGroupTypeId("7")
    } else if (value == "36-40") {
      setImagingAgeGroup("41-45")
      setImagingAgeGroupTypeId("8")
    } else if (value == "46+") {
      setImagingAgeGroup("46+")
      setImagingAgeGroupTypeId("9")
    }
  }
  const handleImagingTimeFactor = (value) => {
    var today = new Date();
    if (value == "Last 15 Days") {
      setImagingTimeFactor("Last 15 Days")
      setImagingsFromDate(moment().subtract(15, 'days').format('YYYY-MM-DD'))
      setImagingsToDate(today)
    } else if (value == "Last 30 Days") {
      setImagingTimeFactor("Last 30 Days")
      setImagingsFromDate(moment().subtract(30, 'days').format('YYYY-MM-DD'))
      setImagingsToDate(today)
    } else if (value == "Last 45 Days") {
      setImagingTimeFactor("Last 45 Days")
      setImagingsFromDate(moment().subtract(45, 'days').format('YYYY-MM-DD'))
      setImagingsToDate(today)
    } else if (value == "Last 60 Days") {
      setImagingTimeFactor("Last 60 Days")
      setImagingsFromDate(moment().subtract(60, 'days').format('YYYY-MM-DD'))
      setImagingsToDate(today)
    } else if (value == "Last 75 Days") {
      setImagingTimeFactor("Last 75 Days")
      setImagingsFromDate(moment().subtract(75, 'days').format('YYYY-MM-DD'))
      setImagingsToDate(today)
    } else if (value == "Last 90 Days") {
      setImagingTimeFactor("Last 90 Days")
      setImagingsFromDate(moment().subtract(90, 'days').format('YYYY-MM-DD'))
      setImagingsToDate(today)
    }
  }
  const handleImagingChangeStatus = (value) => {
    if (value == "Prescribed") {
      setImagingStatusType("Prescribed")
      setImagingStatusTypeId("1")
    } else if (value == "Registered") {
      setImagingStatusType("Registered")
      setImagingStatusTypeId("2")
    } else if (value == "Sample Collected") {
      setImagingStatusType("Sample Collected")
      setImagingStatusTypeId("3")
    } else if (value == "In Transit") {
      setImagingStatusType("In Transit")
      setImagingStatusTypeId("4")
    } else if (value == "Processing") {
      setImagingStatusType("Processing")
      setImagingStatusTypeId("5")
    } else if (value == "Validation Pending") {
      setImagingStatusType("Validation Pending")
      setImagingStatusTypeId("6")
    } else if (value == "Under Review") {
      setImagingStatusType("Under Review")
      setImagingStatusTypeId("7")
    } else if (value == "Provisional Report Ready") {
      setImagingStatusType("Provisional Report Ready")
      setImagingStatusTypeId("8")
    } else if (value == "Signed Off") {
      setImagingStatusType("Signed Off")
      setImagingStatusTypeId("9")
    } else if (value == "Report Available") {
      setImagingStatusType("Report Available")
      setImagingStatusTypeId("10")
    } else if (value == "Notified") {
      setImagingStatusType("Notified")
      setImagingStatusTypeId("11")
    }
  }

  var fetchImagingsList = async () => {
    showLoader();
    try {
      var result = await GetImagingList({
        "doctorid": getLoginID(),
        'pageno': 1,
        pagesize
      });
      // console.log('resultPromoCode: ', result)  

      if (result?.data) {
        setImagingViewdata(result.data);
        let count = result?.count;
        let pageno = result?.pageno;
        let pagesize = result?.pagesize;
        setTotalItemCount(count)
        let totalPagesCalc = count / pagesize;
        let totalPagesCount = Math.ceil(totalPagesCalc);

        setTotalPages(totalPagesCount);

        setTotalItemCount(count)
        if (result && result.count < itemPerPageCommonValue) {
          setCountTo(result.count)
          setTotalExceedsPageCount(true)
        } else if (count > itemPerPageCommonValue && pageno == 1) {
          setCountTo(itemPerPageCommonValue);
          setTotalExceedsPageCount(false);
        }

      } else {
        setImagingViewdata([])
      }
    } catch (error) {
      console.error("Error in home:", error);
    }
    dismissLoader();
  };

  const getImagingFilteredResults = () => {
    // if(!name && !email && !specialization && (!status || status== '')){
    //       showErrorToast('Please enter the inputs to filter.')
    //       return;
    //     }
    const tableContainer = document.querySelector('.tableContainer');
    if (tableContainer) {
      tableContainer.scrollTop = 0;
    }
    showLoader();
    var input = {
      "doctorid": getLoginID(),
      "searchtext": userNameImaging,
      // "username": userNameImaging,
      'agenumber': imagingAgeGroupTypeId,
      "status": imagingStatusTypeId,
      "startdate": imagingsFromDate,
      "enddate": formatDate_YYYY_MM_DD(imagingsToDate),
      "pageno": pageno,
      pagesize
    };
    var getImagingsList = async () => {
      try {
        var result = await GetImagingList(input);

        if (result?.data) {
          setImagingViewdata(result.data);
          let count = result?.count;
          let pageno = result?.pageno;
          let pagesize = result?.pagesize;
          setTotalItemCount(count)
          let totalPagesCalc = count / pagesize;
          let totalPagesCount = Math.ceil(totalPagesCalc);
          // alert(totalPages)
          setTotalPages(totalPagesCount);
          // setFilteredData(result.data);
          setTotalItemCount(result.count)
          if (result && result.count < itemPerPageCommonValue) {
            setCountTo(result.count)
            setTotalExceedsPageCount(true)
          } else if (count > itemPerPageCommonValue && pageno == 1) {
            setCountTo(itemPerPageCommonValue);
            setTotalExceedsPageCount(false);
          }
        } else {
          setImagingViewdata([])
        }
      } catch (error) {
        console.log(error, "error in getDoctorsList");
      }
      dismissLoader();
    };

    getImagingsList();
  };

  const handleImagingApplyFilters = () => {
    // if(!patientName && !email && !mobile && (!plan || plan== '')){
    //   showErrorToast('Please enter the inputs to filter.')
    //   return;
    // }
    if (!userNameImaging && !imagingAgeGroup && !imagingTimeFactor && !imagingStatusType) {
      showErrorToast('Please enter the inputs to filter.')
      return;
    }
    setCountFrom(1)
    setShowFilterCount(true);
    setPageno(1)
    setCurrentPage(1)
    getImagingFilteredResults();
  };

  const imagingResetFields = () => {
    setUserNameImaging('')
    setImagingAgeGroup('')
    setImagingAgeGroupTypeId('')
    setImagingStatusType('')
    setImagingStatusTypeId('')
    setImagingsFromDate('')
    setImagingsToDate('')
    setImagingTimeFactor('')
    setCurrentPage(1);
    setPageno(1);
    // setPagesize(30);
    //clear states for correct item count
    setPagesize(itemPerPageCommonValue);
    setCountFrom(1)
    setCountTo(itemPerPageCommonValue)
    setCurrentPage(1)
    setShowFilterCount(false);
    fetchImagingsList();

    setRefresh(!refresh);
  };
  // --------------------------- Imaging Functionality end ----------------------------

  // --------------------------- Procedures Functionality start ----------------------------
  var [userNameProcedure, setUserNameProcedure] = useState('');
  var [procedureAgeGroup, setProcedureAgeGroup] = useState('');
  var [procedureAgeGroupTypeId, setProcedureAgeGroupTypeId] = useState('');
  var [procedureStatusType, setProcedureStatusType] = useState('');
  var [procedureStatusTypeId, setProcedureStatusTypeId] = useState('');
  var [procedureTimeFactor, setProcedureTimeFactor] = useState('');
  var [proceduresFromDate, setProceduresFromDate] = useState('');
  var [proceduresToDate, setProceduresToDate] = useState('');

  const handleChangeProcedureName = (event) => {
    let inputValue = event.target.value;
    inputValue = inputValue.replace(/[^A-Za-z\s]/g, '').slice(0, 50);
    event.target.value = inputValue;
    setUserNameProcedure(event.target.value);
  };
  const handleProcedureAgeGroup = (value) => {
    if (value == "1-5") {
      setProcedureAgeGroup("1-5")
      setProcedureAgeGroupTypeId("1")
    } else if (value == "6-10") {
      setProcedureAgeGroup("6-10")
      setProcedureAgeGroupTypeId("2")
    } else if (value == "11-15") {
      setProcedureAgeGroup("11-15")
      setProcedureAgeGroupTypeId("3")

    } else if (value == "16-20") {
      setProcedureAgeGroup("16-20")
      setProcedureAgeGroupTypeId("4")

    } else if (value == "21-25") {
      setProcedureAgeGroup("21-25")
      setProcedureAgeGroupTypeId("5")

    } else if (value == "26-30") {
      setProcedureAgeGroup("26-30")
      setProcedureAgeGroupTypeId("6")

    } else if (value == "31-35") {
      setProcedureAgeGroup("31-35")
      setProcedureAgeGroupTypeId("7")

    } else if (value == "36-40") {
      setProcedureAgeGroup("41-45")
      setProcedureAgeGroupTypeId("8")

    } else if (value == "46+") {
      setProcedureAgeGroup("46+")
      setProcedureAgeGroupTypeId("9")

    }
  }
  const handleProcedureTimeFactor = (value) => {
    var today = new Date();
    if (value == "Last 15 Days") {
      setProcedureTimeFactor("Last 15 Days")
      setProceduresFromDate(moment().subtract(15, 'days').format('YYYY-MM-DD'))
      setProceduresToDate(today)
    } else if (value == "Last 30 Days") {
      setProcedureTimeFactor("Last 30 Days")
      setProceduresFromDate(moment().subtract(30, 'days').format('YYYY-MM-DD'))
      setProceduresToDate(today)
    } else if (value == "Last 45 Days") {
      setProcedureTimeFactor("Last 45 Days")
      setProceduresFromDate(moment().subtract(45, 'days').format('YYYY-MM-DD'))
      setProceduresToDate(today)
    } else if (value == "Last 60 Days") {
      setProcedureTimeFactor("Last 60 Days")
      setProceduresFromDate(moment().subtract(60, 'days').format('YYYY-MM-DD'))
      setProceduresToDate(today)
    } else if (value == "Last 75 Days") {
      setProcedureTimeFactor("Last 75 Days")
      setProceduresFromDate(moment().subtract(75, 'days').format('YYYY-MM-DD'))
      setProceduresToDate(today)
    } else if (value == "Last 90 Days") {
      setProcedureTimeFactor("Last 90 Days")
      setProceduresFromDate(moment().subtract(90, 'days').format('YYYY-MM-DD'))
      setProceduresToDate(today)
    }
  }
  const handleProcedureChangeStatus = (value) => {
    if (value == "Prescribed") {
      setProcedureStatusType("Prescribed")
      setProcedureStatusTypeId("1")
    } else if (value == "Registered") {
      setProcedureStatusType("Registered")
      setProcedureStatusTypeId("2")
    } else if (value == "Sample Collected") {
      setProcedureStatusType("Sample Collected")
      setProcedureStatusTypeId("3")
    } else if (value == "In Transit") {
      setProcedureStatusType("In Transit")
      setProcedureStatusTypeId("4")
    } else if (value == "Processing") {
      setProcedureStatusType("Processing")
      setProcedureStatusTypeId("5")
    } else if (value == "Validation Pending") {
      setProcedureStatusType("Validation Pending")
      setProcedureStatusTypeId("6")
    } else if (value == "Under Review") {
      setProcedureStatusType("Under Review")
      setProcedureStatusTypeId("7")
    } else if (value == "Provisional Report Ready") {
      setProcedureStatusType("Provisional Report Ready")
      setProcedureStatusTypeId("8")
    } else if (value == "Signed Off") {
      setProcedureStatusType("Signed Off")
      setProcedureStatusTypeId("9")
    } else if (value == "Report Available") {
      setProcedureStatusType("Report Available")
      setProcedureStatusTypeId("10")
    } else if (value == "Notified") {
      setProcedureStatusType("Notified")
      setProcedureStatusTypeId("11")
    }
  }

  var fetchProceduresList = async () => {
    showLoader();
    try {
      var result = await GetProceduresList({
        "doctorid": getLoginID(),
        'pageno': 1,
        pagesize
      });
      // console.log('resultPromoCode: ', result)  

      if (result?.data) {
        setProcedureViewdata(result.data);
        setProcedureNotificationData(result.data);
        let count = result?.count;
        let pageno = result?.pageno;
        let pagesize = result?.pagesize;
        setTotalItemCount(count)
        let totalPagesCalc = count / pagesize;
        let totalPagesCount = Math.ceil(totalPagesCalc);

        setTotalPages(totalPagesCount);

        setTotalItemCount(count)
        if (result && result.count < itemPerPageCommonValue) {
          setCountTo(result.count)
          setTotalExceedsPageCount(true)
        } else if (count > itemPerPageCommonValue && pageno == 1) {
          setCountTo(itemPerPageCommonValue);
          setTotalExceedsPageCount(false);
        }

      } else {
        setProcedureViewdata([])
        setProcedureNotificationData([])
      }
    } catch (error) {
      console.error("Error in home:", error);
    }
    dismissLoader();
  };

  const getProcedureFilteredResults = () => {
    // if(!userNameProcedure && !specialization && (!status || status== '')){
    // if(!userNameProcedure && !procedureAgeGroup && !procedureTimeFactor){
    //       showErrorToast('Please enter the inputs to filter.')
    //       return;
    //     }
    const tableContainer = document.querySelector('.tableContainer');
    if (tableContainer) {
      tableContainer.scrollTop = 0;
    }
    showLoader();
    var input = {
      "doctorid": getLoginID(),
      "searchtext": userNameProcedure,
      // "username": userNameProcedure,
      'agenumber': procedureAgeGroupTypeId,
      "status": procedureStatusTypeId,
      "startdate": proceduresFromDate,
      "enddate": formatDate_YYYY_MM_DD(proceduresToDate),
      "pageno": pageno,
      pagesize
    };
    var getProceduresList = async () => {
      try {
        var result = await GetProceduresList(input);

        if (result?.data) {
          setProcedureViewdata(result.data);
          setProcedureNotificationData(result.data);
          let count = result?.count;
          let pageno = result?.pageno;
          let pagesize = result?.pagesize;
          setTotalItemCount(count)
          let totalPagesCalc = count / pagesize;
          let totalPagesCount = Math.ceil(totalPagesCalc);
          // alert(totalPages)
          setTotalPages(totalPagesCount);
          // setFilteredData(result.data);
          setTotalItemCount(result.count)
          if (result && result.count < itemPerPageCommonValue) {
            setCountTo(result.count)
            setTotalExceedsPageCount(true)
          } else if (count > itemPerPageCommonValue && pageno == 1) {
            setCountTo(itemPerPageCommonValue);
            setTotalExceedsPageCount(false);
          }
        } else {
          setProcedureViewdata([])
          setProcedureNotificationData([])
        }
      } catch (error) {
        console.log(error, "error in getDoctorsList");
      }
      dismissLoader();
    };

    getProceduresList();
  };

  const handleProcedureApplyFilters = () => {
    if (!userNameProcedure && !procedureAgeGroup && !procedureTimeFactor && !procedureStatusType) {
      showErrorToast('Please enter the inputs to filter.')
      return;
    }
    setCountFrom(1)
    setShowFilterCount(true);
    setPageno(1)
    setCurrentPage(1)
    getProcedureFilteredResults();
  };

  const procedureResetFields = () => {
    setUserNameProcedure('')
    setProcedureAgeGroup('')
    setProcedureAgeGroupTypeId('')
    setProcedureStatusType('')
    setProcedureStatusTypeId('')
    setProceduresFromDate('')
    setProceduresToDate('')
    setProcedureTimeFactor('')
    setCurrentPage(1);
    setPageno(1);
    // setPagesize(30);
    //clear states for correct item count
    setPagesize(itemPerPageCommonValue);
    setCountFrom(1)
    setCountTo(itemPerPageCommonValue)
    setCurrentPage(1)
    setShowFilterCount(false);
    fetchProceduresList();

    setRefresh(!refresh);
  };
  // --------------------------- Procedures Functionality end ----------------------------

   // --------------------------- Vaccinations Functionality start ----------------------------
  var [userNameVaccine, setUserNameVaccine] = useState('');
  // var [ageGroupType, setAgeGroupType] = useState('');
  // var [ageGroupTypeId, setAgeGroupTypeId] = useState('');
  // var [labStatusType, setLabStatusType] = useState('');
  // var [labStatusTypeId, setLabStatusTypeId] = useState('');
  // var [timeFactor, setTimeFactor] = useState('');
  // var [labsFromDate, setLabsFromDate] = useState('');
  // var [labsToDate, setLabsToDate] = useState('');

  const handleChangeVaccinationName = (event) => {
    let inputValue = event.target.value;
    inputValue = inputValue.replace(/[^A-Za-z\s]/g, '').slice(0, 50);
    event.target.value = inputValue;
    setUserNameVaccine(event.target.value);
  };
  // const handleChangeAgeGroup = (value) => {
  //   if (value == "1-5") {
  //     setAgeGroupType("1-5")
  //     setAgeGroupTypeId("1")
  //   } else if (value == "6-10") {
  //     setAgeGroupType("6-10")
  //     setAgeGroupTypeId("2")
  //   } else if (value == "11-15") {
  //     setAgeGroupType("11-15")
  //     setAgeGroupTypeId("3")
  //   } else if (value == "16-20") {
  //     setAgeGroupType("16-20")
  //     setAgeGroupTypeId("4")
  //   } else if (value == "21-25") {
  //     setAgeGroupType("21-25")
  //     setAgeGroupType("5")
  //   } else if (value == "26-30") {
  //     setAgeGroupType("26-30")
  //     setAgeGroupTypeId("6")
  //   } else if (value == "31-35") {
  //     setAgeGroupType("31-35")
  //     setAgeGroupTypeId("7")
  //   } else if (value == "36-40") {
  //     setAgeGroupType("36-40")
  //     setAgeGroupTypeId("8")
  //   } else if (value == "46+") {
  //     setAgeGroupType("46+")
  //     setAgeGroupTypeId("9")
  //   }
  // }
  // const handleChangeTimeFactor = (value) => {
  //   var today = new Date();
  //   if (value == "Last 15 Days") {
  //     setTimeFactor("Last 15 Days")
  //     setLabsFromDate(moment().subtract(15, 'days').format('YYYY-MM-DD'))
  //     // setLabsToDate(moment().format('YYYY-MM-DD'))
  //     setLabsToDate(today)
  //   } else if (value == "Last 30 Days") {
  //     setTimeFactor("Last 30 Days")
  //     setLabsFromDate(moment().subtract(30, 'days').format('YYYY-MM-DD'))
  //     setLabsToDate(today)
  //   } else if (value == "Last 45 Days") {
  //     setTimeFactor("Last 45 Days")
  //     setLabsFromDate(moment().subtract(45, 'days').format('YYYY-MM-DD'))
  //     setLabsToDate(today)
  //   } else if (value == "Last 60 Days") {
  //     setTimeFactor("Last 60 Days")
  //     setLabsFromDate(moment().subtract(60, 'days').format('YYYY-MM-DD'))
  //     setLabsToDate(today)
  //   } else if (value == "Last 75 Days") {
  //     setTimeFactor("Last 75 Days")
  //     setLabsFromDate(moment().subtract(75, 'days').format('YYYY-MM-DD'))
  //     setLabsToDate(today)
  //   } else if (value == "Last 90 Days") {
  //     setTimeFactor("Last 90 Days")
  //     setLabsFromDate(moment().subtract(90, 'days').format('YYYY-MM-DD'))
  //     setLabsToDate(today)
  //   }
  // }
  // const handleLabChangeStatus = (value) => {
  //   if (value == "Prescribed") {
  //     setLabStatusType("Prescribed")
  //     setLabStatusTypeId("1")
  //   } else if (value == "Registered") {
  //     setLabStatusType("Registered")
  //     setLabStatusTypeId("2")
  //   } else if (value == "Sample Collected") {
  //     setLabStatusType("Sample Collected")
  //     setLabStatusTypeId("3")
  //   } else if (value == "In Transit") {
  //     setLabStatusType("In Transit")
  //     setLabStatusTypeId("4")
  //   } else if (value == "Processing") {
  //     setLabStatusType("Processing")
  //     setLabStatusTypeId("5")
  //   } else if (value == "Validation Pending") {
  //     setLabStatusType("Validation Pending")
  //     setLabStatusTypeId("6")
  //   } else if (value == "Under Review") {
  //     setLabStatusType("Under Review")
  //     setLabStatusTypeId("7")
  //   } else if (value == "Provisional Report Ready") {
  //     setLabStatusType("Provisional Report Ready")
  //     setLabStatusTypeId("8")
  //   } else if (value == "Signed Off") {
  //     setLabStatusType("Signed Off")
  //     setLabStatusTypeId("9")
  //   } else if (value == "Report Available") {
  //     setLabStatusType("Report Available")
  //     setLabStatusTypeId("10")
  //   } else if (value == "Notified") {
  //     setLabStatusType("Notified")
  //     setLabStatusTypeId("11")
  //   }
  // }

  var fetchVaccinationsList = async () => {
    showLoader();
    try {
      var result = await GetOrderVaccinationList({
        "doctorid": getLoginID(),
        'pageno': 1,
        pagesize
      });
      console.log('resultVaccinesData: ', result.data)  

      if (result?.data) {
        setVaccinationsViewData(result.data);
        let count = result?.count;
        let pageno = result?.pageno;
        let pagesize = result?.pagesize;
        setTotalItemCount(count)
        let totalPagesCalc = count / pagesize;
        let totalPagesCount = Math.ceil(totalPagesCalc);

        setTotalPages(totalPagesCount);

        setTotalItemCount(count)
        if (result && result.count < itemPerPageCommonValue) {
          setCountTo(result.count)
          setTotalExceedsPageCount(true)
        } else if (count > itemPerPageCommonValue && pageno == 1) {
          setCountTo(itemPerPageCommonValue);
          setTotalExceedsPageCount(false);
        }

      } else {
        setVaccinationsViewData([])
      }
    } catch (error) {
      console.error("Error in home:", error);
    }
    dismissLoader();
  };

  const getVaccinationsFilteredResults = () => {
    // if(!name && !email && !specialization && (!status || status== '')){
    //       showErrorToast('Please enter the inputs to filter.')
    //       return;
    //     }
    const tableContainer = document.querySelector('.tableContainer');
    if (tableContainer) {
      tableContainer.scrollTop = 0;
    }
    showLoader();
    var input = {
      "doctorid": getLoginID(),
      "searchtext": userNameVaccine,
      // "username": userNameLab,
      // 'agenumber': ageGroupTypeId,
      // "fromdate": formatDate_YYYY_MM_DD(labsFromDate),
      // "startdate": labsFromDate,
      // "status": labStatusTypeId,
      // "enddate": formatDate_YYYY_MM_DD(labsToDate),
      "pageno": pageno,
      pagesize
    };
    var getVaccinationsList = async () => {
      try {
        var result = await GetOrderVaccinationList(input);

        if (result?.data) {
          setVaccinationsViewData(result.data);
          let count = result?.count;
          let pageno = result?.pageno;
          let pagesize = result?.pagesize;
          setTotalItemCount(count)
          let totalPagesCalc = count / pagesize;
          let totalPagesCount = Math.ceil(totalPagesCalc);
          // alert(totalPages)
          setTotalPages(totalPagesCount);
          // setFilteredData(result.data);
          setTotalItemCount(result.count)
          if (result && result.count < itemPerPageCommonValue) {
            setCountTo(result.count)
            setTotalExceedsPageCount(true)
          } else if (count > itemPerPageCommonValue && pageno == 1) {
            setCountTo(itemPerPageCommonValue);
            setTotalExceedsPageCount(false);
          }
        } else {
          setVaccinationsViewData([])
        }
      } catch (error) {
        console.log(error, "error in getDoctorsList");
      }
      dismissLoader();
    };

    getVaccinationsList();
  };

  const handleVaccinationsApplyFilters = () => {
    if (!userNameVaccine) {
      showErrorToast('Please enter the inputs to filter.')
      return;
    }
    setCountFrom(1)
    setShowFilterCount(true);
    setPageno(1)
    setCurrentPage(1)
    getVaccinationsFilteredResults();
  };

  const vaccinationResetFields = () => {
    setUserNameVaccine('')
    // setAgeGroupType('')
    // setAgeGroupTypeId('')
    // setLabStatusType('')
    // setLabStatusTypeId('')
    // setLabsFromDate('')
    // setLabsToDate('')
    // setTimeFactor('')
    setCurrentPage(1);
    setPageno(1);
    // setPagesize(30);
    //clear states for correct item count
    setPagesize(itemPerPageCommonValue);
    setCountFrom(1)
    setCountTo(itemPerPageCommonValue)
    setCurrentPage(1)
    setShowFilterCount(false);
    fetchVaccinationsList();

    setRefresh(!refresh);
  };

  // --------------------------- Vaccinations Functionality end ----------------------------
  const [selectedTemplate, setSelectedTemplate] = useState('')
  const [selectedPatientDetails, setSelectedPatientDetails] = useState(null);

  // const sendNotification = async () => {
  //   // console.log(procedureNotificationData, 'notification data')
  //   // if(title == ""){
  //   //   showErrorToast("Please provide the title")
  //   // }else if(messagetext == ""){
  //   //     showErrorToast("Please provide the notification text")
  //   // }else if(NotificationType == ""){
  //   //     showErrorToast("Please select the type")
  //   // }
  //   // else{
  //   // let input = {
  //   //     "title": title,
  //   //     "message": messagetext, 
  //   //     // "notificationtype":NotificationType,
  //   //     "notificationtype":'push notification',
  //   //     "notificationfor":NotificationType,
  //   //     userdetails: [
  //   //       {
  //   //          fcmtoken: selectedToken,
  //   //          usertype: "patient",
  //   //         userid: selectedId,
  //   //       }
  //   //     ]
  //   // }

  //   const selectedMessage = selectedMessageIndex !== null ? data[selectedMessageIndex] : null;


  //   let notificationInput = procedureNotificationData?.map((item) => ({
  //     'doctorname': item.doctorname ? item.doctorname : '',
  //     'fcmtoken': item.patientfcmtoken ? item.patientfcmtoken : '',
  //     'procedurename': item.ordername ? item.ordername : '',
  //     'patientid': item.patientid ? item.patientid : '',
  //     'doctorid': item.doctorid ? item.doctorid : '',
  //     'patientname': item.patientname ? item.patientname : '',
  //     'type': item.entitytype ? item.entitytype : '',
  //     'aicontent': item.aicontent ? item.aicontent : '',
  //     'notificationcategoryid': 2,
  //     'orderid': item.orderid ? item.orderid : '',
  //     title: "Procedure Alert",
  //     description: selectedTemplate ? selectedTemplate : '',
  //     // title: selectedMessage ? selectedMessage.title : '',
  //     // description: selectedMessage ? selectedMessage.description : '',
  //   })) || [];
  //   // console.log(input);
  //   showLoader();
  //   try {
  //     const result = await saveNotification(notificationInput);

  //     if (result && result.output.result === 'success') {
  //       showSuccessToast('Notification sent successfully');
  //       categorySelection.current.closeModal();
  //       customMessageSelection.current.closeModal();
  //       fetchProceduresList();
  //     }

  //     // if (result != null) {
  //     //     navigate("/notifications")
  //     // }
  //     dismissLoader();
  //   } catch (error) {
  //     console.error("Error in home:", error);
  //     dismissLoader();
  //   }
  // }
  const sendNotification = async () => {
    const selectedMessage = selectedMessageIndex !== null ? data[selectedMessageIndex] : null;
    if(!selectedTemplate) {
      showErrorToast("Please select any Procedure.")
      return;
    }

    let notificationInput = [{
        'doctorname': selectedPatientDetails.doctorname ? selectedPatientDetails.doctorname : '',
        'fcmtoken': selectedPatientDetails.patientfcmtoken ? selectedPatientDetails.patientfcmtoken : '',
        'procedurename': procedureName,
        'patientid': selectedPatientDetails.patientid ? selectedPatientDetails.patientid : '',
        'doctorid': selectedPatientDetails.doctorid ? selectedPatientDetails.doctorid : '',
        'patientname': selectedPatientDetails.patientname ? selectedPatientDetails.patientname : '',
        'type': selectedPatientDetails.entitytype ? selectedPatientDetails.entitytype : '',
        'aicontent': selectedPatientDetails.aicontent ? selectedPatientDetails.aicontent : '',
        'notificationcategoryid': 2,
        'orderid': selectedPatientDetails.orderid ? selectedPatientDetails.orderid : '',
        title: "Procedure Alert",
        description: selectedTemplate ? selectedTemplate : '',
        "branchid": getBranchId(),
      "hospitalid": getHospitalId()
    }];

    showLoader();
    try {
        const result = await saveNotification(notificationInput);

        if (result && result.output.result === 'success') {
            showSuccessToast('Notification sent successfully');
            setCategory(null)
            categorySelection.current.closeModal();
            customMessageSelection.current.closeModal();
            fetchProceduresList();
        }

        dismissLoader();
    } catch (error) {
        console.error("Error in home:", error);
        dismissLoader();
    }
}
  const openNotificationCustomMessage = () => {
    if(!category) {
      showErrorToast('Please Select the category.')
      return;
    }
    setSelectedTemplate(null)
    setSelectedMessageIndex(null)
    // customMessageSelection.current.openModal();
    getProcedureDesc();
  }
  const customMessageSelection = useRef();
  const [selectedMessages, setSelectedMessages] = useState([]);
  const [selectedMessageIndex, setSelectedMessageIndex] = useState(null);

  const handleCheckboxChange = (index, template) => {
    setSelectedTemplate(template)
    setSelectedMessageIndex((prevIndex) => (prevIndex === index ? null : index));
  };
  const data = [
    {
      title: "Procedure Reminder",
      description: "This is a gentle reminder about your upcoming procedure scheduled. Please follow all pre-procedure instructions and arrive on time."
    },
    {
      title: "Procedure Alert",
      description: "Your scheduled procedure  is approaching. Please review your instructions carefully and reach out to us if you need assistance."
    },
    {
      title: "Procedure Recommended",
      description: "Dear patient your doctor has recommended a procedure to support your recovery."
    },

  ];

  // Imagings Logs
  const ModalImagingTableHeader = [
    { key: "datetime", label: "Date & Time" },
    // { key: "notificationtype", label: "Notification Type" },
    { key: "notificationcontent", label: "Notification Content" },
  ]

  const viewImagingLogs = async (orderid) => {
    showLoader();
    try {
      var result = await FetchLogsData({
        "doctorid": getLoginID(),
        'orderid': orderid,
      });
      // console.log('resultPromoCode: ', result)  

      if (result && result.output.result == 'success') {
        setLogsData(result.output);
        showImagingLogs.current.openRight();
      } else {
        setLogsData([])
        showErrorToast("No Logs found")
      }
    } catch (error) {
      console.error("Error in home:", error);
    }
    dismissLoader();
  }

  // Labs Logs
  const ModalLabTableHeader = [
    { key: "datetime", label: "Date & Time" },
    // { key: "notificationtype", label: "Notification Type" },
    { key: "notificationcontent", label: "Notification Content" },
  ]

  const viewLabLogs = async (orderid) => {
    showLoader();
    try {
      var result = await FetchLogsData({
        "doctorid": getLoginID(),
        'orderid': orderid,
      });
      // console.log('resultPromoCode: ', result)  

      if (result && result.output.result == 'success') {
        setLogsData(result.output);
        showLabLogs.current.openRight();
      } else {
        setLogsData([])
        showErrorToast("No Logs found")
      }
    } catch (error) {
      console.error("Error in home:", error);
    }
    dismissLoader();
  }

  // Procedure Logs
  const ModalTableHeader = [
    { key: "datetime", label: "Date & Time" },
    // { key: "notificationtype", label: "Notification Type" },
    { key: "notificationcontent", label: "Notification Content" },
  ]

  const viewLogs = async (orderid) => {
    showLoader();
    try {
      var result = await FetchLogsData({
        "doctorid": getLoginID(),
        'orderid': orderid,
      });
      // console.log('resultPromoCode: ', result)  

      if (result && result.output.data) {
        setLogsData(result.output);
        showProcedureLogs.current.openRight();
      } else {
        setLogsData([])
      }
    } catch (error) {
      console.error("Error in home:", error);
    }
    dismissLoader();
  }

  // -----------------------------------------------------------
  // SEnd Notification Functionality starts
  const categorySelection = useRef();
  const [selectedCategoryIndex, setSelectedCategoryIndex] = useState(null);
  const [category, setCategory] = useState(null);
  const [categoriesList, setCategoriesList] = useState([]);
  const [categoryDescription, setCategoryDescription] = useState([]);
  const [procedureName, setProcedureName] = useState(null);

  const openNotificationCategory = (ordername, patientDetails) => {
    setProcedureName(ordername)
    setCategory(null)
    setSelectedCategoryIndex(null)
    setSelectedPatientDetails(patientDetails);
    getCategories();
    // categorySelection.current.openModal();
  }

  const getCategories = async() => {
    showLoader();
    const input = {
      // 'doctorid': getLoginID()
      "type": 'doctor'
    }
    try {
      const result = await FetchCategories(input);

      if(result && result.categories) {
        setCategoriesList(result.categories)
        categorySelection.current.openModal();
      }else {
        setCategoriesList([])
      }

    } catch(error) {
      console.error("Something went wrong.", error)
    }
    dismissLoader();
  }

  const handleCategoryCheckboxChange = (index) => {
    if(index == 0) {
      setCategory("general")
    } else if(index == 1) {
      setCategory("risk")
    } else if(index == 2) {
      setCategory('nutritional')
    } else if(index == 3) {
      setCategory("medications")
    } else if(index == 4) {
      setCategory("analytics")
    } else if(index == 5) {
      setCategory("conditions")
    }
    setSelectedCategoryIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const getProcedureDesc = async () => {
    const categoryInput = {
      "procedure": procedureName,
      "number": 5,
      "category": category
    };
    showLoader();
    try {
      const result = await getProcedureCategoryData(categoryInput);

      if(result && result.templates) {
        setCategoryDescription(result.templates)
        customMessageSelection.current.openModal();
      } else {
        setCategoryDescription([])
      }
      dismissLoader();
    } catch (error) {
      console.error("Something went wrong", error)
    }
    dismissLoader();
  }

  // -------------------------------------------------------------------
  // Discharge summary notes functionality start

  const doctorDataArray = [
    { doctorName: "Dr. John Doe", createdDate: "2023-10-01" },
    { doctorName: "Dr. Jane Smith", createdDate: "2023-10-05" },
    { doctorName: "Dr. Rachel Davis", createdDate: "2023-10-06" },
    { doctorName: "Dr. Kevin Taylor", createdDate: "2023-10-07" },
    { doctorName: "Dr. Sarah Lee", createdDate: "2023-10-08" },
    { doctorName: "Dr. Brian Hall", createdDate: "2023-10-09" },
    { doctorName: "Dr. Emily Johnson", createdDate: "2023-10-10" },
    { doctorName: "Dr. Michael Brown", createdDate: "2023-10-12" },
    { doctorName: "Dr. Lisa White", createdDate: "2023-10-15" },

  ];
  const [dischargeSummary, setDischargeSummary] = useState([]);
  var [dischargeDoctorName, setDischargeDoctorName] = useState(null);
  var [dischargeFromDate, setDischargeFromDate] = useState(null);
  var [dischargeToDate, setDischargeToDate] = useState(null);
  const [dischargeFromDateMinMax, setDischargeFromDateMinMax] = useState("")
  const [dischargeToDateMinMax, setDischargeToDateMinMax] = useState("")

  const fetchDischargeLogs = async () => {
    showLoader();

    try {
      var result = await DischargeSummaryLogs({
        "doctorid": getLoginID(),
      });
      if (result?.output?.data) {
        setDischargeSummary(result?.output?.data);
        let count = result?.count;
        let pageno = result?.pageno;
        let pagesize = result?.pagesize;
        setTotalItemCount(count)
        let totalPagesCalc = count / pagesize;
        let totalPagesCount = Math.ceil(totalPagesCalc);

        setTotalPages(totalPagesCount);

        setTotalItemCount(count)
        if (result && result.count < itemPerPageCommonValue) {
          setCountTo(result.count)
          setTotalExceedsPageCount(true)
        } else if (count > itemPerPageCommonValue && pageno == 1) {
          setCountTo(itemPerPageCommonValue);
          setTotalExceedsPageCount(false);
        }

      } else {
        setDischargeSummary([])
      }
    } catch (error) {
      console.error("Error in home:", error);
    }
    dismissLoader();
  };

  const getDischargeFilteredResults = () => {

    const tableContainer = document.querySelector('.tableContainer');
    if (tableContainer) {
      tableContainer.scrollTop = 0;
    }
    showLoader();
    var input = {
      "doctorid": getLoginID(),
      "searchtext": dischargeDoctorName,
      "startdate": formatDate_YYYY_MM_DD(dischargeFromDate),
      "enddate": formatDate_YYYY_MM_DD(dischargeToDate),
      "pageno": pageno,
      pagesize
    };
    var fetchDischargeLogs = async () => {
      try {
        var result = await DischargeSummaryLogs(input);

        if (result?.output?.data) {
          setDischargeSummary(result?.output?.data);
          let count = result?.count;
          let pageno = result?.pageno;
          let pagesize = result?.pagesize;
          setTotalItemCount(count)
          let totalPagesCalc = count / pagesize;
          let totalPagesCount = Math.ceil(totalPagesCalc);
          setTotalPages(totalPagesCount);
          setTotalItemCount(result.count)
          if (result && result.count < itemPerPageCommonValue) {
            setCountTo(result.count)
            setTotalExceedsPageCount(true)
          } else if (count > itemPerPageCommonValue && pageno == 1) {
            setCountTo(itemPerPageCommonValue);
            setTotalExceedsPageCount(false);
          }
        } else {
          setDischargeSummary([])
        }
      } catch (error) {
        console.log(error, "error in fetchDischargeLogs");
      }
      dismissLoader();
    };

    fetchDischargeLogs();
  }

  const handleDischargeName = (event) => {
    let inputValue = event.target.value;
    inputValue = inputValue.replace(/[^A-Za-z\s]/g, '').slice(0, 50);
    event.target.value = inputValue;
    setDischargeDoctorName(event.target.value);
  };
  const handleDischargeFromDate = (selectedDate) => {
    const formattedDate = format(selectedDate, "dd-MM-yyyy");
    setDischargeFromDate(formattedDate);

    setDischargeToDateMinMax(selectedDate);
  };
  const handleDischargeToDate = (selectedDate) => {
    const formattedDate = format(selectedDate, "dd-MM-yyyy");
    setDischargeToDate(formattedDate);

    setDischargeFromDateMinMax(selectedDate);
  };

  const handleDischargeApplyFilters = () => {
    // if(!patientName && !email && !mobile && (!plan || plan== '')){
    //   showErrorToast('Please enter the inputs to filter.')
    //   return;
    // }
    if (!dischargeFromDate && !dischargeToDate) {
      showErrorToast('Please enter the inputs to filter.')
      return;
    }
    setCountFrom(1)
    setShowFilterCount(true);
    setPageno(1)
    setCurrentPage(1)
    getDischargeFilteredResults();
  };

  const dischargeResetFields = () => {
    setDischargeFromDate('')
    setDischargeToDate('')
    setDischargeFromDateMinMax(null)
    setDischargeToDateMinMax(null)
    setCurrentPage(1);
    setPageno(1);
    setPagesize(itemPerPageCommonValue);
    setCountFrom(1)
    setCountTo(itemPerPageCommonValue)
    setCurrentPage(1)
    setShowFilterCount(false);
    fetchDischargeLogs();

    setRefresh(!refresh);
  };
  // Discharge summary notes functionality end
  // -------------------------------------------------------------------
  // Discharge Notes data Download 

  const showAiLogData = useRef();
  const [logPreviewData, setLogPreviewData] = useState(null)

  const downloadSummary = (data) => {
    console.log(data, 'downooad data')
    try {
    let content = `<html>
        <head>
          <meta charset='utf-8'>
          <style>
            body { font-family: Arial, sans-serif; line-height: 1.6; text-align: left; }
            h1 { text-align: center; font-size: 20px; font-weight: bold; margin-bottom: 20px; }
            h3 { font-size: 16px; font-weight: bold; }
            p { font-size: 14px; }
          </style>
        </head>
        <body>
          <h1>Patient Discharge Summary Report</h1>`;

    data?.forEach(item => {
      content += `<h3>${item?.header}</h3><p>${item?.text.replace(/\n/g, "<br>")}</p>`;
    });

    content += `</body></html>`;

    const encodedContent = encodeURIComponent(content);
    const a = document.createElement("a");
    a.href = "data:application/msword;charset=utf-8," + encodedContent;
    a.download = "discharge-summary.doc";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    // navigate("/home")
  } catch (error) {
    console.error("Error in downloadSummary:", error);
    showErrorToast("Failed to download the document");
  }
};

// Existing function
const aiLogPreview = (data) => {
  if(data) {
    showAiLogData.current.openRight();
    setLogPreviewData(data)
  }
}

// -----------------------------------------------------------
  // Lab Notification Functionality starts

  const labNotification = useRef();
  const imagingNotification = useRef();
  const procedureNotification = useRef();
  const vaccineNotification = useRef();

  const [labDoctor, setLabDoctor] = useState(null);
  const [labBookingStatus, setLabBookingStatus] = useState(null);
  const [labfcmToken, setLabfcmToken] = useState(null);
  const [labName, setLabName] = useState(null);
  const [labPatientId, setLabPatientId] = useState(null);
  const [labDoctorId, setLabDoctorId] = useState(null);
  const [labPatientName, setLabPatientName] = useState(null);
  const [labType, setLabType] = useState(null);
  const [labAppointmentId, setLabAppointmentId] = useState(null);
  const [labDate, setLabDate] = useState(null);

  const openLabNotificationData = (labDetails) => {
    // console.log('patientdetials: ', patientDetails)
    // const formatedDate = formatDate_Do_MMM_YYYY_Time(patientDetails.followupdate)
    // console.log(formatedDate, 'formaterdDated')

    setLabDoctor(labDetails.doctorname)
    setLabBookingStatus(labDetails.bookingstatus)
    setLabfcmToken(labDetails.patientfcmtoken)
    setLabName(labDetails.ordername)
    setLabPatientId(labDetails.patientid)
    setLabDoctorId(labDetails.doctorid)
    setLabAppointmentId(labDetails.orderid)
    setLabPatientName(labDetails.patientname)
    setLabType(labDetails.entitytype)
    // setFollowupDate(formatedDate)

    // sendLabNotification(labDetails)
    labNotification.current.openModal();
  }

  const sendLabNotification = async () => {
  //   const input = [{
  //   "doctorname": details.doctorname || "",
  //   "fcmtoken": details.patientfcmtoken ? details.patientfcmtoken : "",
  //   "labname": details.ordername || "",
  //   "patientid": details.patientid,
  //   "doctorid": details.doctorid,
  //   "patientname": details.patientname || "",
  //   "type": details.entitytype,
  //   "notificationcategoryid": 7,
  //   "orderid": details.orderid,
  //   "bookingstatus": details.bookingstatus,
  // }];
    const input = [{
      'doctorname': labDoctor,
      'fcmtoken': labfcmToken,
      'labname': labName,
      'patientid': labPatientId,
      'doctorid': labDoctorId,
      'patientname': labPatientName,
      'type': labType,
      'notificationcategoryid': 7,
      'orderid': labAppointmentId,
      'bookingstatus': labBookingStatus,
      "branchid": getBranchId(),
      "hospitalid": getHospitalId()
  }];
    showLoader();
    try {
      const result = await saveLabNotification(input);
      if(result && result.output.result === 'success'){
        showSuccessToast('Notification sent successfully');
        labNotification.current.closeModal();
        fetchLabsList();
      }else {
        showErrorToast("Something Went Wrong!")
      }
      dismissLoader();

    } catch (error) {
      console.error("Error in Sending Lab Notification: ", error)
    }
  }
  // Lab Notification Functionality ends

// -----------------------------------------------------------
  // Imaging Notification Functionality starts

  const [imagingDoctor, setImagingDoctor] = useState(null);
  const [imagingfcmToken, setImagingfcmToken] = useState(null);
  const [imagingName, setImagingName] = useState(null);
  const [imagingPatientId, setImagingPatientId] = useState(null);
  const [imagingDoctorId, setImagingDoctorId] = useState(null);
  const [imagingPatientName, setImagingPatientName] = useState(null);
  const [imagingType, setImagingType] = useState(null);
  const [imagingAppointmentId, setImagingAppointmentId] = useState(null);
  const [imagingBookingStatus, setImagingBookingStatus] = useState(null);

  // const [labDate, setLabDate] = useState(null);

  const openImagingNotificationData = (imagingDetails) => {
    // console.log('patientdetials: ', patientDetails)
    // const formatedDate = formatDate_Do_MMM_YYYY_Time(patientDetails.followupdate)
    // console.log(formatedDate, 'formaterdDated')

    setImagingDoctor(imagingDetails.doctorname)
    setImagingfcmToken(imagingDetails.patientfcmtoken)
    setImagingName(imagingDetails.ordername)
    setImagingPatientId(imagingDetails.patientid)
    setImagingDoctorId(imagingDetails.doctorid)
    setImagingAppointmentId(imagingDetails.orderid)
    setImagingPatientName(imagingDetails.patientname)
    setImagingType(imagingDetails.entitytype)
    setImagingBookingStatus(imagingDetails.bookingstatus)

    // sendImagingNotification(imagingDetails)
    imagingNotification.current.openModal();
  }

  const sendImagingNotification = async () => {
  //   const input = [{
  //     'doctorname': details.doctorname || "",
  //     'fcmtoken': details.patientfcmtoken ? details.patientfcmtoken : "",
  //     'imagingname': details.ordername || "",
  //     'patientid': details.patientid,
  //     'doctorid': details.doctorid,
  //     'patientname': details.patientname || "",
  //     'type': details.entitytype,
  //     'notificationcategoryid': 9,
  //     'orderid': details.orderid,
  //     'bookingstatus': details.bookingstatus
  // }];
    const input = [{
      'doctorname': imagingDoctor,
      'fcmtoken': imagingfcmToken,
      'imagingname': imagingName,
      'patientid': imagingPatientId,
      'doctorid': imagingDoctorId,
      'patientname': imagingPatientName,
      'type': imagingType,
      'notificationcategoryid': 9,
      'orderid': imagingAppointmentId,
      'bookingstatus': imagingBookingStatus,
      "branchid": getBranchId(),
      "hospitalid": getHospitalId()
  }];
    showLoader();
    try {
      const result = await saveImagingNotification(input);
      if(result && result.output.result === 'success'){
        showSuccessToast('Notification sent successfully');
        imagingNotification.current.closeModal();
        fetchImagingsList();
      }else {
        showErrorToast("Something Went Wrong!")
      }
      dismissLoader();

    } catch (error) {
      console.error("Error in Sending Imaging Notification: ", error)
    }
  }
  // Imaging Notification Functionality ends

  // -----------------------------------------------------------
  // Procedure Notification Functionality starts

  const [procedureDoctor, setProcedureDoctor] = useState(null);
  const [procedurefcmToken, setProcedurefcmToken] = useState(null);
  const [procedureNotifyName, setProcedureNotifyName] = useState(null);
  const [procedurePatientId, setProcedurePatientId] = useState(null);
  const [procedureDoctorId, setProcedureDoctorId] = useState(null);
  const [procedurePatientName, setProcedurePatientName] = useState(null);
  const [procedureType, setProcedureType] = useState(null);
  const [procedureAppointmentId, setProcedureAppointmentId] = useState(null);
  const [procedureBookingStatus, setProcedureBookingStatus] = useState(null);

  // const [procedureDate, setLabDate] = useState(null);

  const openProcedureNotificationData = (procedureDetails) => {
    // console.log('patientdetials: ', patientDetails)
    // const formatedDate = formatDate_Do_MMM_YYYY_Time(patientDetails.followupdate)
    // console.log(formatedDate, 'formaterdDated')

    setProcedureDoctor(procedureDetails.doctorname)
    setProcedurefcmToken(procedureDetails.patientfcmtoken)
    setProcedureNotifyName(procedureDetails.ordername)
    setProcedurePatientId(procedureDetails.patientid)
    setProcedureDoctorId(procedureDetails.doctorid)
    setProcedureAppointmentId(procedureDetails.orderid)
    setProcedurePatientName(procedureDetails.patientname)
    setProcedureType(procedureDetails.entitytype)
    setProcedureBookingStatus(procedureDetails.bookingstatus)
    // setFollowupAppointmentDate(procedureDetails.)
    // setFollowupAppointmentTime(procedureDetails.)

    // sendProcedureNotification(procedureDetails)
    procedureNotification.current.openModal();
  }

  const sendProcedureNotification = async () => {
  //   const input = [{
  //   doctorname: details.doctorname || "",
  //   fcmtoken: details.patientfcmtoken ? details.patientfcmtoken : "",
  //   labname: details.ordername || "",
  //   patientid: details.patientid,
  //   doctorid: details.doctorid,
  //   patientname: details.patientname || "",
  //   type: details.entitytype,
  //   notificationcategoryid: 8,
  //   orderid: details.orderid,
  //   bookingstatus: details.bookingstatus,
  // }];
  const input = [{
      'doctorname': procedureDoctor,
      'fcmtoken': procedurefcmToken,
      'procedurename': procedureName,
      'patientid': procedurePatientId,
      'doctorid': procedureDoctorId,
      'patientname': procedurePatientName,
      'type': procedureType,
      'notificationcategoryid': 8,
      'orderid': procedureAppointmentId,
      'bookingstatus': procedureBookingStatus,
      "branchid": getBranchId(),
      "hospitalid": getHospitalId()
  }];
    showLoader();
    try {
      const result = await saveProcedureNotification(input);
      if(result && result.output.result === 'success'){
        showSuccessToast('Notification sent successfully');
        procedureNotification.current.closeModal();
        fetchProceduresList();
      }else {
        showErrorToast("Something Went Wrong!")
      }
      dismissLoader();

    } catch (error) {
      console.error("Error in Sending Procedure Notification: ", error)
    }
  }
  // Procedure Notification Functionality ends

  // -----------------------------------------------------------------------------
  // -----------------------------------------------------------
  // Vaccine Notification Functionality starts
  const [vaccineDoctor, setVaccineDoctor] = useState(null);
  const [vaccineBookingStatus, setVaccineBookingStatus] = useState(null);
  const [vaccinefcmToken, setVaccinefcmToken] = useState(null);
  const [vaccineName, setVaccineName] = useState(null);
  const [vaccinePatientId, setVaccinePatientId] = useState(null);
  const [vaccineDoctorId, setVaccineDoctorId] = useState(null);
  const [vaccinePatientName, setVaccinePatientName] = useState(null);
  const [vaccineType, setVaccineType] = useState(null);
  const [vaccineAppointmentId, setVaccineAppointmentId] = useState(null);
  const [followupVaccineDate, setFollowupVaccineDate] = useState(null);

  const openVaccineNotificationData = (vaccineDetails) => {
    console.log('vaccine    detials: ', vaccineDetails)
    // const formatedDate = formatDate_Do_MMM_YYYY_Time(patientDetails.followupdate)
    // console.log(formatedDate, 'formaterdDated')
    // const formattedNextDoseDate = vaccineDetails.nextdosagedate 
    // ? vaccineDetails.nextdosagedate.split('T')[0] 
    // : null;

    const formattedNextDoseDate = formatDate_DD_MM_YYYY(vaccineDetails.nextdosagedate);

    setVaccineDoctor(vaccineDetails.doctorname)
    setVaccineBookingStatus(vaccineDetails.bookingstatus)
    setVaccinefcmToken(vaccineDetails.patientfcmtoken)
    setVaccineName(vaccineDetails.vaccinename)
    setVaccinePatientId(vaccineDetails.patientid)
    setVaccineDoctorId(vaccineDetails.doctorid)
    setVaccineAppointmentId(vaccineDetails.orderid)
    setVaccinePatientName(vaccineDetails.patientname)
    setVaccineType(vaccineDetails.entitytype)
    setFollowupVaccineDate(formattedNextDoseDate)

    // sendLabNotification(labDetails)
    vaccineNotification.current.openModal();
  }

  const sendVaccineNotification = async () => {
    const getDocId = getLoginID();
    const input = [{
      'doctorname': vaccineDoctor || "",
      'fcmtoken': vaccinefcmToken || "",
      'vaccinename': vaccineName || "",
      'patientid': vaccinePatientId || "",
      'doctorid': vaccineDoctorId || getDocId,
      'patientname': vaccinePatientName || "",
      'type': vaccineType || "",
      'notificationcategoryid': 11,
      'orderid': vaccineAppointmentId || "",
      'bookingstatus': vaccineBookingStatus || 0,
      'duedate': followupVaccineDate || "",
      "branchid": getBranchId(),
      "hospitalid": getHospitalId()
  }];
    showLoader();
    try {
      const result = await saveVaccinationNotification(input);
      if(result && result.output.result === 'success'){
        showSuccessToast('Notification sent successfully');
        vaccineNotification.current.closeModal();
        fetchVaccinationsList();
      }else {
        showErrorToast("Something Went Wrong!")
      }
      dismissLoader();

    } catch (error) {
      console.error("Error in Sending Lab Notification: ", error)
    }
  }
  // Vaccine Notification Functionality ends

// -----------------------------------------------------------
  // Status Changes Start
  const statusmodal = useRef();
  const [appointmentOrderid, setAppointmentOrderid] = useState(null);
  const [appointmentClinicid, setAppointmentClinicid] = useState(null);
  const [appointmentDocumenturl, setAppointmentDocumenturl] = useState(null);
  const [appointmentEntityType, setAppointmentEntityType] = useState(null);
  const [appointmentOrderStatus, setAppointmentOrderStatus] = useState(null);
  const [orderStatusSend, setOrderStatusSend] = useState(null);

  const updateStatus = (status) => {
    // console.log('status: ', status)
  setAppointmentOrderStatus(status.orderstatus)
  setAppointmentDocumenturl(status.documenturl)
  setAppointmentOrderid(status.orderid)
  setAppointmentClinicid(status.orderstatusid)
  setAppointmentEntityType(status.entitytype)

  statusmodal.current.openModal()
 }

 const handlestatusSelect = (selectedOption) => {
    if(selectedOption == "Prescribed"){
      setAppointmentOrderStatus("Prescribed");
      setOrderStatusSend("1");
    }else if(selectedOption == "Registered"){
      setAppointmentOrderStatus("Registered");
      setOrderStatusSend("2");
    }else if(selectedOption == "Sample Collected"){
      setAppointmentOrderStatus("Sample Collected");
      setOrderStatusSend("3");
    }else if(selectedOption == "In Transit"){
      setAppointmentOrderStatus("In Transit");
      setOrderStatusSend("4");
    }else if(selectedOption == "Processing"){
      setAppointmentOrderStatus("Processing");
      setOrderStatusSend("5");
    }else if(selectedOption == "Validation Pending"){
      setAppointmentOrderStatus("Validation Pending");
      setOrderStatusSend("6");
    }else if(selectedOption == "Under Review"){
      setAppointmentOrderStatus("Under Review");
      setOrderStatusSend("7");
    }else if(selectedOption == "Provisional Report Ready"){
      setAppointmentOrderStatus("Provisional Report Ready");
      setOrderStatusSend("8");
    }else if(selectedOption == "Signed Off"){
      setAppointmentOrderStatus("Signed Off");
      setOrderStatusSend("9");
    }else if(selectedOption == "Report Available"){
      setAppointmentOrderStatus("Report Available");
      setOrderStatusSend("10");
    }else if(selectedOption == "Notified"){
      setAppointmentOrderStatus("Notified");
      setOrderStatusSend("11");
    }
    
  };

 const handleStatusChanges = async () => {
    if(!appointmentOrderStatus.trim()){
      showErrorToast("please select any option")
      return;
    }else{
       var inputForGet = { 
          "orderid": appointmentOrderid ? appointmentOrderid : "",
          // "clinicid": appointmentClinicid ? appointmentClinicid : "",
          "orderstatusid": orderStatusSend ? orderStatusSend : "",
          "documenturl": appointmentDocumenturl ? appointmentDocumenturl : null
       };
    showLoader();
      try {
        var result = await documentProcessingStatus(inputForGet);

        if (result && result.output.result == "success") {
            showSuccessToast("Status updated successfully")
            if(appointmentEntityType == "lab"){
              fetchLabsList()
              
            }else if(appointmentEntityType == "imaging"){
              fetchImagingsList()
              
            }else{
              fetchProceduresList()
            }
            statusmodal.current.closeModal();
            }else {
            showErrorToast("Something went wrong!")
          } 

        // if(appointmentEntityType == "lab"){
        //   alert('lab hit')
        //   if (result && result.output.result == "success") {
        //     showSuccessToast("Status updated successfully")
        //     fetchLabsList()
        //     statusmodal.current.closeModal();
        //     }else {
        //     showErrorToast("Something went wrong!")
        //   }    
        // } else if(appointmentEntityType == "imaging") {
        //   alert('imaging hit')
        //   if (result && result.output.result == "success") {
        //     showSuccessToast("Status updated successfully")
        //     fetchImagingsList()
        //     statusmodal.current.closeModal();
        //     }else {
        //     showErrorToast("Something went wrong!")
        //   }
        // } else {
        //   alert('procedure hit')

        //   if (result && result.output.result == "success") {
        //     showSuccessToast("Status updated successfully")
        //     fetchProceduresList()
        //     statusmodal.current.closeModal();
        //     }else {
        //     showErrorToast("Something went wrong!")
        //   }
        // }

      } catch (error) {
        console.log(error, "Something went wrong in doctor profile");
      } finally {
        dismissLoader();
      }
    }
    
  };

  // Status Changes End

  // -----------------------------------------------------------------------------

// Book Appointment starts
const bookAppointmentModal = useRef();
const [orderid, setOrderid] = useState(null)
const [orderEntityType, setOrderEntityType] = useState('')
const [appointmentID, setAppointmentID] = useState(null)
const [patientAppointmentDetails, setPatientAppointmentDetails] = useState(null)
const [appointmentDate, setAppointmentDate] = useState(null)
const [appointmentTime, setAppointmentTime] = useState('')
const [inputAppointmentTime, setInputAppointmentTime] = useState('')

const handleAppointmentDate = (selectedDate) => {
    const formattedDate = format(selectedDate, "dd-MM-yyyy");
   // console.log('formattedDAte: ', formattedDate)
    setAppointmentDate(formattedDate);
  };

  const to12HourFormat = (time24) => {
  const [hourStr, minute] = time24.split(":");
  let hour = parseInt(hourStr, 10);
  const ampm = hour >= 12 ? "PM" : "AM";
  hour = hour % 12 || 12; // Convert 0 to 12 for 12 AM
  return `${hour.toString().padStart(2, '0')}:${minute} ${ampm}`;
};

const timeSlots = [];
for (let hour = 0; hour < 24; hour++) {
  for (let minutes = 0; minutes < 60; minutes += 15) {
    const startHour = hour.toString().padStart(2, '0');
    const startMin = minutes.toString().padStart(2, '0');

    let endHour = hour;
    let endMin = minutes + 15;

    if (endMin === 60) {
      endMin = 0;
      endHour += 1;
    }

    const endHourStr = endHour.toString().padStart(2, '0');
    const endMinStr = endMin.toString().padStart(2, '0');

    const startTime = `${startHour}:${startMin}`;
    const endTime = `${endHourStr}:${endMinStr}`;

    timeSlots.push({
      // label: `${startTime} - ${endTime}`, 
      label: `${to12HourFormat(startTime)} - ${to12HourFormat(endTime)}`,
      value: startTime 
    });

    // timeSlots.push(`${startHour}:${startMin} - ${endHourStr}:${endMinStr}`);
  }
}

const clearBookingStates = () => {
  setAppointmentDate('')
  setAppointmentTime("")
  setInputAppointmentTime("")
  setOrderEntityType("")
  setOrderid(null)
  setAppointmentID(null);
}
const openBookAppointmentModal = (patient) => {
    setPatientAppointmentDetails(patient)

    setOrderEntityType(patient.entitytype)
    setOrderid(patient.orderid)
    setAppointmentID(patient.appointmentid);
    
    bookAppointmentModal.current.openModal();
  };

  const handleTimeSelect = (selectedTime) => {
  // Find the matching time slot
  const selectedSlot = timeSlots.find(slot => slot.label === selectedTime);
  
  if (selectedSlot) {
    setAppointmentTime(selectedTime); // For display (full range)
    setInputAppointmentTime(selectedSlot.value); // For API (start time only)
  }
};

const handleConfirmAppointment = async () => {
  if(!appointmentDate){
    showErrorToast("Please select the date");
    return;
  }
  if(!inputAppointmentTime){
    showErrorToast("Please select time");
    return;
  }
  showLoader();
  try {
      const result = await BookAppointment({
        "orderid": orderid,
        "appointmentdate": formatDate_YYYY_MM_DD(appointmentDate),
        "appointmenttime": inputAppointmentTime,
        "appointmentid": appointmentID,
        "orderstatusid": 2
      });

      if (result?.output?.result == "success") {
        showSuccessToast('Appointment booked successfully')
        if(orderEntityType == 'lab') {
          fetchLabsList()
        }else if(orderEntityType == 'imaging'){
          fetchImagingsList();
        }else{
          fetchProceduresList();
        }
        clearBookingStates();
        bookAppointmentModal.current.closeModal();
      } else {
        showErrorToast("Something went wrong!")
      }
      dismissLoader()
  } catch (error) {
      console.error("Error in home:", error);
    }
};


// Upload documents changes

const [uploadAppointmentId, setUploadAppointmentId] = useState(null)
const GenericUpload = async (e, appointmentId, patientId, orderId) => {
  // console.log(e, "e")
  // console.log(appointmentId, "appointmentId")
  // console.log(patientId, "patientId")
  // console.log(orderId, "orderId")
          e.preventDefault();
          const file = e.target.files[0];
          const allFiles = e.target.files;
          console.log(allFiles , "allFiles from index")
          const fileCount = allFiles.length || 0;
          if(fileCount > 0){
            
         localStorage.setItem("totalDocumentsSelected", fileCount); 
         localStorage.setItem("remainingDocuments", fileCount); 
        }else{
          localStorage.removeItem("remainingDocuments");
         localStorage.removeItem("totalDocumentsSelected"); 
        }
          
          showLoader();
          navigate("/docupload", { state: { file, allFiles, appointmentId, patientId, orderId } });
          dismissLoader();
        };



// const GenericUpload = async (e, appointmentId, patientId, orderId) => {
//   e.preventDefault();
//   const file = e.target.files[0];
//   const allFiles = e.target.files;
  
//   // Store the appointment and order info for later use
//   setUploadAppointmentId(appointmentId);
  
//   if (allFiles.length > 0) {
//     localStorage.setItem("totalDocumentsSelected", allFiles.length); 
//     localStorage.setItem("remainingDocuments", allFiles.length); 
//   } else {
//     localStorage.removeItem("remainingDocuments");
//     localStorage.removeItem("totalDocumentsSelected"); 
//   }
  
//   showLoader();
//   try {
//     // Navigate to upload page and wait for response
//     const uploadResponse = await navigate("/docupload", { 
//       state: { 
//         file, 
//         allFiles, 
//         appointmentId, 
//         patientId,
//         onUploadSuccess: (documentUrl) => {
//           // This callback will be triggered after successful upload
//           setAppointmentDocumenturl(documentUrl);
//           return documentUrl;
//         }
//       } 
//     });
    
//     // If we get the document URL back from upload
//     if (uploadResponse?.documentUrl) {
//       await handleStatusUpdateUpload(orderId, uploadResponse.documentUrl);
//     }
//   } catch (error) {
//     console.error("Upload failed:", error);
//     showErrorToast("Document upload failed");
//   } finally {
//     dismissLoader();
//   }
// };

// const handleStatusUpdateUpload = async (orderId, documentUrl) => {
//   const inputForGet = { 
//     "orderid": orderId,
//     // "clinicid": clinicId,
//     "orderstatusid": 10,
//     "documenturl": documentUrl
//   };
  
//   try {
//     const result = await documentProcessingStatus(inputForGet);
//     if (result?.output?.result === "success") {
//       showSuccessToast("Document uploaded and status updated successfully");
//       fetchLabsList();
//     } else {
//       showErrorToast("Status update failed");
//     }
//   } catch (error) {
//     console.error("Status update error:", error);
//     showErrorToast("Failed to update status");
//   }
// };

// Helper functions for colors
const getStatusBgColor = (statusId) => {
  const colors = {
    1: '#FFEEEE',  // Light red (Prescribed)
    2: '#FFF5E6',  // Light orange
    3: '#FFF5E6',  // Light orange
    4: '#E6F2FF',  // Light blue
    5: '#E6F2FF',  // Light blue
    6: '#E6F2FF',  // Light blue
    7: '#E6F2FF',  // Light blue
    8: '#E6F2FF',  // Light blue
    9: '#E6F5EE',  // Light green
    10: '#E6F5EE', // Light green (Report Available)
    11: '#E6F5EE'  // Light green (Notified)
  };
  return colors[statusId] || '#F5E6E6'; // Default light red
};

const getStatusTextColor = (statusId) => {
  const colors = {
    1: '#FF4D4D',  // Red (Prescribed)
    2: '#D69E2E',  // Orange
    3: '#D69E2E',  // Orange
    4: '#3182CE',  // Blue
    5: '#3182CE',  // Blue
    6: '#3182CE',  // Blue
    7: '#3182CE',  // Blue
    8: '#3182CE',  // Blue
    9: '#14C585',  // Green
    10: '#14C585', // Green (Report Available)
    11: '#14C585'  // Green (Notified)
  };
  return colors[statusId] || '#FF4D4D'; // Default red
};


// Labs Logs
  const ModalVaccineTableHeader = [
    { key: "datetime", label: "Date & Time" },
    // { key: "notificationtype", label: "Notification Type" },
    { key: "notificationcontent", label: "Notification Content" },
  ]

  const viewVaccineLogs = async (orderid) => {
    showLoader();
    try {
      var result = await FetchLogsData({
        "doctorid": getLoginID(),
        'orderid': orderid,
        'type': 'vaccine'
      });
      console.log('vaccine Logs Data: ', result)  

      if (result && result.output.result == 'success') {
        setLogsData(result.output);
        showLabLogs.current.openRight();
      } else {
        setLogsData([])
        showErrorToast("No Logs found")
      }
    } catch (error) {
      console.error("Error in home:", error);
    }
    dismissLoader();
  }

  // ------------------- Generate Report ---------------------------------
  const generateReport = useRef();
  const [ inputId , setInputId ] = useState("");
  const [rowToDelete, setRowToDelete] = useState(null);
  const deleteRowModal = useRef();
  const [ patientInfo , setPatientInfo] = useState([]);
  const [ vaccineReportData , setVaccineReportData] = useState([]);
  const [manualreportname, setManualReportName] = useState(null);  
  
  const [rows, setRows] = useState([]);
    const initialRow = {
    metricname: '',
    unit: '',
    highrange: '',
    lowrange: '',
    formula: '',
  };

  const openGenerateForm = async (item)=>{
  // populateRowsFromLabMetric(item.labmetric);
    // generateReport.current.openRight();
    console.log('item: ', item)
    generateReportAPI(item);
  }
  const generateReportAPI = async (item) => {
  showLoader();
  try {
    // Prepare the input data for the API call
    const input = {
      // "doctorid": getLoginID(),
      "orderid": item.orderid || "", 
      "reportname": item.ordername || "",
      "labrefid": item.labrefid || "", 
      "type": "getlabbyorder", 
      "patientid": item.patientid || "",

      "hospitalname": item.hospital || "",
      
      // "metrics": rows.map(row => ({
      //   "metricname": row.metricname,
      //   "unit": row.unit,
      //   "highrange": row.highrange,
      //   "lowrange": row.lowrange,
      //   "formula": row.formula
      // }))
    };

    const result = await GetLabList(input);

    if (result?.output?.result === "success") {
      // Access the first item from data array
      const reportData = result.output.data?.[0];
      
      setPatientInfo(result.output.patientinfo);
      console.log(result.output.patientinfo, "patient info")
      setVaccineReportData(reportData);
      
      // Handle lab metrics if they exist
      if (reportData?.labmetric) {
        populateRowsFromLabMetric(reportData.labmetric);
      } else {
        setRows([{ ...initialRow }]);
      }
      
      generateReport.current.openRight();
    } else {
      setRows([{ ...initialRow }]);
      showErrorToast("Failed to load report data");
    }
  } catch (error) {
    console.error("Error generating report:", error);
    showErrorToast("Error generating report");
  } finally {
    dismissLoader();
  }
};
  // Function to populate rows when labmetric has data
  const populateRowsFromLabMetric = (labmetric) => {
    if (labmetric && labmetric.length > 0) {
      const newRows = labmetric.map(metric => ({
        metricname: metric.metricname || '',
        unit: metric.unit || '',
        highrange: metric.highrange || '',
        lowrange: metric.lowrange || '',
        formula: metric.formula || '',
      }));
      setRows(newRows);
    } else {
      // If no labmetric data, start with one empty row
      setRows([{ ...initialRow }]);
    }
  };
  const handleMetricNameChange = (name, index) => {
    setInputId(index);
    const newRows = [...rows];
    newRows[index].metricname = name;
    setRows(newRows);
  };
  
  const handleUnitChange = (unit, index) => {
    const newRows = [...rows];
    newRows[index].unit = unit;
    setRows(newRows);
  };
  
  const handleHighRangeChange = (value, index) => {
    const newRows = [...rows];
    newRows[index].highrange = value;
    setRows(newRows);
  };
  
  const handleLowRangeChange = (value, index) => {
    const newRows = [...rows];
    newRows[index].lowrange = value;
    setRows(newRows);
  };
  
  const handleFormulaChange = (value, index) => {
    const newRows = [...rows];
    newRows[index].formula = value;
    setRows(newRows);
  };
  const AddAnotherRowLabTest = () => {
    setRows((prevRows) => [...prevRows, { ...initialRow }]);
    focusInput("LabNameInAdd");
  };
  
  const focusInput = (inputId) => {
    setTimeout(() => {
      const element = document.getElementById(inputId);
      if (element) {
        element.focus();
      }
    }, 100);
  };
  const confirmDeleteRow = (index) => {
    setRowToDelete(index);
    deleteRowModal.current.openModal();
  };
  
  const deleteRowHandler = () => {
    const newRows = rows.filter((_, i) => i !== rowToDelete);
    setRows(newRows);
    deleteRowModal.current.closeModal();
  };  

  const handleSubmitGenerateReport = async () => {
  showLoader();
  const getTemplateDetails = JSON.parse(localStorage.getItem("prescriptionTemplate") || "{}");
  const getHospitalDetails = localStorage.getItem("hospitalname");
  console.log('getTEmplaeteDetails: ', getTemplateDetails)
  console.log('Hospital: ', getHospitalDetails)
  try {
    const inputToSave = {
      input: {
        patient_info: {
          name: patientInfo?.fullname || '',
          age: patientInfo?.age ? `${patientInfo.age} years` : '0 years',
          date_of_report: patientInfo?.date_of_report?.split('T')[0] || new Date().toISOString().split('T')[0],
          doctor_name: patientInfo?.doctor_name || '',
          patientid: patientInfo?.patientid || '',
          documenturl: patientInfo?.documenturl || '', 
          doctorid: patientInfo?.doctorid || '',
        'patientgender': patientInfo?.gender || "",
        },
        report_info: {
          name: vaccineReportData?.type || '',
          type: 'labs', 
          description: vaccineReportData?.testdescription || ''
        },
        test_list: rows.map((row, index) => ({
          test_index: index + 1,
          metricname: row.metricname,
          unit: row.unit,
          highrange: row.highrange,
          lowrange: row.lowrange,
          formula: row.formula
        })),
        appointmentid: patientInfo?.appointmentid || '',
        encounterid: patientInfo?.appointmentid || '',
        patientid: patientInfo?.patientid || '',
        branchid: '',
        hospitalid: '',

        'templateid': getTemplateDetails?.templateId || "",
        'templatevalue': getTemplateDetails?.templateValue || "",
        'hospitalname': getHospitalDetails || "",

      }
    };

    const response = await SubmitLabReport(inputToSave.input);

    if (response?.output?.result === "success") {
      showSuccessToast("Report submitted successfully");
    } else {
      showErrorToast("Failed to submit report");
    }
  } catch (error) {
    console.error("Error submitting report:", error);
    showErrorToast("Error submitting report");
  } finally {
    dismissLoader();
  }
};

// -------------------------------------------------------------------
const [selectedTab, setSelectedTab] = useState("discharge");
const [aiDischargeResponse, setAiDischargeResponse] = useState(null);
const [shareChatSummary, setShareChatSummary] = useState(true);
  const [shareChatHistory, setShareChatHistory] = useState(true);
  const [shareDoctorNotes, setShareDoctorNotes] = useState(true);
  const [sharePatientHistory, setSharePatientHistory] = useState(true);

  const previewModal = useRef(null);


  const handleTabChange = (tab) => {
    setSelectedTab(tab);
  };
//   const aiLogPreview = (data) => {
//       setAiDischargeResponse(data?.aiinput)
//     console.log('data ailogview', data)
//   if(data) {
//     previewModal.current.openModal();
//   }
// }
const aiIPDLogPreview = (data) => {
  console.log('data ailogview', data);
  if (data) {
    setAiDischargeResponse(data?.aiinput || data); // Set the data first
    // Use a timeout to ensure state is updated before opening modal
    setTimeout(() => {
      previewModal.current.openModal();
    }, 200);
  }
};

const [shareReportDoctorEmail, setShareReportDoctorEmail] = useState("");
const [editableSections, setEditableSections] = useState({
  patientInfo: '',
  admissionDetails: '',
  diagnosis: '',
  presentingComplaints: '',
  clinicalFindings: '',
  history: '',
  investigations: '',
  procedures: '',
  hospitalCourse: '',
  dischargeMeds: '',
  instructions: '',
  followUpPlan: ''
});

const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };
useEffect(() => {
  if (aiDischargeResponse) {
    setEditableSections({
      patientInfo: formatPatientInfo(aiDischargeResponse.patient_info),
      admissionDetails: `Admitted: ${aiDischargeResponse.admission_details.admitted_on!= "None" ? aiDischargeResponse.admission_details.admitted_on : ''}\nDischarged: ${aiDischargeResponse.admission_details.discharge_date!="None" ? aiDischargeResponse.admission_details.discharge_date : ""}`,
      // admissionDetails: `Admitted: ${aiDischargeResponse.admission_details.admitted_on}\nDischarged: ${aiDischargeResponse.admission_details.discharge_date}`,
      // diagnosis: aiDischargeResponse.diagnosis.final.join('\n'),
      diagnosis: aiDischargeResponse.diagnosis.final.filter(d => d && d !== 'None').join('\n'),
      presentingComplaints: formatComplaints(aiDischargeResponse.presenting_complaints),
      clinicalFindings: formatClinicalFindings(aiDischargeResponse.clinical_findings),
      history: formatHistory(aiDischargeResponse.history),
      investigations: formatInvestigations(aiDischargeResponse.investigations),
      procedures: formatProcedures(aiDischargeResponse.procedures),
      hospitalCourse: formatHospitalCourse(aiDischargeResponse.hospital_course),
      dischargeMeds: formatMedications(aiDischargeResponse.medications_on_discharge),
      instructions: formatInstructions(aiDischargeResponse.instructions),
      followUpPlan: formatFollowUpPlan(aiDischargeResponse.follow_up_plan)
    });
  }
}, [aiDischargeResponse]);

// const formatPatientInfo = (info) => {
//   return `Name: ${info.name== "None" ? "" : info.name}
// Age: ${info.age== "None" ? "" : info.age}
// Sex: ${info.sex== "None" ? "" : info.sex}
// UHID: ${info.uhid== "None" ? "" : info.uhid}
// Consultant: ${info.consultant== "None" ? "" : info.consultant}`;
// //   return `Name: ${info.name || ''}
// // Age: ${info.age || ''}
// // Sex: ${info.sex || ''}
// // UHID: ${info.uhid || ''}
// // Consultant: ${info.consultant || ''}`;
// };

const parsePatientInfo = (text) => {
  const lines = text.split('\n');
  const info = {
    name: '',
    age: '',
    sex: '',
    uhid: '',
    consultant: ''
  };
  
  lines.forEach(line => {
    if (line.includes('Name:')) info.name = line.replace('Name:', '').trim();
    if (line.includes('Age:')) info.age = line.replace('Age:', '').trim();
    if (line.includes('Sex:')) info.sex = line.replace('Sex:', '').trim();
    if (line.includes('UHID:')) info.uhid = line.replace('UHID:', '').trim();
    if (line.includes('Consultant:')) info.consultant = line.replace('Consultant:', '').trim();
  });
  
  return info;
};

// const formatComplaints = (complaints) => {
//   return complaints.map(c => `${c.description} - ${c.onset}`).join('\n');
// };
// const formatComplaints = (complaints) => {
//   const validComplaints = complaints.filter(c => c.description && c.description !== 'None');
//   return validComplaints.map(c => `${c.description} - ${c.onset || ''}`).join('\n');
// };

const parseComplaints = (text) => {
  return text.split('\n').filter(line => line.trim()).map(line => {
    const parts = line.split('-').map(p => p.trim());
    return {
      description: parts[0] || '',
      onset: parts[1] || ''
    };
  });
};

// const formatClinicalFindings = (findings) => {
//   let text = `General Condition: ${findings.general_condition || ''}\n\nVitals:\n`;
//   findings.vitals.forEach(vital => {
//     text += `- ${vital.name}: ${vital.value} ${vital.unit || ''}\n`;
//   });
//   text += `\nSystemic Exam:\n`;
//   findings.systemic_examination.forEach(exam => {
//     text += `- ${exam.system}: ${exam.finding}\n`;
//   });
//   return text;
// };
// const formatClinicalFindings = (findings) => {
//   let text = `General Condition: ${findings.general_condition== "None" ? '': findings.general_condition}\n\nVitals:\n`;
//   const validVitals = findings.vitals.filter(vital => vital.name && vital.name !== 'None');
//   validVitals.forEach(vital => {
//     text += `- ${vital.name}: ${vital.value || ''} ${vital.unit || ''}\n`;
//   });
//   if (validVitals.length === 0) text += ' \n';
  
//   text += `\nSystemic Exam:\n`;
//   const validExams = findings.systemic_examination.filter(exam => exam.system && exam.system !== 'None');
//   validExams.forEach(exam => {
//     text += `- ${exam.system}: ${exam.finding || ''}\n`;
//   });
//   if (validExams.length === 0) text += ' \n';
  
//   return text;
// };

const parseClinicalFindings = (text) => {
  const lines = text.split('\n');
  const findings = {
    general_condition: '',
    vitals: [],
    systemic_examination: []
  };

  let currentSection = '';
  
  lines.forEach(line => {
    if (line.includes('General Condition:')) {
      findings.general_condition = line.replace('General Condition:', '').trim();
    } else if (line.includes('Vitals:')) {
      currentSection = 'vitals';
    } else if (line.includes('Systemic Exam:')) {
      currentSection = 'systemic';
    } else if (line.startsWith('-') && currentSection === 'vitals') {
      const parts = line.replace('-', '').split(':').map(p => p.trim());
      if (parts.length >= 2) {
        const valueParts = parts[1].split(' ');
        findings.vitals.push({
          name: parts[0],
          value: valueParts[0],
          unit: valueParts.slice(1).join(' ') || ''
        });
      }
    } else if (line.startsWith('-') && currentSection === 'systemic') {
      const parts = line.replace('-', '').split(':').map(p => p.trim());
      if (parts.length >= 2) {
        findings.systemic_examination.push({
          system: parts[0],
          finding: parts[1]
        });
      }
    }
  });

  return findings;
};

// const formatHospitalCourse = (course) => {
//   let text = `Summary: ${course.summary || ''}\n\nInterventions:\n`;
//   course.interventions.forEach(int => {
//     text += `- ${int.name}: ${int.notes}\n`;
//   });
//   return text;
// };
// const formatHospitalCourse = (course) => {
//   // let text = `Summary: ${course.summary || ''}\n\nInterventions:\n`;
//   let text = `Summary: ${course.summary== "None" ? '': course.summary}\n\nInterventions:\n`;
//   const validInterventions = course.interventions.filter(int => int.name && int.name !== 'None');
//   validInterventions.forEach(int => {
//     text += `- ${int.name}: ${int.notes || ''}\n`;
//   });
//   if (validInterventions.length === 0) text += ' \n';
//   return text;
// };

const parseHospitalCourse = (text) => {
  const lines = text.split('\n');
  const course = {
    summary: '',
    interventions: []
  };

  let currentSection = '';
  
  lines.forEach(line => {
    if (line.includes('Summary:')) {
      course.summary = line.replace('Summary:', '').trim();
    } else if (line.includes('Interventions:')) {
      currentSection = 'interventions';
    } else if (line.startsWith('-') && currentSection === 'interventions') {
      const parts = line.replace('-', '').split(':').map(p => p.trim());
      if (parts.length >= 2) {
        course.interventions.push({
          name: parts[0],
          notes: parts[1]
        });
      }
    }
  });

  return course;
};

// const formatMedications = (meds) => {
//   return meds.map(med => 
//     `${med.name} ${med.dose || ''} ${med.frequency} ${med.route}`
//   ).join('\n');
// };
// const formatMedications = (meds) => {
//   const validMeds = meds.filter(med => med.name && med.name !== 'None');
//   return validMeds.map(med => 
//     `${med.name} ${med.dose || ''} ${med.frequency || ''} ${med.route || ''}`
//   ).join('\n');
// };

const parseMedications = (text) => {
  return text.split('\n').filter(line => line.trim()).map(line => {
    const parts = line.split(' ');
    return {
      name: parts[0] || '',
      dose: parts[1] || '',
      frequency: parts.slice(2, -1).join(' ') || '',
      route: parts[parts.length - 1] || ''
    };
  });
};

// const formatInstructions = (instructions) => {
//   let text = 'To Do:\n';
//   instructions.to_do.forEach(item => {
//     text += `- ${item}\n`;
//   });
//   text += '\nNot To Do:\n';
//   instructions.not_to_do.forEach(item => {
//     text += `- ${item}\n`;
//   });
//   return text;
// };
// const formatInstructions = (instructions) => {
//   let text = 'To Do:\n';
//   instructions.to_do.forEach(item => {
//     if (item && item !== 'None') text += `- ${item}\n`;
//   });
//   text += '\nNot To Do:\n';
//   instructions.not_to_do.forEach(item => {
//     if (item && item !== 'None') text += `- ${item}\n`;
//   });
  
//   // If no items in either section, just show headers
//   if (text === 'To Do:\n\nNot To Do:\n') {
//     // return 'To Do:\n- \nNot To Do:\n- ';
//     return 'To Do:\n \nNot To Do:\n ';
//   }
  
//   return text;
// };

const parseInstructions = (text) => {
  const lines = text.split('\n');
  const instructions = {
    to_do: [],
    not_to_do: []
  };

  let currentSection = '';
  
  lines.forEach(line => {
    if (line.includes('To Do:')) {
      currentSection = 'to_do';
    } else if (line.includes('Not To Do:')) {
      currentSection = 'not_to_do';
    } else if (line.startsWith('-')) {
      const item = line.replace('-', '').trim();
      if (currentSection === 'to_do') {
        instructions.to_do.push(item);
      } else if (currentSection === 'not_to_do') {
        instructions.not_to_do.push(item);
      }
    }
  });

  return instructions;
};

// const formatFollowUpPlan = (plan) => {
//   return `Follow up after: ${plan.follow_up_after_days && plan.follow_up_after_days == "None" ? '' : plan.follow_up_after_days + "Days"} 
// Location: ${plan.location== "None" ? '': plan.location}
// Doctor: ${plan.doctor== "None" ? '': plan.doctor}
// Contact: ${plan.contact== "None" ? '': plan.contact}`;
// // Location: ${plan.location || ''}
// // Doctor: ${plan.doctor || ''}
// // Contact: ${plan.contact || ''}`;
// };

const parseFollowUpPlan = (text) => {
  const lines = text.split('\n');
  const plan = {
    follow_up_after_days: '',
    doctor: '',
    location: '',
    contact: ''
  };

  lines.forEach(line => {
    if (line.includes('Follow up after:')) {
      plan.follow_up_after_days = line.replace('Follow up after:', '').replace('days', '').trim();
    } else if (line.includes('Location:')) {
      plan.location = line.replace('Location:', '').trim();
    } else if (line.includes('Doctor:')) {
      plan.doctor = line.replace('Doctor:', '').trim();
    } else if (line.includes('Contact:')) {
      plan.contact = line.replace('Contact:', '').trim();
    }
  });

  return plan;
};


// const formatHistory = (history) => {
//   let text = 'Personal History:\n';
//   history.personal_history.forEach(item => {
//     if (item !== 'None') text += `- ${item}\n`;
//   });
  
//   text += '\nPast Medical History:\n';
//   history.past_medical_history.forEach(item => {
//     if (item !== 'None') text += `- ${item}\n`;
//   });
  
//   text += '\nPast Surgical History:\n';
//   history.past_surgical_history.forEach(item => {
//     if (item !== 'None') text += `- ${item}\n`;
//   });
  
//   text += '\nChronic Medications:\n';
//   history.chronic_medications.forEach(item => {
//     if (item !== 'None') text += `- ${item}\n`;
//   });
  
//   return text;
// };
// const formatHistory = (history) => {
//   let text = 'Personal History:\n';
//   const personalItems = history.personal_history.filter(item => item && item !== 'None');
//   personalItems.forEach(item => {
//     text += `- ${item}\n`;
//   });
//   if (personalItems.length === 0) text += ' \n';
//   // if (personalItems.length === 0) text += '- \n';
  
//   text += '\nPast Medical History:\n';
//   const medicalItems = history.past_medical_history.filter(item => item && item !== 'None');
//   medicalItems.forEach(item => {
//     text += `- ${item}\n`;
//   });
//   if (medicalItems.length === 0) text += ' \n';
//   // if (medicalItems.length === 0) text += '- \n';
  
//   text += '\nPast Surgical History:\n';
//   const surgicalItems = history.past_surgical_history.filter(item => item && item !== 'None');
//   surgicalItems.forEach(item => {
//     text += `- ${item}\n`;
//   });
//   if (surgicalItems.length === 0) text += ' \n';
//   // if (surgicalItems.length === 0) text += '- \n';
  
//   text += '\nChronic Medications:\n';
//   const medItems = history.chronic_medications.filter(item => item && item !== 'None');
//   medItems.forEach(item => {
//     text += `- ${item}\n`;
//   });
//   if (medItems.length === 0) text += ' \n';
//   // if (medItems.length === 0) text += '- \n';
  
//   return text;
// };
const parseHistory = (text) => {
  const lines = text.split('\n');
  const history = {
    personal_history: [],
    past_medical_history: [],
    past_surgical_history: [],
    chronic_medications: []
  };

  let currentSection = '';
  
  lines.forEach(line => {
    if (line.includes('Personal History:')) {
      currentSection = 'personal';
    } else if (line.includes('Past Medical History:')) {
      currentSection = 'medical';
    } else if (line.includes('Past Surgical History:')) {
      currentSection = 'surgical';
    } else if (line.includes('Chronic Medications:')) {
      currentSection = 'meds';
    } else if (line.startsWith('-')) {
      const item = line.replace('-', '').trim();
      if (currentSection === 'personal') {
        history.personal_history.push(item);
      } else if (currentSection === 'medical') {
        history.past_medical_history.push(item);
      } else if (currentSection === 'surgical') {
        history.past_surgical_history.push(item);
      } else if (currentSection === 'meds') {
        history.chronic_medications.push(item);
      }
    }
  });

  return history;
};

// const formatInvestigations = (investigations) => {
//   return investigations.map(inv => 
//     `${inv.name}: ${inv.value} ${inv.unit || ''}`
//   ).join('\n');
// };
// const formatInvestigations = (investigations) => {
//   const validInvestigations = investigations.filter(inv => inv.name && inv.name !== 'None');
//   return validInvestigations.map(inv => 
//     `${inv.name}: ${inv.value || ''} ${inv.unit || ''}`
//   ).join('\n');
// };

const parseInvestigations = (text) => {
  return text.split('\n').filter(line => line.trim()).map(line => {
    const parts = line.split(':').map(p => p.trim());
    if (parts.length >= 2) {
      const valueParts = parts[1].split(' ');
      return {
        name: parts[0],
        value: valueParts[0],
        unit: valueParts.slice(1).join(' ') || ''
      };
    }
    return { name: '', value: '', unit: '' };
  });
};

// const formatProcedures = (procedures) => {
//   return procedures.map(proc => 
//     `${proc.name} - ${proc.date || ''}\n${proc.details || ''}`
//   ).join('\n\n');
// };
// const formatProcedures = (procedures) => {
//   const validProcedures = procedures.filter(proc => proc.name && proc.name !== 'None');
//   return validProcedures.map(proc => 
//     `${proc.name}${proc.date ? ` - ${proc.date}` : ''}${proc.details ? `\n${proc.details}` : ''}`
//   ).join('\n\n');
// };

const parseProcedures = (text) => {
  const procedureBlocks = text.split('\n\n');
  return procedureBlocks.filter(block => block.trim()).map(block => {
    const lines = block.split('\n');
    const firstLineParts = lines[0].split('-').map(p => p.trim());
    return {
      name: firstLineParts[0] || '',
      date: firstLineParts.length > 1 ? firstLineParts[1] : '',
      details: lines.slice(1).join('\n') || ''
    };
  });
};

const [updatedDownloadData, setUpdatedDownloadData] = useState(null);
const [downloadSummaryId, setDownloadSummaryId] = useState(null);
// const [dischargeSummary, setDischargeSummary] = useState(null);
const [docUrl, setDocUrl] = useState("");

// const downloadSummary = async () => {
//   try {
//     // Helper function to format sections
//     const formatSection = (title, content) => {
//       if (!content) return '';
//       return `<h3>${title}</h3><p>${content.replace(/\n/g, "<br>")}</p>`;
//     };

//     // Parse the editable sections back to structured data
//     const parsedData = {
//       patient_info: parsePatientInfo(editableSections.patientInfo),
//       admission_details: {
//         admitted_on: editableSections.admissionDetails.match(/Admitted:\s*(.*)/)?.[1] || "",
//         discharge_date: editableSections.admissionDetails.match(/Discharged:\s*(.*)/)?.[1] || ""
//       },
//       diagnosis: {
//         final: editableSections.diagnosis.split('\n').filter(line => line.trim())
//       },
//       presenting_complaints: parseComplaints(editableSections.presentingComplaints),
//       clinical_findings: parseClinicalFindings(editableSections.clinicalFindings),
//       history: parseHistory(editableSections.history),
//       investigations: parseInvestigations(editableSections.investigations),
//       procedures: parseProcedures(editableSections.procedures),
//       hospital_course: parseHospitalCourse(editableSections.hospitalCourse),
//       medications_on_discharge: parseMedications(editableSections.dischargeMeds),
//       instructions: parseInstructions(editableSections.instructions),
//       follow_up_plan: parseFollowUpPlan(editableSections.followUpPlan)
//     };

//     let content = `<html>
//       <head>
//         <meta charset='utf-8'>
//         <style>
//           body { font-family: Arial, sans-serif; line-height: 1.6; text-align: left; }
//           h1 { text-align: center; font-size: 20px; font-weight: bold; margin-bottom: 20px; }
//           h3 { font-size: 16px; font-weight: bold; margin-top: 15px; }
//           p { font-size: 14px; margin-left: 10px; }
//           .section { margin-bottom: 20px; }
//           table { width: 100%; border-collapse: collapse; margin: 10px 0; }
//           th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
//           th { background-color: #f2f2f2; }
//         </style>
//       </head>
//       <body>
//         <h1>Patient Discharge Summary Report</h1>`;

//     // Patient Information
//     content += formatSection('Patient Information', editableSections.patientInfo);

//     // Admission Details
//     content += formatSection('Admission Details', editableSections.admissionDetails);

//     // Diagnosis
//     content += formatSection('Diagnosis', editableSections.diagnosis);

//     // Presenting Complaints
//     if (parsedData.presenting_complaints?.length > 0) {
//       const complaints = parsedData.presenting_complaints.map(c => 
//         `${c.description} (onset: ${c.onset})`).join('<br>');
//       content += formatSection('Presenting Complaints', complaints);
//     }

//     // Clinical Findings
//     if (parsedData.clinical_findings) {
//       let findings = `General Condition: ${parsedData.clinical_findings.general_condition}<br><br>`;
      
//       findings += '<strong>Vitals:</strong><br>';
//       findings += parsedData.clinical_findings.vitals.map(v => 
//         `${v.name}: ${v.value} ${v.unit || ''}`).join('<br>');
      
//       if (parsedData.clinical_findings.systemic_examination?.length > 0) {
//         findings += '<br><br><strong>Systemic Examination:</strong><br>';
//         findings += parsedData.clinical_findings.systemic_examination.map(e => 
//           `${e.system}: ${e.finding}`).join('<br>');
//       }
      
//       content += formatSection('Clinical Findings', findings);
//     }

//     // History
//     if (parsedData.history) {
//       let historyText = '';
//       if (parsedData.history.personal_history?.length > 0) {
//         historyText += '<strong>Personal History:</strong><br>';
//         historyText += parsedData.history.personal_history
//           .filter(h => h !== 'None')
//           .join('<br>') + '<br><br>';
//       }
      
//       if (parsedData.history.past_medical_history?.length > 0) {
//         historyText += '<strong>Past Medical History:</strong><br>';
//         historyText += parsedData.history.past_medical_history
//           .filter(h => h !== 'None')
//           .join('<br>') + '<br><br>';
//       }
      
//       if (parsedData.history.past_surgical_history?.length > 0) {
//         historyText += '<strong>Past Surgical History:</strong><br>';
//         historyText += parsedData.history.past_surgical_history
//           .filter(h => h !== 'None')
//           .join('<br>') + '<br><br>';
//       }
      
//       if (parsedData.history.chronic_medications?.length > 0) {
//         historyText += '<strong>Chronic Medications:</strong><br>';
//         historyText += parsedData.history.chronic_medications
//           .filter(h => h !== 'None')
//           .join('<br>');
//       }
      
//       content += formatSection('History', historyText);
//     }

//     // Investigations
//     if (parsedData.investigations?.length > 0) {
//       const investigations = parsedData.investigations.map(i => 
//         `${i.name}: ${i.value} ${i.unit || ''}`).join('<br>');
//       content += formatSection('Investigations', investigations);
//     }

//     // Procedures
//     if (parsedData.procedures?.length > 0) {
//       const procedures = parsedData.procedures.map(p => 
//         `${p.name}${p.date ? ` (${p.date})` : ''}${p.details ? `<br>${p.details}` : ''}`)
//         .join('<br><br>');
//       content += formatSection('Procedures', procedures);
//     }

//     // Hospital Course
//     if (parsedData.hospital_course) {
//       let courseText = parsedData.hospital_course.summary;
//       if (parsedData.hospital_course.interventions?.length > 0) {
//         courseText += '<br><br><strong>Interventions:</strong><br>';
//         courseText += parsedData.hospital_course.interventions.map(i => 
//           `${i.name}: ${i.notes}`).join('<br>');
//       }
//       content += formatSection('Hospital Course', courseText);
//     }

//     // Discharge Medications
//     if (parsedData.medications_on_discharge?.length > 0) {
//       const medsTable = `
//         <table>
//           <thead>
//             <tr>
//               <th>Medication</th>
//               <th>Dose</th>
//               <th>Frequency</th>
//               <th>Route</th>
//             </tr>
//           </thead>
//           <tbody>
//             ${parsedData.medications_on_discharge.map(med => `
//               <tr>
//                 <td>${med.name}</td>
//                 <td>${med.dose || 'N/A'}</td>
//                 <td>${med.frequency}</td>
//                 <td>${med.route}</td>
//               </tr>
//             `).join('')}
//           </tbody>
//         </table>`;
//       content += `<div class="section"><h3>Discharge Medications</h3>${medsTable}</div>`;
//     }

//     // Instructions
//     if (parsedData.instructions) {
//       let instructionsText = '';
//       if (parsedData.instructions.to_do?.length > 0) {
//         instructionsText += '<strong>To Do:</strong><br>';
//         instructionsText += parsedData.instructions.to_do.join('<br>') + '<br><br>';
//       }
//       if (parsedData.instructions.not_to_do?.length > 0) {
//         instructionsText += '<strong>Not To Do:</strong><br>';
//         instructionsText += parsedData.instructions.not_to_do.join('<br>');
//       }
//       content += formatSection('Instructions', instructionsText);
//     }

//     // Follow Up Plan
//     if (parsedData.follow_up_plan) {
//       const followUp = `
//         Follow up after: ${parsedData.follow_up_plan.follow_up_after_days || 'N/A'} days<br>
//         Location: ${parsedData.follow_up_plan.location || 'N/A'}<br>
//         Doctor: ${parsedData.follow_up_plan.doctor || 'N/A'}<br>
//         Contact: ${parsedData.follow_up_plan.contact || 'N/A'}`;
//       content += formatSection('Follow Up Plan', followUp);
//     }

//     content += `</body></html>`;

//     // Create and trigger download
//     const encodedContent = encodeURIComponent(content);
//     const a = document.createElement("a");
//     a.href = "data:application/msword;charset=utf-8," + encodedContent;
//     a.download = "discharge-summary.doc";
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//     // if(isIPDDischarge) {
//       navigate('/ipdpatients')
//     // } else {
//     //   navigate('/home');
//     // }
//     const getDischargeSetting = localStorage.getItem('saveDischarge');
//     if(getDischargeSetting == 1) {
//       try {
//         showLoader();
        
//         // First upload the document
//         const blob = new Blob([content], { type: 'application/msword' });
//         const file = new File([blob], 'discharge-summary.doc', { type: 'application/msword' });
        
//         const uploadResponse = await uploadImageCommonFunction(file, 'discharge-summary.doc');
        
//         if (!uploadResponse || !uploadResponse.name) {
//           throw new Error("Failed to upload document");
//         }
        
//         const documenturl = uploadResponse.name;
//         setDocUrl(documenturl);

//         // Then make the API call to save the summary
//         const input = {
//           'id': downloadSummaryId,
//           'downloadedpdf': documenturl,
//           'type': 'update',
//         };

//         const result = await SaveSummaryCallLog(input);
        
//         if (result && result.output && result.output.result === 'Success') {
//           showSuccessToast("Document downloaded and saved successfully");
//         } else {
//           throw new Error(result?.output?.message || "Failed to save summary");
//         }
//       } catch (error) {
//         console.error("API Error:", error);
//         showErrorToast(error.message || "Failed to complete download process");
//       } finally {
//         dismissLoader();
//       }
//     }

//   } catch (error) {
//     console.error("Error in downloadSummary:", error);
//     showErrorToast("Failed to download the document");
//   }
// };

const audioPlayerRef = useRef(null);
const [audioDuration, setAudioDuration] = useState(0);
const [audioCurrentTime, setAudioCurrentTime] = useState(0);

const handleAudioLoadedMetadata = (e) => {
  setAudioDuration(e.target.duration);
};

const handleAudioTimeUpdate = (e) => {
  setAudioCurrentTime(e.target.currentTime);
};

const handleAudioEnded = () => {
  setAudioCurrentTime(audioDuration);
};

const formatAudioTime = (time) => {
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
};

// ---------------------------------------------new formatting functions --------------------------

  // Format Patient Information
const formatPatientInfo = (patientInfo) => {
  if (!patientInfo) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  return `Name: ${formatValue(patientInfo.name)}
Age: ${formatValue(patientInfo.age)}
Sex: ${formatValue(patientInfo.sex)}
Mobile: ${formatValue(patientInfo.phone)}
UHID: ${formatValue(patientInfo.uhid)}
Mrn: ${formatValue(patientInfo.mrn)}
Registration No: ${formatValue(patientInfo.registration_no)}
Panel: ${formatValue(patientInfo.panel_name)}
Consultant: ${formatValue(patientInfo.consultant)}`;
};

// Format Admission Details
const formatAdmissionDetails = (admissionDetails) => {
  if (!admissionDetails) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  return `Admitted On: ${formatValue(admissionDetails.admitted_on)}
Discharge Date: ${formatValue(admissionDetails.discharge_date)}`;
};

// Format Diagnosis
const formatDiagnosis = (diagnosis) => {
  if (!diagnosis) return "";
  let result = "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  if (diagnosis.provisional && diagnosis.provisional !== "None") {
    result += `Provisional Diagnosis: ${formatValue(diagnosis.provisional)}\n`;
  }
  if (diagnosis.final && diagnosis.final.length > 0) {
    const validDiagnosis = diagnosis.final.filter(dx => dx !== "None");
    if (validDiagnosis.length > 0) {
      result += "Final Diagnosis:\n";
      validDiagnosis.forEach((dx, index) => {
        result += `${index + 1}. ${dx}\n`;
      });
    }
  }
  return result || "";
};

// Format Presenting Complaints
const formatComplaints = (complaints) => {
  if (!complaints || !Array.isArray(complaints)) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  const validComplaints = complaints.filter(complaint => 
    complaint.description !== "None" || complaint.onset !== "None"
  );
  
  if (validComplaints.length === 0) return "";
  
  return validComplaints.map(complaint => 
    `${formatValue(complaint.description)}${complaint.onset !== "None" ? ` - Onset: ${formatValue(complaint.onset)}` : ''}`
  ).filter(line => line.trim() !== '').join('\n');
};

// Format Clinical Findings
const formatClinicalFindings = (clinicalFindings) => {
  if (!clinicalFindings) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  let result = "";
  
  // General Condition
  if (clinicalFindings.general_condition && clinicalFindings.general_condition !== "None") {
    result += `General Condition: ${formatValue(clinicalFindings.general_condition)}\n\n`;
  }
  
  // Admission Vitals - filter out "None" values
  if (clinicalFindings.admission_vitals && clinicalFindings.admission_vitals.length > 0) {
    const validVitals = clinicalFindings.admission_vitals.filter(vital => 
      vital.value !== "None" && vital.name !== "None"
    );
    if (validVitals.length > 0) {
      result += "Admission Vitals:\n";
      validVitals.forEach(vital => {
        result += `- ${formatValue(vital.name)}: ${formatValue(vital.value)} ${formatValue(vital.unit)}\n`;
      });
      result += "\n";
    }
  }
  
  // Discharge Vitals - filter out "None" values
  if (clinicalFindings.discharge_vitals && clinicalFindings.discharge_vitals.length > 0) {
    const validVitals = clinicalFindings.discharge_vitals.filter(vital => 
      vital.value !== "None" && vital.name !== "None"
    );
    if (validVitals.length > 0) {
      result += "Discharge Vitals:\n";
      validVitals.forEach(vital => {
        result += `- ${formatValue(vital.name)}: ${formatValue(vital.value)} ${formatValue(vital.unit)}\n`;
      });
      result += "\n";
    }
  }
  
  // Systemic Examination - filter out "None" values
  if (clinicalFindings.systemic_examination && clinicalFindings.systemic_examination.length > 0) {
    const validExams = clinicalFindings.systemic_examination.filter(exam => 
      exam.finding !== "None" && exam.system !== "None"
    );
    if (validExams.length > 0) {
      result += "Systemic Examination:\n";
      validExams.forEach(exam => {
        result += `- ${formatValue(exam.system)}: ${formatValue(exam.finding)}\n`;
      });
    }
  }
  
  return result.trim();
};

// Format History
const formatHistory = (history) => {
  if (!history) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  let result = "";
  
  // Personal History
  if (history.personal_history && history.personal_history.length > 0) {
    const validHistory = history.personal_history.filter(item => item !== "None");
    if (validHistory.length > 0) {
      result += "Personal History:\n";
      validHistory.forEach(item => {
        result += `- ${item}\n`;
      });
      result += "\n";
    }
  }
  
  // Past Medical History
  if (history.past_medical_history && history.past_medical_history.length > 0) {
    const validHistory = history.past_medical_history.filter(item => item !== "None");
    if (validHistory.length > 0) {
      result += "Past Medical History:\n";
      validHistory.forEach(item => {
        result += `- ${item}\n`;
      });
      result += "\n";
    }
  }
  
  // Past Surgical History
  if (history.past_surgical_history && history.past_surgical_history.length > 0) {
    const validHistory = history.past_surgical_history.filter(item => item !== "None");
    if (validHistory.length > 0) {
      result += "Past Surgical History:\n";
      validHistory.forEach(item => {
        result += `- ${item}\n`;
      });
      result += "\n";
    }
  }
  
  // Chronic Medications
  if (history.chronic_medications && history.chronic_medications.length > 0) {
    const validMeds = history.chronic_medications.filter(med => med !== "None");
    if (validMeds.length > 0) {
      result += "Chronic Medications:\n";
      validMeds.forEach(med => {
        result += `- ${med}\n`;
      });
    }
  }
  
  return result.trim();
};

// Format Investigations
const formatInvestigations = (investigations) => {
  if (!investigations || !Array.isArray(investigations)) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  const validInvestigations = investigations.filter(inv => 
    inv.value !== "None" && inv.name !== "None"
  );
  
  if (validInvestigations.length === 0) return "";
  
  return validInvestigations.map(inv => 
    `${formatValue(inv.name)}: ${formatValue(inv.value)} ${formatValue(inv.unit)}`
  ).join('\n');
};

// Format Procedures
const formatProcedures = (procedures) => {
  if (!procedures || !Array.isArray(procedures)) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  const validProcedures = procedures.filter(proc => 
    proc.name !== "None" && proc.name !== ""
  );
  
  if (validProcedures.length === 0) return "";
  
  return validProcedures.map(proc => 
    `${formatValue(proc.name)}${proc.date && proc.date !== "None" ? ` - ${formatValue(proc.date)}` : ''}${proc.details && proc.details !== "None" ? `\n${formatValue(proc.details)}` : ''}`
  ).filter(line => line.trim() !== '').join('\n\n');
};

// Format Hospital Course
const formatHospitalCourse = (hospitalCourse) => {
  if (!hospitalCourse) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  let result = "";
  
  // Summary
  if (hospitalCourse.summary && hospitalCourse.summary !== "None") {
    result += `Summary: ${formatValue(hospitalCourse.summary)}\n\n`;
  }
  
  // Interventions
  if (hospitalCourse.interventions && hospitalCourse.interventions.length > 0) {
    const validInterventions = hospitalCourse.interventions.filter(intervention => 
      intervention.name !== "None" && intervention.notes !== "None"
    );
    if (validInterventions.length > 0) {
      result += "Interventions:\n";
      validInterventions.forEach(intervention => {
        result += `- ${formatValue(intervention.name)}: ${formatValue(intervention.notes)}\n`;
      });
    }
  }
  
  return result.trim();
};

// Format Medications
const formatMedications = (medications) => {
  if (!medications || !Array.isArray(medications)) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  const validMedications = medications.filter(med => 
    med.name !== "None" && med.name !== ""
  );
  
  if (validMedications.length === 0) return "";
  
  return validMedications.map(med => {
    const parts = [
      formatValue(med.name),
      formatValue(med.dose),
      formatValue(med.frequency),
      formatValue(med.route),
      med.duration && med.duration !== "None" ? `for ${formatValue(med.duration)}` : "",
      med.timing && med.timing !== "None" ? `(${formatValue(med.timing)})` : ""
    ].filter(part => part !== "").join(' ');
    
    return parts.trim();
  }).filter(line => line.trim() !== '').join('\n');
};

// Format Instructions
const formatInstructions = (instructions) => {
  if (!instructions) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  let result = "";
  
  // To Do
  if (instructions.to_do && instructions.to_do.length > 0) {
    const validToDo = instructions.to_do.filter(item => item !== "None");
    if (validToDo.length > 0) {
      result += "To Do:\n";
      validToDo.forEach(item => {
        result += `- ${item}\n`;
      });
      result += "\n";
    }
  }
  
  // Not To Do
  if (instructions.not_to_do && instructions.not_to_do.length > 0) {
    const validNotToDo = instructions.not_to_do.filter(item => item !== "None");
    if (validNotToDo.length > 0) {
      result += "Not To Do:\n";
      validNotToDo.forEach(item => {
        result += `- ${item}\n`;
      });
    }
  }
  
  return result.trim();
};

// Format Follow Up Plan
const formatFollowUpPlan = (followUpPlan) => {
  if (!followUpPlan) return "";
  
  const formatValue = (value) => value === "None" ? "" : value || "";
  
  const parts = [
    followUpPlan.follow_up_after_days && followUpPlan.follow_up_after_days !== "None" ? `Follow up after: ${formatValue(followUpPlan.follow_up_after_days)} days` : "",
    followUpPlan.doctor && followUpPlan.doctor !== "None" ? `Doctor: ${formatValue(followUpPlan.doctor)}` : "",
    followUpPlan.location && followUpPlan.location !== "None" ? `Location: ${formatValue(followUpPlan.location)}` : "",
    followUpPlan.contact && followUpPlan.contact !== "None" ? `Contact: ${formatValue(followUpPlan.contact)}` : "",
    followUpPlan.emergency_contacts && followUpPlan.emergency_contacts.length > 0 && followUpPlan.emergency_contacts.some(contact => contact !== "None") 
      ? `Emergency Contacts: ${followUpPlan.emergency_contacts.filter(contact => contact !== "None").join(', ')}` 
      : ""
  ].filter(part => part !== "").join('\n');
  
  return parts.trim();
};


// Add this helper function to format admission dates
const formatAdmissionDate = (dateString) => {
  if (!dateString) return "N/A";
  
  try {
    // Extract date part from strings like "8th Oct, 2025 at 6:59 p.m."
    const match = dateString.match(/(\d+(?:st|nd|rd|th)?\s+(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]*,?\s+\d{4})/i);
    if (match) {
      return match[1].replace(/(\d+)(st|nd|rd|th)/, '$1'); // Remove ordinal suffixes
    }
    
    // Fallback: try to parse as Date
    const date = new Date(dateString);
    if (!isNaN(date.getTime())) {
      return moment(date).format("DD MMM YY");
    }
    
    return "N/A";
  } catch (error) {
    console.error("Error formatting date:", error);
    return "N/A";
  }
};

// Helper function to format values - show empty string instead of hiding
const formatValue = (value) => {
  if (value === "None" || value === "N/A" || value === null || value === undefined) {
    return "";
  }
  return String(value).trim();
};

// Helper function to format key names
const formatAttributeKey = (key) => {
  return key.split('_').map(word => 
    word.charAt(0).toUpperCase() + word.slice(1)
  ).join(' ');
};

  return (
    <>
      <Global
        styles={css`
          .activeTab .whiteBorder::after {
            content: "";
            position: absolute;
            left: 0%;
            transform: translateX(-20%);
            transform: translateY(440%);
            border-radius: 5px 5px 0 0;
            top: 120%;
            background: #0b1f4f;
            height: 3px;
            width: 100%;
            z-index: 1;
          }

          .pendingVisits .swiper-container {
            height: 100%;
            max-height: 100vw;
            min-height: 0;
            min-width: 0;
            max-width: 100vw;
            width: 100%;
            overflow: hidden;
          }

          .pendingVisits .swiper-slide {
            width: 285px !important;
            flex-shrink: 0;
            display: block;
            height: 100%;
            max-height: 100%;
          }

          .pendingVisits .swiper {
            margin: 0 !important;
          }

          .pendingVisits .swiper-wrapper {
            max-height: 100%;
            height: 100%t;
            display: flex;
            gap: 20px;
            padding: 0 1rem;
          }
        `}
      />
      <Box w="100%">
        {isLoading && <Loader />}
        {screenType == "web" ? (
          <Flex>
            <Box w="6rem">
              <MiniSideBar />
            </Box>
            <Box w="calc(100vw - 6.5rem)">
              <SecondaryNav customHeader="Orders" />

              {/* Main container start */}
              <Flex w="100%">
                <Box w="100%">
                  {/* Tab buttons start */}
                  <Box
                    display="flex"
                    gap="1rem"
                    borderBottom="1px solid #E6E7E9"
                    bg="white"
                    p="1.25rem 1.5rem"
                  >
                    <Box
                      as="button"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      pos="relative"
                      className={activeTab == "prescriptions" ? "activeTab" : ""}
                      fontSize="0.87rem"
                      fontWeight="600"
                      onClick={() => tabChanged("prescriptions")}
                      color={activeTab == "prescriptions" ? "#061027" : "#898D97"}
                    >
                      <Text>Prescriptions</Text>
                      <Box as="span" className="whiteBorder" />
                    </Box>
                    <Box
                      as="button"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      pos="relative"
                      className={activeTab == "followups" ? "activeTab" : ""}
                      fontSize="0.87rem"
                      fontWeight="600"
                      onClick={() => tabChanged("followups")}
                      color={activeTab == "followups" ? "#061027" : "#898D97"}
                    >
                      <Text>Followups</Text>
                      <Box as="span" className="whiteBorder" />
                    </Box>
                    {/* <Box
                    as="button"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    pos="relative"
                    className={activeTab == "payments" ? "activeTab" : ""}
                    fontSize="0.87rem"
                    fontWeight="600"
                    onClick={() => tabChanged("payments")}
                    color={activeTab == "payments" ? "#061027" : "#898D97"}
                  >
                    <Text>Payments</Text>
                    <Box as="span" className="whiteBorder" />
                  </Box> */}
                    <Box
                      as="button"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      pos="relative"
                      className={activeTab == "labs" ? "activeTab" : ""}
                      fontSize="0.87rem"
                      fontWeight="600"
                      onClick={() => tabChanged("labs")}
                      color={activeTab == "labs" ? "#061027" : "#898D97"}
                    >
                      <Text>Labs</Text>
                      <Box as="span" className="whiteBorder" />
                    </Box>
                    <Box
                      as="button"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      pos="relative"
                      className={activeTab == "imaging" ? "activeTab" : ""}
                      fontSize="0.87rem"
                      fontWeight="600"
                      onClick={() => tabChanged("imaging")}
                      color={activeTab == "imaging" ? "#061027" : "#898D97"}
                    >
                      <Text>Imaging</Text>
                      <Box as="span" className="whiteBorder" />
                    </Box>
                    <Box
                      as="button"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      pos="relative"
                      className={activeTab == "procedures" ? "activeTab" : ""}
                      fontSize="0.87rem"
                      fontWeight="600"
                      onClick={() => tabChanged("procedures")}
                      color={activeTab == "procedures" ? "#061027" : "#898D97"}
                    >
                      <Text>Procedures</Text>
                      <Box as="span" className="whiteBorder" />
                    </Box>
                    <Box
                      as="button"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      pos="relative"
                      className={activeTab == "vaccinations" ? "activeTab" : ""}
                      fontSize="0.87rem"
                      fontWeight="600"
                      onClick={() => tabChanged("vaccinations")}
                      color={activeTab == "vaccinations" ? "#061027" : "#898D97"}
                    >
                      <Text>Vaccinations</Text>
                      <Box as="span" className="whiteBorder" />
                    </Box>
                    <Box
                      as="button"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      pos="relative"
                      className={activeTab == "discharge" ? "activeTab" : ""}
                      fontSize="0.87rem"
                      fontWeight="600"
                      onClick={() => tabChanged("discharge")}
                      color={activeTab == "discharge" ? "#061027" : "#898D97"}
                    >
                      <Text>Discharge Summary Logs</Text>
                      <Box as="span" className="whiteBorder" />
                    </Box>
                  </Box>
                  {/* Tab buttons end */}

                  {/* Prescriptions tab */}
                  {activeTab == "prescriptions" && (
                    <>
                      <Box gap='10px' p='2rem' w='calc(100vw - 6.5rem)' borderBottom="1px solid #E6E7E9" display='flex' flexDirection='row' justifyContent='center' alignItems='center'>
                        <PrimaryInput
                          variant="fullRound"
                          title="Name"
                          inputPlace="Name"
                          id="yourName"
                          onKeyDown={handleKeyDown}
                          onChange={handleChangePrescriptionName}
                          inputValue={dischargeDoctorName}
                        />
                        <PrimaryInput
                          variant="fullRound"
                          title="Email"
                          inputPlace="Email"
                          id="yourEmail"
                          onKeyDown={handleKeyDown}
                          onChange={handleChangePrescriptionEmail}
                          inputValue={prescriptionEmail}
                        />
                        <Box w='800px'>
                          <DatePicker
                            // defaultDate={procedureDate}
                            onDateChange={(selectedDateValue) =>
                              handleFromDate(selectedDateValue)
                            }
                            placeholderProp="From Date"
                            datePickerInputStyle={{ borderRadius: "10px 10px 10px 10px" }}
                            value={fromDate}
                            clearValue={true}

                            CUSTOM_DISABLE={true}
                            disableFutureDates={true}
                            maxDate={toDateMinMax}
                          />
                        </Box>
                        <Box w='800px'>
                          <DatePicker
                            onDateChange={(selectedDateValue) =>
                              handleToDate(selectedDateValue)
                            }
                            placeholderProp="To Date"
                            datePickerInputStyle={{ borderRadius: "10px 10px 10px 10px " }}
                            value={toDate}
                            clearValue={true}

                            CUSTOM_DISABLE={true}
                            maxDate={new Date().toISOString()}
                            minDate={fromDateMinMax}

                          />
                        </Box>

                        <Box gap='10px' pl='2rem' w='70vw' display='flex' flexDirection='row' justifyContent='center' alignItems='center'>
                          <PrimaryButton buttonText="Filter" id="filterButton"
                            onClick={handlePrescriptionsApplyFilters}
                          />
                          <PrimaryButton buttonText="Reset" id="resetButton" variant="grayBtnFull" btnStyle={{ color: "#AA2F27" }}
                            onClick={prescriptionResetFields}
                          />
                        </Box>

                      </Box>

                      <Box w='100%' p="1.5rem 2rem" maxH="calc(100vh - 310px)" overflowY="auto" className="prescriptionContainer">
  <SimpleGrid 
    columns={{ 
      base: 1, 
      md: prescriptionViewdata && prescriptionViewdata.length === 0 ? 1 : 2,
      lg: prescriptionViewdata && prescriptionViewdata.length === 0 ? 1 : 3, 
      xl: prescriptionViewdata && prescriptionViewdata.length === 0 ? 1 : 4 
    }} 
    spacing="1rem"
  >
    {prescriptionViewdata && prescriptionViewdata.length > 0 ? (
      prescriptionViewdata.map((item, index) => (
        <DoctorCard
          key={index}
          hasFooter={false}
          cardBody={
            <Box w="100%" maxW="100%">
              {/* Header Section */}
              <Box display="flex" justifyContent="space-between" w="100%" alignItems="flex-start" gap="0.5rem">
                <Box display="flex" gap="0.75rem" minW="0" flex="1" overflow="hidden">
                  <Image
                    borderRadius="full"
                    w="2.75rem"
                    h="2.75rem"
                    flexShrink="0"
                    src={item.patientimage ?
                      (item.patientimage.startsWith('https') ? item.patientimage : item.imagepath + item.patientimage)
                      : '/assets/imgs/no-image.png'}
                  />
                  <Box minW="0" flex="1" overflow="hidden">
                    <Text
                      fontSize="0.875rem"
                      fontWeight="600"
                      color="#061027"
                      title={item.patientname}
                      isTruncated
                      display="block"
                    >
                      {item.patientname}
                    </Text>
                  </Box>
                </Box>
                <Text
                  fontSize="0.75rem"
                  fontWeight="500"
                  color="#384052"
                  flexShrink="0"
                  whiteSpace="nowrap"
                >
                  {formatDate_Do_MMM_YYYY(item.prescribeddate)}
                </Text>
              </Box>

              <Divider my="0.75rem" />
              
              {/* Doctor Info */}
              <Flex gap="8px" align="center" justifyContent='space-between' wrap="wrap">
                <Text fontSize="12px" fontWeight="500" isTruncated flex="1" minW="0">
                  {item.doctorname ? item.doctorname : "-"}
                </Text>
                <Text fontSize="12px" fontWeight="500" flexShrink="0" whiteSpace="nowrap">
                  {item.bookingid ? "#" + item.bookingid : "-"}
                </Text>
              </Flex>

              {/* Chief Complaint */}
              <Flex mt='10px' gap="8px" align="center" w="100%">
                <Text 
                  fontSize="12px" 
                  fontWeight="500" 
                  title={item.chiefcomplaint}
                  isTruncated
                  w="100%"
                >
                  {item.chiefcomplaint ? item.chiefcomplaint : "-"}
                </Text>
              </Flex>

              <Divider my="1rem" />

              <Box w="100%" maxW="100%">
                <VStack spacing="0.75rem" w="100%">
                  
                  {/* Progress Notes */}
                  <Box w="70%" position="relative">
                    {/* <Text fontSize="0.75rem" fontWeight="600" mb="0.25rem" color="#061027">
                      Progress Notes
                    </Text> */}
                    <Flex w="100%" border="1px solid #E6E7E9" borderRadius="8px" overflow="hidden">
                      <Box 
                        flex="1" 
                        display="flex" 
                        alignItems="center" 
                        justifyContent="center"
                        bg="white"
                        minH="2.5rem"
                      >
                        <Text fontSize="0.7rem" color="gray.600">
                          Progress Notes
                        </Text>
                      </Box>
                      <Flex borderLeft="1px solid #E6E7E9">
                        <Box
                          display="flex"
                          p="0.5rem"
                          bg="white"
                          borderRight="1px solid #E6E7E9"
                          cursor="pointer"
                          alignItems="center"
                          justifyContent="center"
                          // onClick={() => window.open(item.imagepath + item.progessnoteurl, '_blank')}
                          onClick={() => {
                            if (item.progessnoteurl) {
                              window.open(item.imagepath + item.progessnoteurl, '_blank');
                            } else {
                              showErrorToast("Progress Notes document is not available");
                            }
                          }}
                          minW="2.5rem"
                          minH="2.5rem"
                        >
                          <Image
                            w="1rem"
                            h="1rem"
                            src="/assets/imgs/show-pass.png"
                            alt="Preview"
                          />
                        </Box>
                        <Box
                          display="flex"
                          p="0.5rem"
                          bg="white"
                          cursor="pointer"
                          alignItems="center"
                          justifyContent="center"
                          // onClick={() => downloadDocument(item.imagepath + item.progessnoteurl, "Progress Notes")}
                          onClick={() => {
                            if (item.progessnoteurl) {
                              downloadDocument(item.imagepath + item.progessnoteurl, "Progress Notes");
                            } else {
                              showErrorToast("Progress Notes document is not available");
                            }
                          }}
                          minW="2.5rem"
                          minH="2.5rem"
                        >
                          <Image
                            w="1rem"
                            h="1rem"
                            src="/assets/svgs/pdf-outline.svg"
                            alt="Download"
                          />
                        </Box>
                      </Flex>
                    </Flex>
                  </Box>

                  {/* Prescription */}
                  <Box w="70%" position="relative">
                    {/* <Text fontSize="0.75rem" fontWeight="600" mb="0.25rem" color="#061027">
                      Prescription
                    </Text> */}
                    <Flex w="100%" border="1px solid #E6E7E9" borderRadius="8px" overflow="hidden">
                      <Box 
                        flex="1" 
                        display="flex" 
                        alignItems="center" 
                        justifyContent="center"
                        bg="white"
                        minH="2.5rem"
                      >
                        <Text fontSize="0.7rem" color="gray.600">
                          Prescription
                        </Text>
                      </Box>
                      <Flex borderLeft="1px solid #E6E7E9">
                        <Box
                          display="flex"
                          p="0.5rem"
                          bg="white"
                          borderRight="1px solid #E6E7E9"
                          cursor="pointer"
                          alignItems="center"
                          justifyContent="center"
                          // onClick={() => window.open(item.imagepath + item.documents)}
                          onClick={() => {
                            if (item.documents) {
                              window.open(item.imagepath + item.documents, '_blank');
                            } else {
                              showErrorToast("Prescription document is not available");
                            }
                          }}
                          minW="2.5rem"
                          minH="2.5rem"
                        >
                          <Image
                            w="1rem"
                            h="1rem"
                            src="/assets/imgs/show-pass.png"
                            alt="Preview"
                          />
                        </Box>
                        <Box
                          display="flex"
                          p="0.5rem"
                          bg="white"
                          cursor="pointer"
                          alignItems="center"
                          justifyContent="center"
                          // onClick={() => downloadDocument(item.imagepath + item.documents, "Order")}
                          onClick={() => {
                            if (item.documents) {
                              downloadDocument(item.imagepath + item.documents, "Order");
                            } else {
                              showErrorToast("Prescription document is not available");
                            }
                          }}
                          minW="2.5rem"
                          minH="2.5rem"
                        >
                          <Image
                            w="1rem"
                            h="1rem"
                            src="/assets/svgs/pdf-outline.svg"
                            alt="Download"
                          />
                        </Box>
                      </Flex>
                    </Flex>
                  </Box>

                </VStack>

                <Divider my="1rem" borderColor="#E6E7E9" />

                {/* Audio Player */}
                {item.audiourl && (
                  <Box mt={4} mb={5} display="flex" flexDirection="column" alignItems="center">
                    <Text fontWeight="600" mb={2} fontSize="0.875rem" textAlign="center">
                      Listen to your recorded audio:
                    </Text>
                    <Box position="relative" width="100%" maxWidth="300px">
                      <audio
                        ref={audioPlayerRef}
                        src={item.imagepath + item.audiourl}
                        controls
                        style={{ width: "100%", maxWidth: "100%" }}
                      />
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          }
        />
      ))
    ) : (
      <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center" height="calc(100vh - 300px)" width="100%">
        <Image boxSize="64px" opacity="0.5" src="/assets/svgs/prescriptions.svg" />
        <Text>No Prescriptions found</Text>
      </Box>
    )}
  </SimpleGrid>
</Box>
                      {prescriptionViewdata && prescriptionViewdata.length > 0 && (
                        <Box w="100%" display="flex" boxShadow="rgba(0, 0, 0, 0.15) 0px 5px 15px 0px" justifyContent="space-between" alignItems="center" p='1rem' pl='2rem' pos='fixed' bottom='0' bg='white'>
                          <Box
                            visibility={(totalItemCount < countTo && !totalExceedsPageCount) ? "hidden" : "visible"}
                          >
                            <Text>Showing  <b>{countFrom}</b> to <b>{countTo}</b>  of {totalItemCount} results</Text>
                          </Box>
                          <Box
                            gap="2.5rem"
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            mr='120px'>
                            <Box visibility={currentPage === 1 ? 'hidden' : 'visible'} currentPage={currentPage}
                            // onPageChange={handlePageChange}
                            >

                              <Box as="button" onClick={handlePreviousClick} p="0.5rem 0.75rem" border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" fontSize="1rem" fontWeight="500">
                                Previous
                              </Box>
                            </Box>
                            <Text textAlign="center" fontSize=".875rem" fontWeight="600">
                              Page {currentPage} of {totalPages}
                            </Text>
                            {(totalItemCount >= countTo && !totalExceedsPageCount) &&
                              <Box
                              // visibility={currentPage === totalPages ? 'hidden' : 'visible'}
                              >

                                <Box as="button" onClick={handleNextClick} p="0.5rem 0.75rem" border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" fontSize="1rem" fontWeight="500">
                                  Next
                                </Box>
                              </Box>
                            }
                          </Box>
                        </Box>
                      )}
                      {/* Table end */}
                    </>
                  )}

                  {/* Followups tab */}
                  {activeTab == "followups" && (
                    <>
                      <Box gap='10px' p='2rem' w='calc(100vw - 6.5rem)' borderBottom="1px solid #E6E7E9" display='flex' flexDirection='row' justifyContent='center' alignItems='center'>
                        <PrimaryInput
                          variant="fullRound"
                          title="Name"
                          inputPlace="Name"
                          id="yourName"
                          onKeyDown={handleKeyDown}
                          onChange={handleChangeFollowupName}
                          inputValue={userNameFollowup}
                        />

{/* <Box w='800px'> */}
                          <DatePicker
                            // defaultDate={procedureDate}
                            onDateChange={(selectedDateValue) =>
                              handleFollowupFromDate(selectedDateValue)
                            }
                            placeholderProp="From Date"
                            datePickerInputStyle={{ borderRadius: "10px 10px 10px 10px" }}
                            value={fromDateFollowup}
                            clearValue={true}

                            CUSTOM_DISABLE={true}
                            disableFutureDates={true}
                            maxDate={toDateMinMaxFollowup}
                          />
                        {/* </Box> */}
                        {/* <Box w='800px'> */}
                          <DatePicker
                            onDateChange={(selectedDateValue) =>
                              handleFollowupToDate(selectedDateValue)
                            }
                            placeholderProp="To Date"
                            datePickerInputStyle={{ borderRadius: "10px 10px 10px 10px " }}
                            value={toDateFollowup}
                            clearValue={true}

                            CUSTOM_DISABLE={true}
                            // maxDate={new Date().toISOString()}
                            minDate={fromDateMinMaxFollowup}

                          />
                        {/* </Box> */}

                        <Box gap='10px' pl='1rem' w='70vw' display='flex' flexDirection='row' justifyContent='center' alignItems='center'>
                          <PrimaryButton buttonText="Filter" id="filterButton"
                            onClick={handleFollowupsApplyFilters}
                          />
                          <PrimaryButton buttonText="Reset" id="resetButton" variant="grayBtnFull" btnStyle={{ color: "#AA2F27" }}
                            onClick={followupResetFields}
                          />
                        </Box>

                        {/* <Box gap='10px' pl='2rem' w='70vw' display='flex' flexDirection='row' justifyContent='center' alignItems='center'>
                          <PrimaryButton
                            //isDisabled={showFilterCount ? false : true} 
                            buttonText="Send Notification" onClick={openNotificationCustomMessage}
                          />
                        </Box> */}

                      </Box>

                      <Box w='100%' p="1.5rem 2rem" maxH="calc(100vh - 310px)" overflowY="auto" className="labContainer">
                        <SimpleGrid columns={{ base: 1, lg: followupViewData && followupViewData.length == 0 ? 1 : 3, xl: followupViewData && followupViewData.length == 0 ? 1 : 4 }} spacing="1rem">
                          {followupViewData && followupViewData.length > 0 ? (
                            followupViewData.map((item, index) => {
                              const isPastFollowup = new Date(item.followupdate) < new Date();
                              return (
                              <DoctorCard
                                hasFooter={false}
                                cardBody={
                                  <>
                                    <Box
                                      key={index}
                                      display="flex"
                                      justifyContent="space-between"
                                      flexDir='column'
                                      w="100%"
                                      alignItems="flex-start"
                                    >
                                      <Box display="flex" justifyContent='space-between' w='100%' gap="0.75rem">
                                        <Box>
                                      <Box display="flex" alignItems='center' gap="0.75rem">
                                        <Image
                                          borderRadius="full"
                                          w="2.75rem"
                                          h="2.75rem"
                                          src={item.doctorimage ?
                                            (item.doctorimage.startsWith('https') ? item.doctorimage : item.imagepath + item.doctorimage)
                                            : '/assets/imgs/no-image.png'}
                                        />

<Box>

                                        <Box w="100%" maxW="20rem" isTruncated>
                                          <Text
                                            fontSize="0.875rem"
                                            fontWeight="600"
                                            color="#061027"
                                            className="textOverflow"
                                            // title={item.specality}
                                            title={item.patientname}
                                          >
                                            {/* {item.specality} */}
                                            {item.patientname}
                                          </Text>
                                        </Box>
                                          {/* <Text
                                            fontSize="0.625rem"
                                            fontWeight="500"
                                            color="#384052"
                                          >
                                            {formatDate_Do_MMM_YYYY(item.followupdate)}
                                          </Text> */}

                                          {/* <Text fontSize='0.75rem' fontWeight='600'>
                                          {item.isfreevisit == 1 ? "Visit Type: Free" : "Visit Type: Paid"}
                                        </Text> */}

</Box>
                                          {/* <Text fontSize='0.75rem' fontWeight='600'>
                                          Reminder sent: {item.logcount ? item.logcount : 0}
                                        </Text> */}
                                        </Box>
                                        </Box>
                                        {/* <Box
                                          as="button"
                                          border="1px solid #E6E7E9"
                                          borderRadius="full"
                                          w="36px"
                                          h="36px"
                                          p="6px"
                                          display="flex"
                                          justifyContent="center"
                                          alignItems="center"
                                          onClick={() => viewLogs(item.orderid)}
                                          title={item.logcount == 0 ? 'No Logs' : 'View Logs'}
                                          disabled={item.logcount == 0}
                                        >
                                          <Image minW='20px' w="100%" h='16px' src="/assets/svgs/reports-filled.svg" />
                                        </Box> */}

{/* <Box w='fit-content'>
                            {item.isfreevisitbooked && item.isfreevisitbooked === 1 ? (
                              <Text
                              fontSize="0.75rem"
                              borderRadius="full"
                              fontWeight="600"
                              p="0.25rem 0.5rem"
                              border="1px solid #E6E7E9"
                              // bg='#14C585'
                              bg="#E6E7E966"
                              color='rgb(0,151,0)'
                            >
                              Present
                            </Text>
                            ) : (
                              <Text
                                fontSize="0.75rem"
                                borderRadius="full"
                                fontWeight="600"
                                p="0.25rem 0.5rem"
                                border="1px solid #E6E7E9"
                                // bg='#F044383D'
                                bg="#E6E7E966"
                                // color='#E6E7E966'
                                // color='rgb(255,165,0)'
                                // color='#FA594E'
                                // bg='#032217' for approve
                                // color='#14C585' for approve
                              >
                                Past
                              </Text>
                            )}
                           </Box> */}
                                      </Box>
                                      <Box
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems='center'
                                        w="100%"
                                        // alignItems="flex-start"
                                        mt='0.75rem'
                                        //flexDir='column'
                                      >
                                        {/* <Text fontSize='0.75rem' fontWeight='600'>
                                          {item.isfreevisit == 1 ? "Free" : "Paid"}
                                        </Text> */}
                                        
                                        {/* <Text fontSize='0.75rem' fontWeight='600'>
                                          {item.isfreevisitbooked == 1 ? "Present" : "Past"}
                                        </Text> */}
                                      
                                    </Box>
                                    {/* {item.patientacceptedcount > 0 && */}
                                    {/* <Text fontSize='0.75rem' fontWeight='600'>
                                          Followup Date: {item.followupdate ? formatDate_Do_MMM_YYYY_Time(item.followupdate) : ""}
                                        </Text> */}
                                     {/* }  */}

                                     <Box w='fit-content'>
                            {/* {item.isPastFollowup ? ( */}
                            { new Date(item.followupdate) > new Date() ? (
                              <Text
                              fontSize="0.75rem"
                              // borderRadius="full"
                              fontWeight="600"
                              // p="0.25rem 0.5rem"
                              // border="1px solid #E6E7E9"
                              // // bg='#14C585'
                              // bg="#E6E7E966"
                              color='rgb(0,151,0)'
                            >
                              Followup Date: {item.followupdate ? formatDate_Do_MMM_YYYY_Time(item.followupdate) : ""}
                            </Text>
                            ) : (
                              <Text
                                fontSize="0.75rem"
                                // borderRadius="full"
                                fontWeight="600"
                                // p="0.25rem 0.5rem"
                                // border="1px solid #E6E7E9"
                                // bg='#F044383D'
                                // bg="#E6E7E966"
                                // color='grey'
                                color='gray'
                                // color='rgb(255,165,0)'
                                // color='#FA594E'
                                // bg='#032217' for approve
                                // color='#14C585' for approve
                              >
                                Followup Date: {item.followupdate ? formatDate_Do_MMM_YYYY_Time(item.followupdate) : ""}
                              </Text>
                            )}
                            {/* <Text fontSize='0.75rem' fontWeight='600'>
                              Followups count: {item.followupcount ? item.followupcount : 0}
                              </Text> */}
                           </Box>
                                     <Box w='fit-content'>
                              <Text
                              fontSize="0.75rem"
                              fontWeight="600"
                              color='rgb(0,151,0)'
                            >
                              {item.isfreevisit == 1 ? "Visit Type: Free" : "Visit Type: Paid"}
                            </Text>
                            {/* <Text fontSize='0.75rem' fontWeight='600'>
                              Followups count: {item.followupcount ? item.followupcount : 0}
                              </Text> */}
                           </Box>
                                    </Box>

                                    <Divider my="0.75rem" />

                                    <Box display='flex' flexDir="column">
                                      <Box display="flex" alignItems="center" gap="0.5rem">
                                        <Image w="12px" h="13px" src="/assets/svgs/stethoscope.svg" />
                                        <Text fontSize="0.75rem" fontWeight="500">{item.doctorname}</Text>
                                      </Box>
                                      {/* <Box display="flex" alignItems="center" gap="0.5rem">
                                        <Image filter={COLORS.BLUE_FILTER} w="12px" h="13px" src="/assets/svgs/patient.svg" />
                                        <Text fontSize="0.75rem" fontWeight="500">{item.patientname}</Text>
                                      </Box> */}
                                      {/* <Box display="flex" alignItems="center" gap="0.5rem">
                                        <Image w="13px" h="10px" src="/assets/svgs/hospital.svg" />
                                        <Text fontSize="0.75rem" fontWeight="500">{item.hospital}</Text>
                                      </Box>
                                      <Box display="flex" alignItems="center" gap="0.5rem">
                                        <Image w="13px" h="10px" src="/assets/svgs/location-blue.svg" />
                                        <Text fontSize="0.75rem" fontWeight="500">{(item.address === null || item.address === '') && (item.city === null || item.city === '') && (item.country === null || item.country === '') ? '-' : `${item.address || ''}${item.address && item.city ? ', ' : ''}${item.city || ''}${(item.city && item.country) || (item.address && item.country) ? ', ' : ''}${item.country || ''}`}</Text>


                                      </Box> */}
                                    </Box>

                                    <Box w="100%" display="flex" justifyContent="space-between" gap="10px" mt="15px">
                                      <Box
                                        as="button"
                                        key={index}
                                        w="100%"
                                        border="1px solid #E6E7E9"
                                        p="10px"
                                        borderRadius="10px"
                                        height="50px"
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                        onClick={() => openNotificationModal(
                                          {
                                            patientid: item.patientid,
                                            patientfcmtoken: item.patientfcmtoken,
                                            patientname: item.patientname,
                                            doctorname: item.doctorname,
                                            orderid: item.followupid,
                                            doctorid: item.doctorid,
                                            followupdate: item.followupdate
                                          }
                                        )}
                                      //   onClick={() => openNotificationCategory(item.ordername, {
                                      //     patientid: item.patientid,
                                      //     patientfcmtoken: item.patientfcmtoken,
                                      //     patientname: item.patientname,
                                      //     doctorname: item.doctorname,
                                      //     orderid: item.orderid,
                                      //     entitytype: item.entitytype,
                                      //     aicontent: item.aicontent
                                      // })}
                                      >
                                        <Box display="flex" fontSize="12px" flexDirection="column" justifyContent="center" fontWeight="500">
                                          Send Notification
                                        </Box>
                                      </Box>
                                    </Box>

                                    <Box w="100%">
                                      {/* <Box
                                as="button"
                                // onClick={onClick}
                                w="100%"
                                border="1px solid #E6E7E9"
                                p="10px"
                                borderRadius="10px"
                                mt="15px"
                                height="50px"
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between">
                                <Box
                                  display="flex"
                                  fontSize="12px"
                                  flexDirection="column"
                                  justifyContent="center"
                                  fontWeight="500"
                                >
                                2 documents
                                </Box>
                                <Box borderRadius="full" p="10px">
                                  <Image w="8px" src="/assets/imgs/right-icon.png" />
                                </Box>
                              </Box> */}
                                    </Box>
                                  </>
                                }
                              />
                            )})
                          ) : (
                            <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center" height="calc(100vh - 300px)" width="100%">
                              <Image boxSize="64px" opacity="0.5" src="/assets/svgs/prescriptions.svg" />
                              <Text>No Followups found</Text>
                            </Box>
                          )}
                        </SimpleGrid>
                        {/* Pagination Section */}
                      </Box>
                      {followupViewData && followupViewData.length > 0 && (
                        <Box w="100%" display="flex" boxShadow="rgba(0, 0, 0, 0.15) 0px 5px 15px 0px" justifyContent="space-between" alignItems="center" p='1rem' pl='2rem' pos='fixed' bottom='0' bg='white'>
                          <Box
                            visibility={(totalItemCount < countTo && !totalExceedsPageCount) ? "hidden" : "visible"}
                          >
                            <Text>Showing  <b>{countFrom}</b> to <b>{countTo}</b>  of {totalItemCount} results</Text>
                          </Box>
                          <Box
                            gap="2.5rem"
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            mr='120px'>
                            <Box visibility={currentPage === 1 ? 'hidden' : 'visible'} currentPage={currentPage}
                            // onPageChange={handlePageChange}
                            >

                              <Box as="button" onClick={handlePreviousClick} p="0.5rem 0.75rem" border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" fontSize="1rem" fontWeight="500">
                                Previous
                              </Box>
                            </Box>
                            <Text textAlign="center" fontSize=".875rem" fontWeight="600">
                              Page {currentPage} of {totalPages}
                            </Text>
                            {(totalItemCount >= countTo && !totalExceedsPageCount) &&
                              <Box
                              // visibility={currentPage === totalPages ? 'hidden' : 'visible'}
                              >

                                <Box as="button" onClick={handleNextClick} p="0.5rem 0.75rem" border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" fontSize="1rem" fontWeight="500">
                                  Next
                                </Box>
                              </Box>
                            }
                          </Box>
                        </Box>
                      )}
                      {/* Table end */}
                    </>
                  )}

                    {/* Labs Tab */}
                    {activeTab == "labs" && (
                      <>
                        <Box gap='10px' p='2rem' w='calc(100vw - 6.5rem)' borderBottom="1px solid #E6E7E9" display='flex' flexDirection='row' justifyContent='center' alignItems='center'>
                          <PrimaryInput
                            variant="fullRound"
                            title="Name"
                            inputPlace="Name"
                            id="yourName"
                            onKeyDown={handleKeyDown}
                            onChange={handleChangelabName}
                            inputValue={userNameLab}
                          />
                          <DropdownInput
                            variant="fullSide"
                            dropDownPlace="Age Group"
                            options={['1-5', '6-10', '11-15', '16-20', '21-25', '26-30', '31-35', '36-40', '41-45', '46+']}
                            readOnly={true}
                            onClick={handleChangeAgeGroup}
                            value={ageGroupType}
                            menuList={{ pos: "absolute", right: "-45px", minW: "115px" }}
                          // inputStyleCss={{w: "80%"}}
                          />
                          <DropdownInput
                            variant="fullSide"
                            dropDownPlace="Time Factor"
                            options={['Last 15 Days', 'Last 30 Days', 'Last 45 Days', 'Last 60 Days', 'Last 75 Days', 'Last 90 Days']}
                            readOnly={true}
                            onClick={handleChangeTimeFactor}
                            value={timeFactor}
                            menuList={{ pos: "absolute", right: "-45px", minW: "135px" }}
                          // inputStyleCss={{w: "80%"}}
                          />
                          <DropdownInput
                            variant="fullSide"
                            dropDownPlace="Status"
                            options={["Prescribed", "Registered", "Sample Collected", "In Transit", "Processing", "Validation Pending", "Under Review", "Provisional Report Ready", "Signed Off", "Report Available", "Notified"]}
                            readOnly={true}
                            onClick={handleLabChangeStatus}
                            value={labStatusType}
                            menuList={{ pos: "absolute", right: "-45px", minW: "235px" }}
                          // inputStyleCss={{w: "80%"}}
                          />

                          <Box gap='10px' pl='1rem' w='70vw' display='flex' flexDirection='row' justifyContent='center' alignItems='center'>
                            <PrimaryButton buttonText="Filter" id="filterButton"
                              onClick={handleLabsApplyFilters}
                            />
                            <PrimaryButton buttonText="Reset" id="resetButton" variant="grayBtnFull" btnStyle={{ color: "#AA2F27" }}
                              onClick={labResetFields}
                            />
                          </Box>

                        </Box>

                        <Box w='100%' p="1.5rem 2rem" maxH="calc(100vh - 310px)" overflowY="auto" className="labContainer">
  <SimpleGrid columns={{ base: 1, lg: labsViewdata && labsViewdata.length == 0 ? 1 : 3, xl: labsViewdata && labsViewdata.length == 0 ? 1 : 4 }} spacing="1rem">
    {labsViewdata && labsViewdata.length > 0 ? (
      labsViewdata.map((item, index) => (
        <DoctorCard
          hasFooter={false}
          cardBody={
            <>
              {/* Header section with order name and status */}
              <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb="0.5rem">
                <Box>
                  <Box w="100%" maxW="10rem" isTruncated>
                                          <Text
                                            fontSize="0.875rem"
                                            fontWeight="600"
                                            color="#061027"
                                            className="textOverflow"
                                            title={item.ordername}
                                          >
                                            {item.ordername}
                                          </Text>
                                        </Box>
                  {/* <Text fontSize="1rem" fontWeight="600" color="#061027">
                    {item.ordername}
                  </Text> */}
                  <Text fontSize="0.75rem" fontWeight="500" color="#384052">
                    {formatDate_Do_MMM_YYYY(item.orderdate)}
                  </Text>
                </Box>
                  <Box
  display='flex' 
  flexDirection='row'
  justifyContent='space-between'
  fontSize="0.75rem"
  borderRadius="full"
  fontWeight="600"
>
  {/* Status Box */}
  <Box 
    p="0.25rem 0.5rem" 
    border="1px solid #E6E7E9" 
    borderRadius='30px 0 0 30px' 
    bg={getStatusBgColor(item.orderstatusid)}
  >
    <Text color={getStatusTextColor(item.orderstatusid)}>
      {item.orderstatus || 'Prescribed'}
    </Text>
  </Box>
  
  {/* Edit Button */}
  <Box 
    p="0.25rem 0.5rem" 
    cursor='pointer' 
    bg='white' 
    borderRadius='0 30px 30px 0' 
    border="1px solid #E6E7E9"
  >
    <Image 
      src="/assets/imgs/edit-gray.png" 
      w="16px" 
      h="16px"
      onClick={() => updateStatus(item)} 
    />
  </Box>
</Box>

                {/* view Logs */}
                <Box
                                          as="button"
                                          border="1px solid #E6E7E9"
                                          borderRadius="full"
                                          w="36px"
                                          h="36px"
                                          p="6px"
                                          display="flex"
                                          justifyContent="center"
                                          alignItems="center"
                                          onClick={() => viewLabLogs(item.orderid)}
                                          title={item.logcount == 0 ? 'No Logs' : 'View Logs'}
                                          disabled={item.logcount == 0}
                                        >
                                          <Image minW='20px' w="100%" h='16px' src="/assets/svgs/reports-filled.svg" />
                                        </Box>
              </Box>

                                      <Box
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems='center'
                                        w="100%"
                                        // alignItems="flex-start"
                                        mt='0.75rem'
                                        //flexDir='column'
                                      >
                                        <Text fontSize='0.75rem' fontWeight='600'>
                                          Reminder sent: {item.logcount ? item.logcount : 0}
                                        </Text>
                                        {/* {item.patientacceptedcount > 0 &&
                                        <Text fontSize='0.75rem' fontWeight='600'>
                                          Status: {item.patientacceptedcount > 0 ? "Accepted" : ""}
                                        </Text>
                                        }  */}
                                        {/* <Box
                                          as="button"
                                          fontSize="0.875rem"
                                          fontWeight="700"
                                          textDecor="underline"
                                          // onClick={openUploadDocumentModal}
                                        >
                                          Upload document
                                        </Box> */}

                                      {item.documenturl == null ? (
                                        <Box
                                          as="button"
                                          fontSize="0.875rem"
                                          fontWeight="700"
                                          textDecor="underline"
                                          position="relative" 
                                        >
                                          {/* Hidden file input */}
                                          <input
                                            type="file"
                                            id={`genericupload-${item.appointmentid}-${item.orderid}`}
                                            style={{
                                              position: 'absolute',
                                              width: '1px',
                                              height: '1px',
                                              padding: 0,
                                              margin: '-1px',
                                              overflow: 'hidden',
                                              clip: 'rect(0, 0, 0, 0)',
                                              whiteSpace: 'nowrap',
                                              border: 0,
                                            }}
                                            accept="image/jpeg,image/jpg,image/png,image/tiff,application/pdf"
                                            onChange={(e) => GenericUpload(e, item.appointmentid, item.patientid, item.orderid)}
                                            multiple
                                          />
                                          
                                          {/* Visible button text */}
                                          <Box
                                            as="span"
                                            onClick={() => {
                                              document.getElementById(`genericupload-${item.appointmentid}-${item.orderid}`)?.click();
                                            }}
                                          >
                                            Upload document
                                          </Box>
                                        </Box>

                                  ) : (
                                    <Box
                                                  as="button"
                                                  w="40%"
                                                  border="1px solid #E6E7E9"
                                                  p="0.75rem"
                                                  borderRadius="8px"
                                                  fontWeight="600"
                                                  fontSize="0.875rem"
                                                  display="flex"
                                                  alignItems="center"
                                                  justifyContent="center"
                                                  gap="0.5rem"
                                                  // onClick={() => openLabNotificationData(item)}
                                                  onClick={() => window.open(item.imagepath + item.documenturl)}
                                                >
                                                  Preview
                                                </Box>
)}
                                      
                                    </Box>

              <Divider my="0.75rem" borderColor="#E6E7E9" />

              {/* Doctor and patient info */}
              <Box display='flex' flexDir="column" gap="0.5rem" mb="1rem">
                <Box display="flex" alignItems="center" gap="0.5rem">
                  <Image w="12px" h="13px" src="/assets/svgs/stethoscope.svg" />
                  <Text fontSize="0.75rem" fontWeight="500">{item.doctorname}</Text>
                </Box>
                <Box display="flex" alignItems="center" gap="0.5rem">
                  <Image filter={COLORS.BLUE_FILTER} w="12px" h="13px" src="/assets/svgs/patient.svg" />
                  <Text fontSize="0.75rem" fontWeight="500">{item.patientname}</Text>
                </Box>
                <Box display="flex" alignItems="center" gap="0.5rem">
                  <Image w="13px" h="10px" src="/assets/svgs/hospital.svg" />
                  <Text fontSize="0.75rem" fontWeight="500">{item.hospital}</Text>
                </Box>
                <Box display="flex" alignItems="center" gap="0.5rem">
                  <Image w="13px" h="10px" src="/assets/svgs/location-blue.svg" />
                  <Text fontSize="0.75rem" fontWeight="500">
                    {(item.address === null || item.address === '') && (item.city === null || item.city === '') && (item.country === null || item.country === '') ? 
                      '-' : 
                      `${item.address || ''}${item.address && item.city ? ', ' : ''}${item.city || ''}${(item.city && item.country) || (item.address && item.country) ? ', ' : ''}${item.country || ''}`
                  }
                  </Text>
                </Box>
              </Box>

              {/* Book Appointment Button */}
              {/* <Box 
                as="button"
                w="100%"
                bg="#3182CE"
                color="white"
                p="0.75rem"
                borderRadius="8px"
                fontWeight="600"
                fontSize="0.875rem"
                mb="1rem"
                _hover={{ bg: "#2C5282" }}
                // onClick={() => handleBookAppointment(item)}
              >
                Book an Appointment
              </Box> */}
              <Box w='100%' mb="1rem">
  <PrimaryButton 
    buttonText={item.appointmentdate && item.appointmenttime ? `Appointment Date: ${formatDate(item.appointmentdate)}, ${to12HourFormat(item.appointmenttime)}` : "Book an Appointment"}
    id="filterButton"
    variant='mdBtn'
    btnStyle={{
      w: '100%',
      bg: item.appointmentdate && item.appointmenttime ? 'rgb(20, 197, 133)' : '#d69e2e',
      _hover: {
        bg: item.appointmentdate && item.appointmenttime ? 'rgb(16, 167, 113)' : '#b7790f'
      }
    }}
    onClick={() => openBookAppointmentModal(item)}
  />
</Box>
              <Box w='100%' mb="1rem">
  <PrimaryButton
                      fontSize="14px"
                      variant="mdBtn"
                      buttonText="Generate Report"
                      btnIcon="/assets/imgs/add.png"
                      onClick={() => openGenerateForm(item)}
                    />
</Box>

              {/* Notify/Remind Button */}
              <Box display='flex' justifyContent='space-between' alignItems='center'>
                {/* Checkmarks row */}
              <Box display="flex" justifyContent="space-between" alignItems="center" mb="1rem" w="50%">
                {[1, 2, 3, 4, 5].map((check) => (
                  <Box
                    key={check}
                    w="24px"
                    h="24px"
                    borderRadius="50%"
                    border={check <= item.logcount ? "1px solid #14C585" : "1px solid #E6E7E9"}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    bg={check <= item.logcount ? "#E6F5EE" : "transparent"}
                  >
                    {check <= item.logcount && (
                      <Image 
                        src="/assets/imgs/success-alert.png" 
                        w="24px" 
                        h="24px" 
                        alt="completed step"
                      />
                    )}
                  </Box>
                ))}
              </Box>

              <Box
                as="button"
                w="40%"
                border="1px solid #E6E7E9"
                p="0.75rem"
                borderRadius="8px"
                fontWeight="600"
                fontSize="0.875rem"
                display="flex"
                alignItems="center"
                justifyContent="center"
                gap="0.5rem"
                onClick={() => openLabNotificationData(item)}
              >
                {/* <Image src="/assets/svgs/bell-icon.svg" w="16px" h="16px" /> */}
                Notify / Remind
              </Box>
              </Box>

              {/* <Box display="flex" alignItems="center" pr="20px" mt="15px">                      
                <input
                  type="file"
                  id={`genericupload-${item.appointmentid}-${item.orderid}`}
                  style={{ display: 'none' }}
                  accept="image/jpeg,image/jpg,image/png,image/tiff,application/pdf"
                  onChange={(e) => GenericUpload(e, item.appointmentid, item.patientid, item.orderid)}
                  multiple
                />

               <PrimaryInput
                  inputType="file"
                  uploadText="Upload document"
                  id={`genericupload-${item.appointmentid}-${item.orderid}`}
                  docBtnWidth="195px"
                  docBtnColor="#1C4EC5"
                  iconImg="/assets/svgs/prescriptions.svg"
                  iconImgCss={{
                    width: "30px",
                    height: "auto",
                    color: "#1C4EC5",
                    filter:
                      "brightness(0) saturate(100%) invert(24%) sepia(84%) saturate(2247%) hue-rotate(215deg) brightness(83%) contrast(96%)",
                  }}
                  onClick={() => {
                    document
                      .getElementById(`genericupload-${item.appointmentid}-${item.orderid}`)
                      ?.click();
                  }}
                  variant="grayBtnFull"
                />                                                 
                </Box> */}
            </>
          }
        />
      ))
    ) : (
      <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center" height="calc(100vh - 300px)" width="100%">
        <Image boxSize="64px" opacity="0.5" src="/assets/svgs/prescriptions.svg" />
        <Text>No Labs found</Text>
      </Box>
    )}
  </SimpleGrid>
</Box>
                        {labsViewdata && labsViewdata.length > 0 && (
                          <Box w="100%" display="flex" boxShadow="rgba(0, 0, 0, 0.15) 0px 5px 15px 0px" justifyContent="space-between" alignItems="center" p='1rem' pl='2rem' pos='fixed' bottom='0' bg='white'>
                            <Box
                              visibility={(totalItemCount < countTo && !totalExceedsPageCount) ? "hidden" : "visible"}
                            >
                              <Text>Showing  <b>{countFrom}</b> to <b>{countTo}</b>  of {totalItemCount} results</Text>
                            </Box>
                            <Box
                              gap="2.5rem"
                              display="flex"
                              justifyContent="space-between"
                              alignItems="center"
                              mr='120px'>
                              <Box visibility={currentPage === 1 ? 'hidden' : 'visible'} currentPage={currentPage}
                              // onPageChange={handlePageChange}
                              >

                                <Box as="button" onClick={handlePreviousClick} p="0.5rem 0.75rem" border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" fontSize="1rem" fontWeight="500">
                                  Previous
                                </Box>
                              </Box>
                              <Text textAlign="center" fontSize=".875rem" fontWeight="600">
                                Page {currentPage} of {totalPages}
                              </Text>
                              {(totalItemCount >= countTo && !totalExceedsPageCount) &&
                                <Box
                                // visibility={currentPage === totalPages ? 'hidden' : 'visible'}
                                >

                                  <Box as="button" onClick={handleNextClick} p="0.5rem 0.75rem" border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" fontSize="1rem" fontWeight="500">
                                    Next
                                  </Box>
                                </Box>
                              }
                            </Box>
                          </Box>
                        )}
                        {/* Table end */}
                      </>
                    )}

                  {/* Imagings Tab */}
                  {activeTab == "imaging" && (
                    <>
                      <Box gap='10px' p='2rem' w='calc(100vw - 6.5rem)' borderBottom="1px solid #E6E7E9" display='flex' flexDirection='row' justifyContent='center' alignItems='center'>
                        <PrimaryInput
                          variant="fullRound"
                          title="Name"
                          inputPlace="Name"
                          id="yourName"
                          onKeyDown={handleKeyDown}
                          onChange={handleChangeImagingName}
                          inputValue={userNameImaging}
                        />
                        <DropdownInput
                          variant="fullSide"
                          dropDownPlace="Age Group"
                          options={['1-5', '6-10', '11-15', '16-20', '21-25', '26-30', '31-35', '36-40', '41-45', '46+']}
                          readOnly={true}
                          onClick={handleImagingAgeGroup}
                          value={imagingAgeGroup}
                          menuList={{ pos: "absolute", right: "-45px", minW: "115px" }}
                        // inputStyleCss={{w: "80%"}}
                        />
                        <DropdownInput
                          variant="fullSide"
                          dropDownPlace="Time Factor"
                          options={['Last 15 Days', 'Last 30 Days', 'Last 45 Days', 'Last 60 Days', 'Last 75 Days', 'Last 90 Days']}
                          readOnly={true}
                          onClick={handleImagingTimeFactor}
                          value={imagingTimeFactor}
                          menuList={{ pos: "absolute", right: "-45px", minW: "135px" }}
                        // inputStyleCss={{w: "80%"}}
                        />
                        <DropdownInput
                          variant="fullSide"
                          dropDownPlace="Status"
                          options={["Prescribed", "Registered", "Sample Collected", "In Transit", "Processing", "Validation Pending", "Under Review", "Provisional Report Ready", "Signed Off", "Report Available", "Notified"]}
                          readOnly={true}
                          onClick={handleImagingChangeStatus}
                          value={imagingStatusType}
                          menuList={{ pos: "absolute", right: "-45px", minW: "235px" }}
                        // inputStyleCss={{w: "80%"}}
                        />

                        <Box gap='10px' pl='1rem' w='70vw' display='flex' flexDirection='row' justifyContent='center' alignItems='center'>
                          <PrimaryButton buttonText="Filter" id="filterButton"
                            onClick={handleImagingApplyFilters}
                          />
                          <PrimaryButton buttonText="Reset" id="resetButton" variant="grayBtnFull" btnStyle={{ color: "#AA2F27" }}
                            onClick={imagingResetFields}
                          />
                        </Box>

                        {/* <Box gap='10px' pl='2rem' w='70vw' display='flex' flexDirection='row' justifyContent='center' alignItems='center'>
                        <PrimaryButton buttonText="Send Notification" id="filterButton"
                          onClick={handlePrescriptionsApplyFilters}
                        />
                      </Box> */}

                      </Box>

                      <Box w='100%' p="1.5rem 2rem" maxH="calc(100vh - 310px)" overflowY="auto" className="labContainer">
                        <SimpleGrid columns={{ base: 1, lg: imagingViewdata && imagingViewdata.length == 0 ? 1 : 3, xl: imagingViewdata && imagingViewdata.length == 0 ? 1 : 4 }} spacing="1rem">
                          {imagingViewdata && imagingViewdata.length > 0 ? (
                            imagingViewdata.map((item, index) => (
                              <DoctorCard
                                hasFooter={false}
                                cardBody={
                                  <>
                                    <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb="0.5rem">
                <Box>
                  <Box w="100%" maxW="10rem" isTruncated>
                                          <Text
                                            fontSize="0.875rem"
                                            fontWeight="600"
                                            color="#061027"
                                            className="textOverflow"
                                            title={item.ordername}
                                          >
                                            {item.ordername}
                                          </Text>
                                        </Box>
                  {/* <Text fontSize="1rem" fontWeight="600" minW='100px' color="#061027">
                    {item.ordername}
                  </Text> */}
                  <Text fontSize="0.75rem" fontWeight="500" color="#384052">
                    {formatDate_Do_MMM_YYYY(item.orderdate)}
                  </Text>
                </Box>
                {/* existing status design */}
                  {/* <Box
                  display='flex' flexDirection='row'
                  justifyContent='space-between'
                    fontSize="0.75rem"
                    borderRadius="full"
                    fontWeight="600"
                  >
                <Box p="0.25rem 0.5rem" border="1px solid #F5E6E6" borderRadius='30px 0 0 30px' bg={item.orderstatus === 'Approved' ? '#E6F5EE' : '#F5E6E6'}>
                    <Text color={item.orderstatus === 'Approved' ? '#14C585' : '#FF4D4D'}>
                    {item.orderstatus || 'Prescribed'}
 
                    </Text>
                  </Box>
                  <Box p="0.25rem 0.5rem" cursor='pointer' bg='white' borderRadius='0 30px 30px 0' border="1px solid #E6E7E9">
                    <Image src="/assets/imgs/edit-gray.png" w="16px" h="16px"
                    onClick={() => updateStatus(item)}
                     />
                  </Box>
                </Box> */}
                <Box
  display='flex' 
  flexDirection='row'
  justifyContent='space-between'
  fontSize="0.75rem"
  borderRadius="full"
  fontWeight="600"
>
  {/* Status Box */}
  <Box 
    p="0.25rem 0.5rem" 
    border="1px solid #E6E7E9" 
    borderRadius='30px 0 0 30px' 
    bg={getStatusBgColor(item.orderstatusid)}
  >
    <Text color={getStatusTextColor(item.orderstatusid)}>
      {item.orderstatus || 'Prescribed'}
    </Text>
  </Box>
  
  {/* Edit Button */}
  <Box 
    p="0.25rem 0.5rem" 
    cursor='pointer' 
    bg='white' 
    borderRadius='0 30px 30px 0' 
    border="1px solid #E6E7E9"
  >
    <Image 
      src="/assets/imgs/edit-gray.png" 
      w="16px" 
      h="16px"
      onClick={() => updateStatus(item)} 
    />
  </Box>
</Box>

                {/* view Logs */}
                <Box
                                          as="button"
                                          border="1px solid #E6E7E9"
                                          borderRadius="full"
                                          w="36px"
                                          h="36px"
                                          p="6px"
                                          display="flex"
                                          justifyContent="center"
                                          alignItems="center"
                                          onClick={() => viewImagingLogs(item.orderid)}
                                          title={item.logcount == 0 ? 'No Logs' : 'View Logs'}
                                          disabled={item.logcount == 0}
                                        >
                                          <Image minW='20px' w="100%" h='16px' src="/assets/svgs/reports-filled.svg" />
                                        </Box>
              </Box>

                                    {/* Upload document */}
                                        <Box
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems='center'
                                        w="100%"
                                        // alignItems="flex-start"
                                        mt='0.75rem'
                                        //flexDir='column'
                                      >
                                        <Text fontSize='0.75rem' fontWeight='600'>
                                          Reminder sent: {item.logcount ? item.logcount : 0}
                                        </Text>
                                        {/* {item.patientacceptedcount > 0 &&
                                        <Text fontSize='0.75rem' fontWeight='600'>
                                          Status: {item.patientacceptedcount > 0 ? "Accepted" : ""}
                                        </Text>
                                        }  */}
                                        {/* <Box
                                          as="button"
                                          fontSize="0.875rem"
                                          fontWeight="700"
                                          textDecor="underline"
                                          // onClick={openUploadDocumentModal}
                                        >
                                          Upload document
                                        </Box> */}

                                      {item.documenturl == null ? (
                                        <Box
                                          as="button"
                                          fontSize="0.875rem"
                                          fontWeight="700"
                                          textDecor="underline"
                                          position="relative" 
                                        >
                                          {/* Hidden file input */}
                                          <input
                                            type="file"
                                            id={`genericupload-${item.appointmentid}-${item.orderid}`}
                                            style={{
                                              position: 'absolute',
                                              width: '1px',
                                              height: '1px',
                                              padding: 0,
                                              margin: '-1px',
                                              overflow: 'hidden',
                                              clip: 'rect(0, 0, 0, 0)',
                                              whiteSpace: 'nowrap',
                                              border: 0,
                                            }}
                                            accept="image/jpeg,image/jpg,image/png,image/tiff,application/pdf"
                                            onChange={(e) => GenericUpload(e, item.appointmentid, item.patientid, item.orderid)}
                                            multiple
                                          />
                                          
                                          {/* Visible button text */}
                                          <Box
                                            as="span"
                                            onClick={() => {
                                              document.getElementById(`genericupload-${item.appointmentid}-${item.orderid}`)?.click();
                                            }}
                                          >
                                            Upload document
                                          </Box>
                                        </Box>

                                  ) : (
                                    <Box
                                                  as="button"
                                                  w="40%"
                                                  border="1px solid #E6E7E9"
                                                  p="0.75rem"
                                                  borderRadius="8px"
                                                  fontWeight="600"
                                                  fontSize="0.875rem"
                                                  display="flex"
                                                  alignItems="center"
                                                  justifyContent="center"
                                                  gap="0.5rem"
                                                  // onClick={() => openLabNotificationData(item)}
                                                  onClick={() => window.open(item.imagepath + item.documenturl)}
                                                >
                                                  Preview
                                                </Box>
)}
                                      
                                    </Box>

                                    <Divider my="0.75rem" />

                                    <Box display='flex' flexDir="column" mb='1rem'>
                                      <Box display="flex" alignItems="center" gap="0.5rem">
                                        <Image w="12px" h="13px" src="/assets/svgs/stethoscope.svg" />
                                        <Text fontSize="0.75rem" fontWeight="500">{item.doctorname}</Text>
                                      </Box>
                                      <Box display="flex" alignItems="center" gap="0.5rem">
                                        <Image filter={COLORS.BLUE_FILTER} w="12px" h="13px" src="/assets/svgs/patient.svg" />
                                        <Text fontSize="0.75rem" fontWeight="500">{item.patientname}</Text>
                                      </Box>

                                      <Box display="flex" alignItems="center" gap="0.5rem">
                                        <Image w="13px" h="10px" src="/assets/svgs/hospital.svg" />
                                        <Text fontSize="0.75rem" fontWeight="500">{item.hospital}</Text>
                                      </Box>
                                      <Box display="flex" alignItems="center" gap="0.5rem">
                                        <Image w="13px" h="10px" src="/assets/svgs/location-blue.svg" />
                                        <Text fontSize="0.75rem" fontWeight="500">{(item.address === null || item.address === '') && (item.city === null || item.city === '') && (item.country === null || item.country === '') ? '-' : `${item.address || ''}${item.address && item.city ? ', ' : ''}${item.city || ''}${(item.city && item.country) || (item.address && item.country) ? ', ' : ''}${item.country || ''}`}</Text>


                                      </Box>
                                    </Box>

                                    {/* <Box w='100%' mb="1rem">
                <PrimaryButton 
                buttonText={item.appointmentdate && item.appointmenttime ? `Appointment Date: ${formatDate(item.appointmentdate)}, ${item.appointmenttime}` : "Book an Appointment"}
                // buttonText="Book an Appointment" 
                id="filterButton"
                  // onClick={handleLabsApplyFilters}
                  onClick={() => openBookAppointmentModal(item)}
                />
              </Box> */}

              <Box w='100%' mb="1rem">
  <PrimaryButton 
    buttonText={item.appointmentdate && item.appointmenttime ? `Appointment Date: ${formatDate(item.appointmentdate)}, ${to12HourFormat(item.appointmenttime)}` : "Book an Appointment"}
    id="filterButton"
    variant='mdBtn'
    btnStyle={{
      w: '100%',
      bg: item.appointmentdate && item.appointmenttime ? 'rgb(20, 197, 133)' : '#d69e2e',
      _hover: {
        bg: item.appointmentdate && item.appointmenttime ? 'rgb(16, 167, 113)' : '#b7790f'
      }
    }}
    onClick={() => openBookAppointmentModal(item)}
  />
</Box>

                                    {/* Notify/Remind Button */}
                                    <Box display='flex' justifyContent='space-between' alignItems='center'>
                                      {/* Checkmarks row */}
                                    <Box display="flex" justifyContent="space-between" mb="1rem" w="50%">
                                      {[1, 2, 3, 4, 5].map((check) => (
                                        <Box
                                          key={check}
                                          w="24px"
                                          h="24px"
                                          borderRadius="50%"
                                          border={check <= item.logcount ? "1px solid #14C585" : "1px solid #E6E7E9"}
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                          bg={check <= item.logcount ? "#E6F5EE" : "transparent"}
                                        >
                                          {check <= item.logcount && (
                                            <Image 
                                              src="/assets/imgs/success-alert.png" 
                                              w="24px" 
                                              h="24px" 
                                              alt="completed step"
                                            />
                                          )}
                                        </Box>
                                      ))}
                                    </Box>

                                    <Box
                                      as="button"
                                      w="40%"
                                      border="1px solid #E6E7E9"
                                      p="0.75rem"
                                      borderRadius="8px"
                                      fontWeight="600"
                                      fontSize="0.875rem"
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      gap="0.5rem"
                                      onClick={() => openImagingNotificationData(item)}
                                    >
                                      {/* <Image src="/assets/svgs/bell-icon.svg" w="16px" h="16px" /> */}
                                      Notify / Remind
                                    </Box>
                                    </Box>

                                    {/* <Box display="flex" alignItems="center" pr="20px" mt="15px"
                              >                      
                                <input
                                  type="file"
                                  id={`genericupload-${item.appointmentid}-${item.orderid}`}
                                  style={{ display: 'none' }}
                                  accept="image/jpeg,image/jpg,image/png,image/tiff,application/pdf"
                                  onChange={(e) => GenericUpload(e, item.appointmentid, item.patientid, item.orderid)}
                                  multiple
                                />

                              <PrimaryInput
                                  inputType="file"
                                  uploadText="Upload document"
                                  id={`genericupload-${item.appointmentid}-${item.orderid}`}
                                  docBtnWidth="195px"
                                  docBtnColor="#1C4EC5"
                                  iconImg="/assets/svgs/prescriptions.svg"
                                  iconImgCss={{
                                    width: "30px",
                                    height: "auto",
                                    color: "#1C4EC5",
                                    filter:
                                      "brightness(0) saturate(100%) invert(24%) sepia(84%) saturate(2247%) hue-rotate(215deg) brightness(83%) contrast(96%)",
                                  }}
                                  onClick={() => {
                                    document
                                      .getElementById(`genericupload-${item.appointmentid}-${item.orderid}`)
                                      ?.click();
                                  }}
                                  variant="grayBtnFull"
                                />                                                 
                                </Box> */}

                                    <Box w="100%">
                                      {/* <Box
                                as="button"
                                // onClick={onClick}
                                w="100%"
                                border="1px solid #E6E7E9"
                                p="10px"
                                borderRadius="10px"
                                mt="15px"
                                height="50px"
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between">
                                <Box
                                  display="flex"
                                  fontSize="12px"
                                  flexDirection="column"
                                  justifyContent="center"
                                  fontWeight="500"
                                >
                                2 documents
                                </Box>
                                <Box borderRadius="full" p="10px">
                                  <Image w="8px" src="/assets/imgs/right-icon.png" />
                                </Box>
                              </Box> */}
                                    </Box>
                                  </>
                                }
                              />
                            ))
                          ) : (
                            <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center" height="calc(100vh - 300px)" width="100%">
                              <Image boxSize="64px" opacity="0.5" src="/assets/svgs/prescriptions.svg" />
                              <Text>No Imagings found</Text>
                            </Box>
                          )}
                        </SimpleGrid>
                        {/* {prescriptionViewdata == null && (
          <Box display='flex' justifyContent='center' flexDirection='column' alignItems='center' height='100vh' width='100%'>
          <Image boxSize='64px' opacity='0.5' src='/assets/svgs/prescriptions.svg'/>
          <Text>No Prescriptions</Text>
        </Box>
        )} */}
                        {/* Pagination Section */}
                      </Box>
                      {imagingViewdata && imagingViewdata.length > 0 && (
                        <Box w="100%" display="flex" boxShadow="rgba(0, 0, 0, 0.15) 0px 5px 15px 0px" justifyContent="space-between" alignItems="center" p='1rem' pl='2rem' pos='fixed' bottom='0' bg='white'>
                          <Box
                            visibility={(totalItemCount < countTo && !totalExceedsPageCount) ? "hidden" : "visible"}
                          >
                            <Text>Showing  <b>{countFrom}</b> to <b>{countTo}</b>  of {totalItemCount} results</Text>
                          </Box>
                          <Box
                            gap="2.5rem"
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            mr='120px'>
                            <Box visibility={currentPage === 1 ? 'hidden' : 'visible'} currentPage={currentPage}
                            // onPageChange={handlePageChange}
                            >

                              <Box as="button" onClick={handlePreviousClick} p="0.5rem 0.75rem" border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" fontSize="1rem" fontWeight="500">
                                Previous
                              </Box>
                            </Box>
                            <Text textAlign="center" fontSize=".875rem" fontWeight="600">
                              Page {currentPage} of {totalPages}
                            </Text>
                            {(totalItemCount >= countTo && !totalExceedsPageCount) &&
                              <Box
                              // visibility={currentPage === totalPages ? 'hidden' : 'visible'}
                              >

                                <Box as="button" onClick={handleNextClick} p="0.5rem 0.75rem" border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" fontSize="1rem" fontWeight="500">
                                  Next
                                </Box>
                              </Box>
                            }
                          </Box>
                        </Box>
                      )}
                      {/* Table end */}
                    </>
                  )}

                  {/* Procedures Tab */}
                  {activeTab == "procedures" && (
                    <>
                      <Box gap='10px' p='2rem' w='calc(100vw - 6.5rem)' borderBottom="1px solid #E6E7E9" display='flex' flexDirection='row' justifyContent='center' alignItems='center'>
                        <PrimaryInput
                          variant="fullRound"
                          title="Name"
                          inputPlace="Name"
                          id="yourName"
                          onKeyDown={handleKeyDown}
                          onChange={handleChangeProcedureName}
                          inputValue={userNameProcedure}
                        />
                        <DropdownInput
                          variant="fullSide"
                          dropDownPlace="Age Group"
                          options={['1-5', '6-10', '11-15', '16-20', '21-25', '26-30', '31-35', '36-40', '41-45', '46+']}
                          readOnly={true}
                          onClick={handleProcedureAgeGroup}
                          value={procedureAgeGroup}
                          menuList={{ pos: "absolute", right: "-45px", minW: "115px" }}
                        // inputStyleCss={{w: "80%"}}
                        />
                        <DropdownInput
                          variant="fullSide"
                          dropDownPlace="Time Factor"
                          options={['Last 15 Days', 'Last 30 Days', 'Last 45 Days', 'Last 60 Days', 'Last 75 Days', 'Last 90 Days']}
                          readOnly={true}
                          onClick={handleProcedureTimeFactor}
                          value={procedureTimeFactor}
                          menuList={{ pos: "absolute", right: "-45px", minW: "135px" }}
                        // inputStyleCss={{w: "80%"}}
                        />
                        <DropdownInput
                          variant="fullSide"
                          dropDownPlace="Status"
                          options={["Prescribed", "Registered", "Sample Collected", "In Transit", "Processing", "Validation Pending", "Under Review", "Provisional Report Ready", "Signed Off", "Report Available", "Notified"]}
                          readOnly={true}
                          onClick={handleProcedureChangeStatus}
                          value={procedureStatusType}
                          menuList={{ pos: "absolute", right: "-45px", minW: "235px" }}
                        // inputStyleCss={{w: "80%"}}
                        />

                        <Box gap='10px' pl='1rem' w='70vw' display='flex' flexDirection='row' justifyContent='center' alignItems='center'>
                          <PrimaryButton buttonText="Filter" id="filterButton"
                            onClick={handleProcedureApplyFilters}
                          />
                          <PrimaryButton buttonText="Reset" id="resetButton" variant="grayBtnFull" btnStyle={{ color: "#AA2F27" }}
                            onClick={procedureResetFields}
                          />
                        </Box>

                        {/* <Box gap='10px' pl='2rem' w='70vw' display='flex' flexDirection='row' justifyContent='center' alignItems='center'>
                          <PrimaryButton
                            //isDisabled={showFilterCount ? false : true} 
                            buttonText="Send Notification" onClick={openNotificationCustomMessage}
                          />
                        </Box> */}

                      </Box>

                      <Box w='100%' p="1.5rem 2rem" maxH="calc(100vh - 310px)" overflowY="auto" className="labContainer">
                        <SimpleGrid columns={{ base: 1, lg: procedureViewdata && procedureViewdata.length == 0 ? 1 : 3, xl: procedureViewdata && procedureViewdata.length == 0 ? 1 : 4 }} spacing="1rem">
                          {procedureViewdata && procedureViewdata.length > 0 ? (
                            procedureViewdata.map((item, index) => (
                              <DoctorCard
                                hasFooter={false}
                                cardBody={
                                  <>
                                    <Box
                                      key={index}
                                      display="flex"
                                      justifyContent="space-between"
                                      flexDir='column'
                                      w="100%"
                                      alignItems="flex-start"
                                    >
                                      <Box display="flex" justifyContent='space-between' w='100%' gap="0.75rem">
                                        <Box>
                                        <Box w="100%" maxW="13rem" isTruncated>
                                          <Text
                                            fontSize="0.875rem"
                                            fontWeight="600"
                                            color="#061027"
                                            className="textOverflow"
                                            title={item.ordername}
                                          >
                                            {item.ordername}
                                          </Text>
                                        </Box>
                                          <Text
                                            fontSize="0.625rem"
                                            fontWeight="500"
                                            color="#384052"
                                          >
                                            {formatDate_Do_MMM_YYYY(item.orderdate)}
                                          </Text>
                                          {/* <Text fontSize='0.75rem' fontWeight='600'>
                                          Reminder sent: {item.logcount ? item.logcount : 0}
                                        </Text> */}
                                        </Box>
                                        <Box
  display='flex' 
  flexDirection='row'
  justifyContent='space-between'
  fontSize="0.75rem"
  borderRadius="full"
  fontWeight="600"
>
  {/* Status Box */}
  <Box 
    p="0.25rem 0.5rem" 
    border="1px solid #E6E7E9" 
    borderRadius='30px 0 0 30px' 
    bg={getStatusBgColor(item.orderstatusid)}
  >
    <Text color={getStatusTextColor(item.orderstatusid)}>
      {item.orderstatus || 'Prescribed'}
    </Text>
  </Box>
  
  {/* Edit Button */}
  <Box 
    p="0.25rem 0.5rem" 
    cursor='pointer' 
    bg='white' 
    borderRadius='0 30px 30px 0' 
    border="1px solid #E6E7E9"
  >
    <Image 
      src="/assets/imgs/edit-gray.png" 
      w="16px" 
      h="16px"
      onClick={() => updateStatus(item)} 
    />
  </Box>
</Box>

                                        <Box
                                          as="button"
                                          border="1px solid #E6E7E9"
                                          borderRadius="full"
                                          w="36px"
                                          h="36px"
                                          p="6px"
                                          display="flex"
                                          justifyContent="center"
                                          alignItems="center"
                                          onClick={() => viewLogs(item.orderid)}
                                          title={item.logcount == 0 ? 'No Logs' : 'View Logs'}
                                          disabled={item.logcount == 0}
                                        >
                                          <Image minW='20px' w="100%" h='16px' src="/assets/svgs/reports-filled.svg" />
                                        </Box>
                                      </Box>
                                      <Box
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems='center'
                                        w="100%"
                                        // alignItems="flex-start"
                                        mt='0.75rem'
                                        //flexDir='column'
                                      >
                                        <Text fontSize='0.75rem' fontWeight='600'>
                                          Reminder sent: {item.logcount ? item.logcount : 0}
                                        </Text>
                                        {item.patientacceptedcount > 0 &&
                                        <Text fontSize='0.75rem' fontWeight='600'>
                                          Status: {item.patientacceptedcount > 0 ? "Accepted" : ""}
                                        </Text>
                                        } 
                                      
                                    </Box>
                                    {item.patientacceptedcount > 0 &&
                                    <Text fontSize='0.75rem' fontWeight='600'>
                                          Accepted On: {item.lastprocedureacceptedon ? formatDate_Do_MMM_YYYY_Time(item.lastprocedureacceptedon) : ""}
                                        </Text>
                                    } 
                                    </Box>

                                    <Divider my="0.75rem" />

                                    <Box display='flex' flexDir="column" mb="1rem">
                                      <Box display="flex" alignItems="center" gap="0.5rem">
                                        <Image w="12px" h="13px" src="/assets/svgs/stethoscope.svg" />
                                        <Text fontSize="0.75rem" fontWeight="500">{item.doctorname}</Text>
                                      </Box>
                                      <Box display="flex" alignItems="center" gap="0.5rem">
                                        <Image filter={COLORS.BLUE_FILTER} w="12px" h="13px" src="/assets/svgs/patient.svg" />
                                        <Text fontSize="0.75rem" fontWeight="500">{item.patientname}</Text>
                                      </Box>
                                      {/* <Box display="flex" alignItems="center" gap="0.5rem">
                                        <Image w="13px" h="10px" src="/assets/svgs/hospital.svg" />
                                        <Text fontSize="0.75rem" fontWeight="500">{item.hospital}</Text>
                                      </Box>
                                      <Box display="flex" alignItems="center" gap="0.5rem">
                                        <Image w="13px" h="10px" src="/assets/svgs/location-blue.svg" />
                                        <Text fontSize="0.75rem" fontWeight="500">{(item.address === null || item.address === '') && (item.city === null || item.city === '') && (item.country === null || item.country === '') ? '-' : `${item.address || ''}${item.address && item.city ? ', ' : ''}${item.city || ''}${(item.city && item.country) || (item.address && item.country) ? ', ' : ''}${item.country || ''}`}</Text>


                                      </Box> */}
                                    </Box>

                                    {/* Book Appointment */}
                                    <Box w='100%' mb="1rem">
  <PrimaryButton 
    buttonText={item.appointmentdate && item.appointmenttime ? `Appointment Date: ${formatDate(item.appointmentdate)}, ${to12HourFormat(item.appointmenttime)}` : "Book an Appointment"}
    id="filterButton"
    variant='mdBtn'
    btnStyle={{
      w: '100%',
      bg: item.appointmentdate && item.appointmenttime ? 'rgb(20, 197, 133)' : '#d69e2e',
      _hover: {
        bg: item.appointmentdate && item.appointmenttime ? 'rgb(16, 167, 113)' : '#b7790f'
      }
    }}
    onClick={() => openBookAppointmentModal(item)}
  />
</Box>

                                    {/* Notify/Remind Button */}
                                    <Box display='flex' justifyContent='space-between' alignItems='center'>
                                      {/* Checkmarks row */}
                                    <Box display="flex" justifyContent="space-between" alignItems="center" mb="1rem" w="50%">
                {[1, 2, 3, 4, 5].map((check) => (
                  <Box
                    key={check}
                    w="24px"
                    h="24px"
                    borderRadius="50%"
                    border={check <= item.logcount ? "1px solid #14C585" : "1px solid #E6E7E9"}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    bg={check <= item.logcount ? "#E6F5EE" : "transparent"}
                  >
                    {check <= item.logcount && (
                      <Image 
                        src="/assets/imgs/success-alert.png" 
                        w="24px" 
                        h="24px" 
                        alt="completed step"
                      />
                    )}
                  </Box>
                ))}
              </Box>

                                    <Box
                                      as="button"
                                      w="40%"
                                      border="1px solid #E6E7E9"
                                      p="0.75rem"
                                      borderRadius="8px"
                                      fontWeight="600"
                                      fontSize="0.875rem"
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      gap="0.5rem"
                                      onClick={() => openProcedureNotificationData(item)}
                                    >
                                      {/* <Image src="/assets/svgs/bell-icon.svg" w="16px" h="16px" /> */}
                                      Notify / Remind
                                    </Box>
                                    </Box>

                                    <Box w="100%" display="flex" justifyContent="space-between" gap="10px" mt="15px">
                                      <Box
                                        as="button"
                                        key={index}
                                        w="100%"
                                        border="1px solid #E6E7E9"
                                        p="10px"
                                        borderRadius="10px"
                                        height="50px"
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                        // onClick={() => openNotificationCategory(item.ordername)}
                                        onClick={() => openNotificationCategory(item.ordername, {
                                          patientid: item.patientid,
                                          patientfcmtoken: item.patientfcmtoken,
                                          patientname: item.patientname,
                                          doctorname: item.doctorname,
                                          orderid: item.orderid,
                                          entitytype: item.entitytype,
                                          aicontent: item.aicontent
                                      })}
                                      >
                                        <Box display="flex" fontSize="12px" flexDirection="column" justifyContent="center" fontWeight="500">
                                          AI Notification
                                          {/* Send Notification */}
                                        </Box>
                                      </Box>
                                    </Box>

                                    <Box w="100%">
                                      {/* <Box
                                as="button"
                                // onClick={onClick}
                                w="100%"
                                border="1px solid #E6E7E9"
                                p="10px"
                                borderRadius="10px"
                                mt="15px"
                                height="50px"
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between">
                                <Box
                                  display="flex"
                                  fontSize="12px"
                                  flexDirection="column"
                                  justifyContent="center"
                                  fontWeight="500"
                                >
                                2 documents
                                </Box>
                                <Box borderRadius="full" p="10px">
                                  <Image w="8px" src="/assets/imgs/right-icon.png" />
                                </Box>
                              </Box> */}
                                    </Box>
                                  </>
                                }
                              />
                            ))
                          ) : (
                            <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center" height="calc(100vh - 300px)" width="100%">
                              <Image boxSize="64px" opacity="0.5" src="/assets/svgs/prescriptions.svg" />
                              <Text>No Procedures found</Text>
                            </Box>
                          )}
                        </SimpleGrid>
                        {/* {prescriptionViewdata == null && (
          <Box display='flex' justifyContent='center' flexDirection='column' alignItems='center' height='100vh' width='100%'>
          <Image boxSize='64px' opacity='0.5' src='/assets/svgs/prescriptions.svg'/>
          <Text>No Prescriptions</Text>
        </Box>
        )} */}
                        {/* Pagination Section */}
                      </Box>
                      {procedureViewdata && procedureViewdata.length > 0 && (
                        <Box w="100%" display="flex" boxShadow="rgba(0, 0, 0, 0.15) 0px 5px 15px 0px" justifyContent="space-between" alignItems="center" p='1rem' pl='2rem' pos='fixed' bottom='0' bg='white'>
                          <Box
                            visibility={(totalItemCount < countTo && !totalExceedsPageCount) ? "hidden" : "visible"}
                          >
                            <Text>Showing  <b>{countFrom}</b> to <b>{countTo}</b>  of {totalItemCount} results</Text>
                          </Box>
                          <Box
                            gap="2.5rem"
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            mr='120px'>
                            <Box visibility={currentPage === 1 ? 'hidden' : 'visible'} currentPage={currentPage}
                            // onPageChange={handlePageChange}
                            >

                              <Box as="button" onClick={handlePreviousClick} p="0.5rem 0.75rem" border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" fontSize="1rem" fontWeight="500">
                                Previous
                              </Box>
                            </Box>
                            <Text textAlign="center" fontSize=".875rem" fontWeight="600">
                              Page {currentPage} of {totalPages}
                            </Text>
                            {(totalItemCount >= countTo && !totalExceedsPageCount) &&
                              <Box
                              // visibility={currentPage === totalPages ? 'hidden' : 'visible'}
                              >

                                <Box as="button" onClick={handleNextClick} p="0.5rem 0.75rem" border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" fontSize="1rem" fontWeight="500">
                                  Next
                                </Box>
                              </Box>
                            }
                          </Box>
                        </Box>
                      )}
                      {/* Table end */}
                    </>
                  )}

                  {/* discharge Tab */}
                  {activeTab == "discharge" && (
                    <>
                      <Box gap='10px' p='2rem' w='calc(100vw - 6.5rem)' borderBottom="1px solid #E6E7E9" display='flex' flexDirection='row' justifyContent='center' alignItems='center'>
                        {/* <PrimaryInput
                        variant="fullRound"
                        title="Name"
                        inputPlace="Name"
                        id="yourName"
                        onKeyDown={handleKeyDown}
                        onChange={handleDischargeName}
                        inputValue={dischargeDoctorName}
                      /> */}
                        <Box w='800px'>
                          <Text fontSize='1.25rem' fontWeight='500'>Total Logs: {dischargeSummary && dischargeSummary.length}</Text>
                        </Box>

                        <Box w='800px'>
                          <DatePicker
                            // defaultDate={procedureDate}
                            onDateChange={(selectedDateValue) =>
                              handleDischargeFromDate(selectedDateValue)
                            }
                            placeholderProp="From Date"
                            datePickerInputStyle={{ borderRadius: "10px 10px 10px 10px" }}
                            value={dischargeFromDate}
                            clearValue={true}

                            CUSTOM_DISABLE={true}
                            disableFutureDates={true}
                            maxDate={dischargeToDateMinMax}
                          />
                        </Box>
                        <Box w='800px'>
                          <DatePicker
                            onDateChange={(selectedDateValue) =>
                              handleDischargeToDate(selectedDateValue)
                            }
                            placeholderProp="To Date"
                            datePickerInputStyle={{ borderRadius: "10px 10px 10px 10px " }}
                            value={dischargeToDate}
                            clearValue={true}

                            CUSTOM_DISABLE={true}
                            maxDate={new Date().toISOString()}
                            minDate={dischargeFromDateMinMax}

                          />
                        </Box>

                        <Box gap='10px' pl='2rem' w='70vw' display='flex' flexDirection='row' justifyContent='center' alignItems='center'>
                          <PrimaryButton buttonText="Filter" id="filterButton"
                            onClick={handleDischargeApplyFilters}
                          />
                          <PrimaryButton buttonText="Reset" id="resetButton" variant="grayBtnFull" btnStyle={{ color: "#AA2F27" }}
                            onClick={dischargeResetFields}
                          />
                        </Box>

                      </Box>

                      <Box w='100%' p="1.5rem 2rem" maxH="calc(100vh - 70px)" overflowY="auto" className="dischargeContainer">
                                <SimpleGrid 
                                  columns={{ 
                                    base: 1, 
                                    md: 2,
                                    lg: dischargeSummary && dischargeSummary.length == 0 ? 1 : 4, 
                                    xl: dischargeSummary && dischargeSummary.length == 0 ? 1 : 4 
                                  }} 
                                  spacing="1rem" 
                                >
                                  {dischargeSummary && dischargeSummary.length > 0 ? (
                                    dischargeSummary.map((item, index) => {
                                      const patientInfo = item.aiinput?.patient_info || {};
                                      const diagnosis = item.aiinput?.diagnosis || {};
                                      const admissionDetails = item.aiinput?.admission_details || {};
                                      const specialities = item.doctorqualification?.map(q => q.degreename) || [];
                                      const primaryDiagnosis = diagnosis.final?.[0] || diagnosis.provisional || "Not specified";
                                      
                                      return (
                                        <DoctorCard
                                          key={index}
                                          hasFooter={false}
                                          cardBody={
                                            <>
                                              {/* Header Section */}
                                              <Box display="flex" justifyContent="space-between" w="100%" alignItems="flex-start" mb="6px">
                                                <Box>
                                                  <Text fontSize="0.875rem" fontWeight="600" color="#061027" mb="2px">
                                                    Discharge Summary
                                                  </Text>
                                                  <Badge 
                                                    colorScheme={item.iscomplete === 1 ? "green" : "orange"} 
                                                    fontSize="0.65rem" 
                                                  >
                                                    {item.iscomplete === 1 ? "COMPLETED" : "DRAFT"}
                                                  </Badge>
                                                </Box>
                                                <Box textAlign="right">
                                                  <Text fontSize="0.75rem" fontWeight="600" color="#061027">
                                                    {formatDate_Do_MMM_YYYY_Time(item.createddate)}
                                                  </Text>
                                                  <Text fontSize="0.7rem" color="#666" mt="2px">
                                                    {item.guid ? `ID: ${item.guid}` : ""}
                                                  </Text>
                                                </Box>
                                              </Box>
                      
                                              {/* Patient Information - Single Line */}
                                              <Box mb="1px">
                                                <Text fontSize="0.75rem" fontWeight="600" color="#061027" display="inline" mr="6px">
                                                  Patient:
                                                </Text>
                                                <Text fontSize="0.75rem" color="#666" display="inline">
                                                  {patientInfo.name || "N/A"} • {patientInfo.age || "N/A"} • {patientInfo.sex || "N/A"}
                                                  {patientInfo.uhid && ` • UHID: ${patientInfo.uhid}`}
                                                </Text>
                                              </Box>
                      
                                              {/* Consultant & Admission Period - Single Line */}
                                              <Box mb="1px" display="flex" justifyContent="space-between" alignItems="center">
                                                <Box flex="1">
                                                  <Text fontSize="0.75rem" fontWeight="600" color="#061027" display="inline" mr="6px">
                                                    Consultant:
                                                  </Text>
                                                  <Text fontSize="0.75rem" color="#666" display="inline">
                                                    {item.doctorname}
                                                    {specialities.length > 0 && ` • ${specialities[0]}`}
                                                    {specialities.length > 1 && "..."}
                                                  </Text>
                                                </Box>
                                                {(admissionDetails.admitted_on || admissionDetails.discharge_date) && (
                                                  <Box textAlign="right" ml="10px" flexShrink={0}>
                                                    <Text fontSize="0.75rem" fontWeight="600" color="#061027" display="inline" mr="4px">
                                                      Stay:
                                                    </Text>
                                                    <Text fontSize="0.7rem" color="#666" display="inline">
                                                      {admissionDetails.admitted_on ? formatAdmissionDate(admissionDetails.admitted_on) : "N/A"} 
                                                      {" - "}
                                                      {admissionDetails.discharge_date ? formatAdmissionDate(admissionDetails.discharge_date) : "N/A"}
                                                    </Text>
                                                  </Box>
                                                )}
                                              </Box>
                      
                                              {/* Primary Diagnosis - Single Line */}
                                              <Box mb="12px">
                                                <Text fontSize="0.75rem" fontWeight="600" color="#061027" display="inline" mr="6px">
                                                  Diagnosis:
                                                </Text>
                                                <Text fontSize="0.75rem" color="#666" display="inline" noOfLines={1}>
                                                  {primaryDiagnosis}
                                                </Text>
                                              </Box>
                      
                                              {/* Compact Audio Player Section */}
                                              {item.audiourl && (
                                                <Box mt="8px" mb="8px" p="6px" bg="blue.50" borderRadius="6px">
                                                  <Box display="flex" alignItems="center" justifyContent="space-between" mb="4px">
                                                    <Text fontSize="0.7rem" fontWeight="600" color="#061027">
                                                      🎧 Recorded Audio
                                                    </Text>
                                                    <Box
                                                      as="button"
                                                      fontSize="0.6rem"
                                                      color="blue.600"
                                                      fontWeight="500"
                                                      onClick={() => {
                                                        // Add play/pause functionality if needed
                                                        const audio = audioPlayerRef.current;
                                                        if (audio) {
                                                          audio.paused ? audio.play() : audio.pause();
                                                        }
                                                      }}
                                                    >
                                                      Play
                                                    </Box>
                                                  </Box>
                                                  <audio
                                                    ref={audioPlayerRef}
                                                    src={item.imagepath + item.audiourl}
                                                    controls
                                                    style={{ 
                                                      width: "100%", 
                                                      height: "30px",
                                                      borderRadius: "4px"
                                                    }}
                                                  />
                                                </Box>
                                              )}
                      
                                              {/* Preview Buttons */}
                                              {/* OPD Discharge */}
                                              {item.iscomplete == 1 && item.ailog != null && (
                                                <Box w="100%" mt="8px" display="flex" gap="8px">
                                                  <Box
                                                    as="button"
                                                    w="50%"
                                                    border="1px solid #E6E7E9"
                                                    p="6px"
                                                    borderRadius="6px"
                                                    height="36px"
                                                    display="flex"
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    bg="white"
                                                    _hover={{ bg: "gray.50" }}
                                                    onClick={() => aiLogPreview(item.ailog)}
                                                  >
                                                    <Box display="flex" fontSize="12px" flexDirection="column" justifyContent="center" fontWeight="500">
                                                      Preview
                                                    </Box>
                                                  </Box>
                                                  <Box
                                                    as="button"
                                                    w="50%"
                                                    border="1px solid #E6E7E9"
                                                    p="6px"
                                                    borderRadius="6px"
                                                    height="36px"
                                                    display="flex"
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    bg="white"
                                                    _hover={{ bg: "gray.50" }}
                                                    onClick={() => downloadSummary(item.ailog)}
                                                  >
                                            <Box display="flex" fontSize="12px" flexDirection="column" justifyContent="center" fontWeight="500">
                                              Download
                                            </Box>
                                          </Box>
                                                </Box>
                                              )}
                      
                                              {/* IPD Discharge */}
                                              {item.iscomplete == 1 && item.ailog == null && (
                                                <Box w="100%" mt="8px" display="flex" gap="8px">
                                                  <Box
                                                    as="button"
                                                    w="50%"
                                                    border="1px solid #E6E7E9"
                                                    p="6px"
                                                    borderRadius="6px"
                                                    height="36px"
                                                    display="flex"
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    bg="white"
                                                    _hover={{ bg: "gray.50" }}
                                                    onClick={() => aiIPDLogPreview(item.aiinput)}
                                                  >
                                                    <Box display="flex" fontSize="12px" flexDirection="column" justifyContent="center" fontWeight="500">
                                                      Preview
                                                    </Box>
                                                  </Box>
                                                  <Box
                                                    as="button"
                                                    w="50%"
                                                    border="1px solid #E6E7E9"
                                                    p="6px"
                                                    borderRadius="6px"
                                                    height="36px"
                                                    display="flex"
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    bg="white"
                                                    _hover={{ bg: "gray.50" }}
                                                    onClick={() => {
                                                      if (item.downloadedpdf) {
                                                        downloadDocument(item.imagepath + item.downloadedpdf, "discharge-notes");
                                                      }
                                                    }}
                                                  >
                                            <Box display="flex" fontSize="12px" flexDirection="column" justifyContent="center" fontWeight="500">
                                              Download
                                            </Box>
                                          </Box>
                                                </Box>
                                              )}
                      
                                              {/* In Process Status */}
                                              {item.iscomplete == 0 && item.issingledocument != 1 && (
                                                <Box mt="8px" p="4px" bg="orange.50" borderRadius="4px">
                                                  <Text fontSize="0.7rem" fontWeight="600" color="orange.600" textAlign="center">
                                                    ⏳ Processing...
                                                  </Text>
                                                </Box>
                                              )}
                                            </>
                                          }
                                        />
                                      );
                                    })
                                  ) : (
                                    <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center" height="calc(100vh - 300px)" width="100%">
                                      <Image boxSize="64px" opacity="0.5" src="/assets/svgs/prescriptions.svg" />
                                      <Text>No Discharge summary Notes found</Text>
                                    </Box>
                                  )}
                                </SimpleGrid>
                              </Box>


<Box w='100%' p="1.5rem 2rem" maxH="calc(100vh - 310px)" overflowY="auto" className="dischargeContainer">
                        <SimpleGrid columns={{ base: 1, lg: dischargeSummary && dischargeSummary.length == 0 ? 1 : 3, xl: dischargeSummary && dischargeSummary.length == 0 ? 1 : 4 }} spacing="1rem">
                          {dischargeSummary && dischargeSummary.length > 0 ? (
                            dischargeSummary.map((item, index) => (
                              // Newly changed Card
                              <DoctorCard
                                hasFooter={false}
                                cardBody={
                                  <>
                                    <Box
                                      key={index}
                                      display="flex"
                                      justifyContent="space-between"
                                      w="100%"
                                      alignItems="flex-start"
                                    >
                                      <Box display="flex" justifyContent='space-between' w='100%' gap="0.75rem">
                                        <Box>
                                        <Text
                                            fontSize="0.875rem"
                                            fontWeight="600"
                                            color="#061027"
                                          >
                                            {formatDate_Do_MMM_YYYY_Time(item.createddate)}
                                          </Text>
                                          <Text
                                            fontSize="0.875rem"
                                            fontWeight="600"
                                            color="#061027"
                                          >
                                            {item.guid ? item.guid : ""}
                                          </Text>
                                          {/* {summaryStatus == 1 && (
                                          <Text
                                            fontSize="0.875rem"
                                            fontWeight="600"
                                            color="#061027"
                                          >
                                            This is still in process...
                                          </Text>
                                          )} */}
                                        </Box>
                                      </Box>
                                    </Box>
                                    {/* {summaryStatus == 1 && item.ailog && item.ailog !== null ? ( */}
                                    {/* OPD Discharge */}
                                     {item.iscomplete == 1 && item.ailog != null &&
                                      <Box w="100%" display="flex" justifyContent="space-between" gap="10px" mt="15px">
                                        <Box
                                          as="button"
                                          w="50%"
                                          border="1px solid #E6E7E9"
                                          p="10px"
                                          borderRadius="10px"
                                          height="50px"
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                          onClick={() => aiLogPreview(item.ailog)}
                                          // onClick={() => aiLogPreview(ailog)}
                                        >
                                          <Box display="flex" fontSize="12px" flexDirection="column" justifyContent="center" fontWeight="500">
                                            Preview
                                          </Box>
                                        </Box>
                                        {/* {item.downloadedpdf && ( */}
                                          <Box
                                            as="button"
                                            w="50%"
                                            border="1px solid #E6E7E9"
                                            p="10px"
                                            borderRadius="10px"
                                            height="50px"
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="center"
                                            onClick={() => downloadSummary(item.ailog)}
                                            // onClick={() => downloadSummary(ailog)}
                                          >
                                            <Box display="flex" fontSize="12px" flexDirection="column" justifyContent="center" fontWeight="500">
                                              Download
                                            </Box>
                                          </Box>
                                        {/* )} */}
                                      </Box>
                                     }
                                     {/* IPD Discharge */}
                                     {item.iscomplete == 1 && item.ailog == null && 
                                      <Box w="100%" display="flex" justifyContent="space-between" gap="10px" mt="15px">
                                        <Box
                                          as="button"
                                          w="50%"
                                          border="1px solid #E6E7E9"
                                          p="10px"
                                          borderRadius="10px"
                                          height="50px"
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                          // onClick={() => aiLogPreview(item.ailog)}
                                          // onClick={() =>
                                          //   window.open(
                                          //     item.imagepath + item.downloadedpdf,
                                          //     "_blank"
                                          //   )
                                          // }
                                          onClick={() => aiIPDLogPreview(item.aiinput)}
                                          // onClick={() => aiLogPreview(ailog)}
                                        >
                                          <Box display="flex" fontSize="12px" flexDirection="column" justifyContent="center" fontWeight="500">
                                            Preview
                                          </Box>
                                        </Box>
                                        {/* {item.downloadedpdf && ( */}
                                          <Box
                                            as="button"
                                            w="50%"
                                            border="1px solid #E6E7E9"
                                            p="10px"
                                            borderRadius="10px"
                                            height="50px"
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="center"
                                            // onClick={() => downloadSummary(item.ailog)}
                                            onClick={() => {
                                              if (item.downloadedpdf) {
                                                downloadDocument(item.imagepath + item.downloadedpdf, "discharge-notes");
                                              }
                                            }}
                                            // onClick={() => downloadSummary(ailog)}
                                          >
                                            <Box display="flex" fontSize="12px" flexDirection="column" justifyContent="center" fontWeight="500">
                                              Download
                                            </Box>
                                          </Box>
                                        {/* )} */}
                                      </Box>
                                     }
                                      {item.iscomplete == 0 && item.issingledocument != 1 &&
                                          <Box>
                                            <Text fontSize="0.875rem" fontWeight="600" color="#061027">
                                              This is still in process...
                                            </Text>
                                        </Box>
                                      }

                                      {/* Horizontal Divider */}
  <Divider my={4} borderColor="#E6E7E9" />

  {/* Audio Player Section */}
  {item.audiourl && (
  <Box mt={4} mb={5} display="flex" flexDirection="column" alignItems="center">
    <Text fontWeight="600" mb={2} fontSize="0.875rem">Listen to your recorded audio:</Text>
    <Box position="relative" width="100%" maxWidth="300px">
      <audio
        ref={audioPlayerRef}
        src={item.imagepath + item.audiourl}
        controls
        style={{ width: "100%" }}
        // onLoadedMetadata={handleAudioLoadedMetadata}
        // onTimeUpdate={handleAudioTimeUpdate}
        // onEnded={handleAudioEnded}
      />
      {/* <Box
        position="absolute"
        bottom="8px"
        right="16px"
        bg="rgba(0,0,0,0.6)"
        color="white"
        px={2}
        py={0.5}
        borderRadius="6px"
        fontSize="0.85em"
        pointerEvents="none"
      >
        {formatAudioTime(audioCurrentTime)} / {formatAudioTime(audioDuration)}
      </Box> */}
    </Box>
  </Box>
)}

                                  </>
                                }
                              />
                            ))
                          ) : (
                            <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center" height="calc(100vh - 300px)" width="100%">
                              <Image boxSize="64px" opacity="0.5" src="/assets/svgs/prescriptions.svg" />
                              <Text>No Discharge summary logs found</Text>
                            </Box>
                          )}
                        </SimpleGrid>
                        {/* Pagination Section */}
                      </Box>
                      {/* Table end */}
                    </>
                  )}

                  {/* vaccinations Tab */}
                    {activeTab == "vaccinations" && (
                      <>
                        <Box gap='10px' p='2rem' w='calc(100vw - 6.5rem)' borderBottom="1px solid #E6E7E9" display='flex' flexDirection='row' justifyContent='flex-start' alignItems='center'>
                          <Box w="40%">
                          <PrimaryInput
                            variant="fullRound"
                            title="Name"
                            inputPlace="Search by Vaccine name, email, patient name"
                            id="yourName"
                            onKeyDown={handleKeyDown}
                            onChange={handleChangeVaccinationName}
                            inputValue={userNameVaccine}
                          />

                          </Box>
                          {/* <DropdownInput
                            variant="fullSide"
                            dropDownPlace="Age Group"
                            options={['1-5', '6-10', '11-15', '16-20', '21-25', '26-30', '31-35', '36-40', '41-45', '46+']}
                            readOnly={true}
                            onClick={handleChangeAgeGroup}
                            value={ageGroupType}
                            menuList={{ pos: "absolute", right: "-45px", minW: "115px" }}
                          // inputStyleCss={{w: "80%"}}
                          />
                          <DropdownInput
                            variant="fullSide"
                            dropDownPlace="Time Factor"
                            options={['Last 15 Days', 'Last 30 Days', 'Last 45 Days', 'Last 60 Days', 'Last 75 Days', 'Last 90 Days']}
                            readOnly={true}
                            onClick={handleChangeTimeFactor}
                            value={timeFactor}
                            menuList={{ pos: "absolute", right: "-45px", minW: "135px" }}
                          // inputStyleCss={{w: "80%"}}
                          />
                          <DropdownInput
                            variant="fullSide"
                            dropDownPlace="Status"
                            options={["Prescribed", "Registered", "Sample Collected", "In Transit", "Processing", "Validation Pending", "Under Review", "Provisional Report Ready", "Signed Off", "Report Available", "Notified"]}
                            readOnly={true}
                            onClick={handleLabChangeStatus}
                            value={labStatusType}
                            menuList={{ pos: "absolute", right: "-45px", minW: "235px" }}
                          // inputStyleCss={{w: "80%"}}
                          /> */}

                          <Box gap='10px' pl='1rem' w='15vw' display='flex' flexDirection='row' justifyContent='center' alignItems='center'>
                            <PrimaryButton buttonText="Filter" id="filterButton"
                              onClick={handleVaccinationsApplyFilters}
                            />
                            <PrimaryButton buttonText="Reset" id="resetButton" variant="grayBtnFull" btnStyle={{ color: "#AA2F27" }}
                              onClick={vaccinationResetFields}
                            />
                          </Box>

                        </Box>

                        <Box w='100%' p="1.5rem 2rem" maxH="calc(100vh - 310px)" overflowY="auto" className="labContainer">
  <SimpleGrid columns={{ base: 1, lg: vaccinationsViewData && vaccinationsViewData.length == 0 ? 1 : 3, xl: vaccinationsViewData && vaccinationsViewData.length == 0 ? 1 : 4 }} spacing="1rem">
    {vaccinationsViewData && vaccinationsViewData.length > 0 ? (
      vaccinationsViewData.map((item, index) => (
        <DoctorCard
          hasFooter={false}
          cardBody={
            <>
              {/* Header section with order name and status */}
              <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb="0.5rem">
                <Box>
                  <Box w="100%" maxW="10rem" isTruncated>
                                          <Text
                                            fontSize="0.875rem"
                                            fontWeight="600"
                                            color="#061027"
                                            className="textOverflow"
                                            title={item.vaccinename}
                                          >
                                            {/* {item.ordername} */}
                                            {item.vaccinename ? item.vaccinename : "-"}
                                          </Text>
                                        </Box>
                  {/* <Text fontSize="1rem" fontWeight="600" color="#061027">
                    {item.ordername}
                  </Text> */}
                  <Text fontSize="0.75rem" fontWeight="500" color="#384052">
                    {item.nextdosagedate ? formatDate_Do_MMM_YYYY(item.nextdosagedate) : "-"}
                  </Text>
                </Box>

                {/* view Logs */}
                <Box
                                          as="button"
                                          border="1px solid #E6E7E9"
                                          borderRadius="full"
                                          w="36px"
                                          h="36px"
                                          p="6px"
                                          display="flex"
                                          justifyContent="center"
                                          alignItems="center"
                                          onClick={() => viewVaccineLogs(item.orderid)}
                                          title={item.logcount == 0 ? 'No Logs' : 'View Logs'}
                                          disabled={item.logcount == 0}
                                        >
                                          <Image minW='20px' w="100%" h='16px' src="/assets/svgs/reports-filled.svg" />
                                        </Box>
              </Box>

                                      <Box
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems='center'
                                        w="100%"
                                        // alignItems="flex-start"
                                        mt='0.75rem'
                                        //flexDir='column'
                                      >
                                        <Text fontSize='0.75rem' fontWeight='600'>
                                          Reminder sent: {item.logcount ? item.logcount : 0}
                                        </Text>
                                        {/* {item.patientacceptedcount > 0 &&
                                        <Text fontSize='0.75rem' fontWeight='600'>
                                          Status: {item.patientacceptedcount > 0 ? "Accepted" : ""}
                                        </Text>
                                        }  */}
                                        

                                      {/* {item.documenturl == null ? (
                                        <Box
                                          as="button"
                                          fontSize="0.875rem"
                                          fontWeight="700"
                                          textDecor="underline"
                                          position="relative" 
                                        >
                                          <input
                                            type="file"
                                            id={`genericupload-${item.appointmentid}-${item.orderid}`}
                                            style={{
                                              position: 'absolute',
                                              width: '1px',
                                              height: '1px',
                                              padding: 0,
                                              margin: '-1px',
                                              overflow: 'hidden',
                                              clip: 'rect(0, 0, 0, 0)',
                                              whiteSpace: 'nowrap',
                                              border: 0,
                                            }}
                                            accept="image/jpeg,image/jpg,image/png,image/tiff,application/pdf"
                                            onChange={(e) => GenericUpload(e, item.appointmentid, item.patientid, item.orderid)}
                                            multiple
                                          />
                                          
                                          <Box
                                            as="span"
                                            onClick={() => {
                                              document.getElementById(`genericupload-${item.appointmentid}-${item.orderid}`)?.click();
                                            }}
                                          >
                                            Upload document
                                          </Box>
                                        </Box>

                                  ) : (
                                    <Box
                                                  as="button"
                                                  w="40%"
                                                  border="1px solid #E6E7E9"
                                                  p="0.75rem"
                                                  borderRadius="8px"
                                                  fontWeight="600"
                                                  fontSize="0.875rem"
                                                  display="flex"
                                                  alignItems="center"
                                                  justifyContent="center"
                                                  gap="0.5rem"
                                                  onClick={() => window.open(item.imagepath + item.documenturl)}
                                                >
                                                  Preview
                                                </Box>
)} */}
                                      
                                    </Box>

              <Divider my="0.75rem" borderColor="#E6E7E9" />

              {/* Doctor and patient info */}
              <Box display='flex' flexDir="column" gap="0.5rem" mb="1rem">
                {/* <Box display="flex" alignItems="center" gap="0.5rem">
                  <Image w="12px" h="13px" src="/assets/svgs/stethoscope.svg" />
                  <Text fontSize="0.75rem" fontWeight="500">{item.doctorname}</Text>
                </Box> */}
                <Box display="flex" alignItems="center" gap="0.5rem">
                  <Image filter={COLORS.BLUE_FILTER} w="12px" h="13px" src="/assets/svgs/patient.svg" />
                  <Text fontSize="0.75rem" fontWeight="500">{item.patientname}</Text>
                </Box>
                {/* <Box display="flex" alignItems="center" gap="0.5rem">
                  <Image w="13px" h="10px" src="/assets/svgs/hospital.svg" />
                  <Text fontSize="0.75rem" fontWeight="500">{item.hospital}</Text>
                </Box>
                <Box display="flex" alignItems="center" gap="0.5rem">
                  <Image w="13px" h="10px" src="/assets/svgs/location-blue.svg" />
                  <Text fontSize="0.75rem" fontWeight="500">
                    {(item.address === null || item.address === '') && (item.city === null || item.city === '') && (item.country === null || item.country === '') ? 
                      '-' : 
                      `${item.address || ''}${item.address && item.city ? ', ' : ''}${item.city || ''}${(item.city && item.country) || (item.address && item.country) ? ', ' : ''}${item.country || ''}`
                  }
                  </Text>
                </Box> */}
              </Box>

              {/* Book Appointment Button */}
              {/* <Box w='100%' mb="1rem">
  <PrimaryButton 
    buttonText={item.appointmentdate && item.appointmenttime ? `Appointment Date: ${formatDate(item.appointmentdate)}, ${to12HourFormat(item.appointmenttime)}` : "Book an Appointment"}
    id="filterButton"
    variant='mdBtn'
    btnStyle={{
      w: '100%',
      bg: item.appointmentdate && item.appointmenttime ? 'rgb(20, 197, 133)' : '#d69e2e',
      _hover: {
        bg: item.appointmentdate && item.appointmenttime ? 'rgb(16, 167, 113)' : '#b7790f'
      }
    }}
    onClick={() => openBookAppointmentModal(item)}
  />
</Box> */}

              {/* Notify/Remind Button */}
              <Box display='flex' justifyContent='space-between' alignItems='center'>
                {/* Checkmarks row */}
              <Box display="flex" justifyContent="space-between" alignItems="center" mb="1rem" w="50%">
                {[1, 2, 3, 4, 5].map((check) => (
                  <Box
                    key={check}
                    w="24px"
                    h="24px"
                    borderRadius="50%"
                    border={check <= item.logcount ? "1px solid #14C585" : "1px solid #E6E7E9"}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    bg={check <= item.logcount ? "#E6F5EE" : "transparent"}
                  >
                    {check <= item.logcount && (
                      <Image 
                        src="/assets/imgs/success-alert.png" 
                        w="24px" 
                        h="24px" 
                        alt="completed step"
                      />
                    )}
                  </Box>
                ))}
              </Box>

              <Box
                as="button"
                w="40%"
                border="1px solid #E6E7E9"
                p="0.75rem"
                borderRadius="8px"
                fontWeight="600"
                fontSize="0.875rem"
                display="flex"
                alignItems="center"
                justifyContent="center"
                gap="0.5rem"
                onClick={() => openVaccineNotificationData(item)}
              >
                {/* <Image src="/assets/svgs/bell-icon.svg" w="16px" h="16px" /> */}
                Notify / Remind
              </Box>
              </Box>

              {/* <Box display="flex" alignItems="center" pr="20px" mt="15px">                      
                <input
                  type="file"
                  id={`genericupload-${item.appointmentid}-${item.orderid}`}
                  style={{ display: 'none' }}
                  accept="image/jpeg,image/jpg,image/png,image/tiff,application/pdf"
                  onChange={(e) => GenericUpload(e, item.appointmentid, item.patientid, item.orderid)}
                  multiple
                />

               <PrimaryInput
                  inputType="file"
                  uploadText="Upload document"
                  id={`genericupload-${item.appointmentid}-${item.orderid}`}
                  docBtnWidth="195px"
                  docBtnColor="#1C4EC5"
                  iconImg="/assets/svgs/prescriptions.svg"
                  iconImgCss={{
                    width: "30px",
                    height: "auto",
                    color: "#1C4EC5",
                    filter:
                      "brightness(0) saturate(100%) invert(24%) sepia(84%) saturate(2247%) hue-rotate(215deg) brightness(83%) contrast(96%)",
                  }}
                  onClick={() => {
                    document
                      .getElementById(`genericupload-${item.appointmentid}-${item.orderid}`)
                      ?.click();
                  }}
                  variant="grayBtnFull"
                />                                                 
                </Box> */}
            </>
          }
        />
      ))
    ) : (
      <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center" height="calc(100vh - 300px)" width="100%">
        <Image boxSize="64px" opacity="0.5" src="/assets/svgs/prescriptions.svg" />
        <Text>No Vaccinations found</Text>
      </Box>
    )}
  </SimpleGrid>
</Box>
                        {vaccinationsViewData && vaccinationsViewData.length > 0 && (
                          <Box w="100%" display="flex" boxShadow="rgba(0, 0, 0, 0.15) 0px 5px 15px 0px" justifyContent="space-between" alignItems="center" p='1rem' pl='2rem' pos='fixed' bottom='0' bg='white'>
                            <Box
                              visibility={(totalItemCount < countTo && !totalExceedsPageCount) ? "hidden" : "visible"}
                            >
                              <Text>Showing  <b>{countFrom}</b> to <b>{countTo}</b>  of {totalItemCount} results</Text>
                            </Box>
                            <Box
                              gap="2.5rem"
                              display="flex"
                              justifyContent="space-between"
                              alignItems="center"
                              mr='120px'>
                              <Box visibility={currentPage === 1 ? 'hidden' : 'visible'} currentPage={currentPage}
                              // onPageChange={handlePageChange}
                              >

                                <Box as="button" onClick={handlePreviousClick} p="0.5rem 0.75rem" border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" fontSize="1rem" fontWeight="500">
                                  Previous
                                </Box>
                              </Box>
                              <Text textAlign="center" fontSize=".875rem" fontWeight="600">
                                Page {currentPage} of {totalPages}
                              </Text>
                              {(totalItemCount >= countTo && !totalExceedsPageCount) &&
                                <Box
                                // visibility={currentPage === totalPages ? 'hidden' : 'visible'}
                                >

                                  <Box as="button" onClick={handleNextClick} p="0.5rem 0.75rem" border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" fontSize="1rem" fontWeight="500">
                                    Next
                                  </Box>
                                </Box>
                              }
                            </Box>
                          </Box>
                        )}
                        {/* Table end */}
                      </>
                    )}

                </Box>
              </Flex>
            </Box>
          </Flex>
        ) : (
          <>
            <MobileNavbar />
            <MobileSecondaryNav header='Orders' handlebackarrow={() => navigate('/home')} />
            {/* Tab buttons start */}
            <Box
              display="flex"
              gap="1rem"
              borderBottom="1px solid #E6E7E9"
              bg="white"
              p="1.25rem 1.5rem"
              overflow='scroll hidden'
            >
              <Box
                as="button"
                display="flex"
                justifyContent="center"
                alignItems="center"
                pos="relative"
                className={activeTab == "prescriptions" ? "activeTab" : ""}
                fontSize="0.87rem"
                fontWeight="600"
                onClick={() => tabChanged("prescriptions")}
                color={activeTab == "prescriptions" ? "#061027" : "#898D97"}
              >
                <Text>Prescriptions</Text>
                <Box as="span" className="whiteBorder" />
              </Box>
              <Box
                      as="button"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      pos="relative"
                      className={activeTab == "followups" ? "activeTab" : ""}
                      fontSize="0.87rem"
                      fontWeight="600"
                      onClick={() => tabChanged("followups")}
                      color={activeTab == "followups" ? "#061027" : "#898D97"}
                    >
                      <Text>Followups</Text>
                      <Box as="span" className="whiteBorder" />
                    </Box>
              <Box
                as="button"
                display="flex"
                justifyContent="center"
                alignItems="center"
                pos="relative"
                className={activeTab == "labs" ? "activeTab" : ""}
                fontSize="0.87rem"
                fontWeight="600"
                onClick={() => tabChanged("labs")}
                color={activeTab == "labs" ? "#061027" : "#898D97"}
              >
                <Text>Labs</Text>
                <Box as="span" className="whiteBorder" />
              </Box>
              <Box
                as="button"
                display="flex"
                justifyContent="center"
                alignItems="center"
                pos="relative"
                className={activeTab == "imaging" ? "activeTab" : ""}
                fontSize="0.87rem"
                fontWeight="600"
                onClick={() => tabChanged("imaging")}
                color={activeTab == "imaging" ? "#061027" : "#898D97"}
              >
                <Text>Imaging</Text>
                <Box as="span" className="whiteBorder" />
              </Box>
              <Box
                as="button"
                display="flex"
                justifyContent="center"
                alignItems="center"
                pos="relative"
                className={activeTab == "procedures" ? "activeTab" : ""}
                fontSize="0.87rem"
                fontWeight="600"
                onClick={() => tabChanged("procedures")}
                color={activeTab == "procedures" ? "#061027" : "#898D97"}
              >
                <Text>Procedures</Text>
                <Box as="span" className="whiteBorder" />
              </Box>
              <Box
                as="button"
                display="flex"
                justifyContent="center"
                alignItems="center"
                pos="relative"
                className={activeTab == "discharge" ? "activeTab" : ""}
                fontSize="0.87rem"
                fontWeight="600"
                onClick={() => tabChanged("discharge")}
                color={activeTab == "procedures" ? "#061027" : "#898D97"}
              >
                <Text>Discharge Summary Notes</Text>
                <Box as="span" className="whiteBorder" />
              </Box>
              <Box
                      as="button"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      pos="relative"
                      className={activeTab == "vaccinations" ? "activeTab" : ""}
                      fontSize="0.87rem"
                      fontWeight="600"
                      onClick={() => tabChanged("vaccinations")}
                      color={activeTab == "vaccinations" ? "#061027" : "#898D97"}
                    >
                      <Text>Vaccinations</Text>
                      <Box as="span" className="whiteBorder" />
                    </Box>
            </Box>
            {/* Tab buttons end */}


            {/* Prescriptions tab */}
            {activeTab == "prescriptions" && (
              <>
                <Box gap='10px' p='1rem' w='100%' borderBottom="1px solid #E6E7E9" display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
                  <PrimaryInput
                    variant="fullRound"
                    title="Name"
                    inputPlace="Name"
                    id="yourName"
                    onKeyDown={handleKeyDown}
                    onChange={handleChangePrescriptionName}
                    inputValue={userNamePrescription}
                  />
                  <Box onClick={onToggle}>
                    <Image
                      w='50px'
                      cursor='pointer'
                      src={isOpen ? "assets/svgs/outline-f.svg" : "assets/svgs/filled-f.svg"}
                    />
                  </Box>
                  <Box w='100%' display='flex' flexDirection='row' justifyContent='flex-end' alignItems='center' gap='0.875rem'>
                    <PrimaryButton buttonText="Filter" id="filterButton" btnStyle={{ w: 'max-content' }}
                      onClick={handlePrescriptionsApplyFilters}
                    />
                    <PrimaryButton buttonText="X" id="resetButton" variant="grayBtnFull" btnStyle={{ color: "#AA2F27", w: 'max-content' }}
                      onClick={prescriptionResetFields}
                    />
                  </Box>
                </Box>
                <Collapse in={isOpen} animateOpacity style={{ overflow: 'visible' }}>
                  <Box w="100%" display="flex" p='1rem' flexDir='column' gap="10px">
                    <PrimaryInput
                      variant="fullRound"
                      title="Email"
                      inputPlace="Email"
                      id="yourEmail"
                      onKeyDown={handleKeyDown}
                      onChange={handleChangePrescriptionEmail}
                      inputValue={prescriptionEmail}
                    />
                    <DatePicker
                      onDateChange={(selectedDateValue) =>
                        handleFromDate(selectedDateValue)
                      }
                      placeholderProp="From Date"
                      datePickerInputStyle={{ borderRadius: "10px 10px 10px 10px" }}
                      value={fromDate}
                      clearValue={true}

                      CUSTOM_DISABLE={true}
                      disableFutureDates={true}
                      maxDate={toDateMinMax}
                    />
                    <DatePicker
                      onDateChange={(selectedDateValue) =>
                        handleToDate(selectedDateValue)
                      }
                      placeholderProp="To Date"
                      datePickerInputStyle={{ borderRadius: "10px 10px 10px 10px " }}
                      value={toDate}
                      clearValue={true}

                      CUSTOM_DISABLE={true}
                      maxDate={new Date().toISOString()}
                      minDate={fromDateMinMax}
                    />

                    <Box w='100%' display='flex' flexDirection='row' justifyContent='center' alignItems='center' gap='0.875rem'>
                      <PrimaryButton buttonText="Filter" id="filterButton"
                        onClick={handlePrescriptionsApplyFilters}
                      />
                      <PrimaryButton buttonText="Reset" id="resetButton" variant="grayBtnFull" btnStyle={{ color: "#AA2F27" }}
                        onClick={prescriptionResetFields}
                      />
                    </Box>
                  </Box>
                </Collapse>




                <Box w='100%' p="1rem" maxH="calc(100vh - 340px)" overflowY="auto" className="prescriptionContainer">
                  <SimpleGrid columns={{ base: 1, md: 2 }} spacing="1rem">
                    {prescriptionViewdata && prescriptionViewdata.length > 0 ? (
                      prescriptionViewdata.map((item, index) => (
                        <DoctorCard
                          key={index}
                          hasFooter={false}
                          cardBody={
                            <>
                              <Box
                                display="flex"
                                justifyContent="space-between"
                                w="100%"
                                alignItems="flex-start"
                              >

                                <Box display="flex" gap="0.75rem">
                                  <Image
                                    borderRadius="full"
                                    w="2.75rem"
                                    h="2.75rem"
                                    src={item.patientimage ?
                                      (item.patientimage.startsWith('https') ? item.patientimage : item.imagepath + item.patientimage)
                                      : '/assets/imgs/no-image.png'}
                                  />
                                  <Box p="10px">
                                    <Text
                                      fontSize="0.875rem"
                                      fontWeight="600"
                                      color="#061027"
                                      title={item.patientname}
                                    >
                                      {item.patientname}
                                    </Text>
                                  </Box>
                                </Box>
                                <Text
                                  fontSize="0.75rem"
                                  fontWeight="500"
                                  color="#384052"
                                >
                                  {formatDate_Do_MMM_YYYY(item.prescribeddate)}
                                </Text>
                              </Box>

                              <Divider my="0.75rem" />
                              <Flex gap="8px" align="center" justifyContent='space-between'>
                                <Text fontSize="12px" fontWeight="500">
                                  {item.doctorname ? item.doctorname : "-"}
                                </Text>
                                <Text fontSize="12px" fontWeight="500">
                                  {item.doctoremail ? item.doctoremail : "-"}
                                </Text>

                              </Flex>
                              <Flex mt='10px' gap="8px" align="center" justifyContent='space-between'>
                                <Text fontSize="12px" fontWeight="500">
                                  {item.bookingid ? "#" + item.bookingid : "-"}
                                </Text>
                              </Flex>

                              <Box w="100%" display='flex' gap='10px'>
                                <Box
                                  as="button"
                                  onClick={() => window.open(item.imagepath + item.prescriptionurl)}
                                  w="50%"
                                  border="1px solid #E6E7E9"
                                  p="10px"
                                  borderRadius="10px"
                                  mt="15px"
                                  height="50px"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center">
                                  <Box
                                    display="flex"
                                    fontSize="12px"
                                    flexDirection="column"
                                    justifyContent="center"
                                    fontWeight="500"
                                  >
                                    Preview

                                  </Box>
                                </Box>
                                <Box
                                  as="button"
                                  onClick={() => downloadDocument(item.imagepath + item.prescriptionurl, "Order")}

                                  w="50%"
                                  border="1px solid #E6E7E9"
                                  p="10px"
                                  borderRadius="10px"
                                  mt="15px"
                                  height="50px"
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center">
                                  <Box
                                    display="flex"
                                    fontSize="12px"
                                    flexDirection="column"
                                    justifyContent="center"
                                    fontWeight="500"
                                  >
                                    Download

                                  </Box>
                                </Box>
                              </Box>
                            </>
                          }
                        />
                      ))
                    ) : (
                      <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center" height="calc(100vh - 300px)" width="100%">
                        <Image boxSize="64px" opacity="0.5" src="/assets/svgs/prescriptions.svg" />
                        <Text>No Prescriptions found</Text>
                      </Box>
                    )}
                  </SimpleGrid>
                  {/* Pagination Section */}
                </Box>
                {/* Table end */}
              </>
            )}

            {/* Followups tab */}
            {activeTab == "followups" && (
                    <>
                      <Box gap='10px' p='2rem' w='100%' borderBottom="1px solid #E6E7E9" display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
                        <PrimaryInput
                          variant="fullRound"
                          title="Name"
                          inputPlace="Name"
                          id="yourName"
                          onKeyDown={handleKeyDown}
                          onChange={handleChangeFollowupName}
                          inputValue={userNameFollowup}
                        />
                        <Box onClick={onToggle}>
                    <Image
                      w='50px'
                      cursor='pointer'
                      src={isOpen ? "assets/svgs/outline-f.svg" : "assets/svgs/filled-f.svg"}
                    />
                  </Box>

                        <Box gap='10px' pl='1rem' w='70vw' display='flex' flexDirection='row' justifyContent='center' alignItems='center'>
                          <PrimaryButton buttonText="Filter" id="filterButton"
                            onClick={handleFollowupsApplyFilters}
                          />
                          <PrimaryButton buttonText="Reset" id="resetButton" variant="grayBtnFull" btnStyle={{ color: "#AA2F27" }}
                            onClick={followupResetFields}
                          />
                        </Box>

                        {/* <Box gap='10px' pl='2rem' w='70vw' display='flex' flexDirection='row' justifyContent='center' alignItems='center'>
                          <PrimaryButton
                            //isDisabled={showFilterCount ? false : true} 
                            buttonText="Send Notification" onClick={openNotificationCustomMessage}
                          />
                        </Box> */}

                      </Box>

                      <Collapse in={isOpen} animateOpacity style={{ overflow: 'visible' }}>
{/* <Box w='800px'> */}
<DatePicker
                            // defaultDate={procedureDate}
                            onDateChange={(selectedDateValue) =>
                              handleFollowupFromDate(selectedDateValue)
                            }
                            placeholderProp="From Date"
                            datePickerInputStyle={{ borderRadius: "10px 10px 10px 10px" }}
                            value={fromDateFollowup}
                            clearValue={true}

                            CUSTOM_DISABLE={true}
                            disableFutureDates={true}
                            maxDate={toDateMinMaxFollowup}
                          />
                        {/* </Box> */}
                        {/* <Box w='800px'> */}
                          <DatePicker
                            onDateChange={(selectedDateValue) =>
                              handleFollowupToDate(selectedDateValue)
                            }
                            placeholderProp="To Date"
                            datePickerInputStyle={{ borderRadius: "10px 10px 10px 10px " }}
                            value={toDateFollowup}
                            clearValue={true}

                            CUSTOM_DISABLE={true}
                            // maxDate={new Date().toISOString()}
                            minDate={fromDateMinMaxFollowup}

                          />
                        {/* </Box> */}
                      </Collapse>

                      <Box w='100%' p="1.5rem 2rem" maxH="calc(100vh - 310px)" overflowY="auto" className="labContainer">
                        <SimpleGrid columns={{ base: 1, lg: followupViewData && followupViewData.length == 0 ? 1 : 3, xl: followupViewData && followupViewData.length == 0 ? 1 : 4 }} spacing="1rem">
                          {followupViewData && followupViewData.length > 0 ? (
                            followupViewData.map((item, index) => {
                              const isPastFollowup = new Date(item.followupdate) < new Date();
                              return (
                              <DoctorCard
                                hasFooter={false}
                                cardBody={
                                  <>
                                    <Box
                                      key={index}
                                      display="flex"
                                      justifyContent="space-between"
                                      flexDir='column'
                                      w="100%"
                                      alignItems="flex-start"
                                    >
                                      <Box display="flex" justifyContent='space-between' w='100%' gap="0.75rem">
                                        <Box>
                                      <Box display="flex" gap="0.75rem">
                                        <Image
                                          borderRadius="full"
                                          w="2.75rem"
                                          h="2.75rem"
                                          src={item.doctorimage ?
                                            (item.doctorimage.startsWith('https') ? item.doctorimage : item.imagepath + item.doctorimage)
                                            : '/assets/imgs/no-image.png'}
                                        />

<Box>

                                        <Box w="100%" maxW="20rem" isTruncated>
                                          <Text
                                            fontSize="0.875rem"
                                            fontWeight="600"
                                            color="#061027"
                                            className="textOverflow"
                                            title={item.specality}
                                          >
                                            {item.specality}
                                          </Text>
                                        </Box>
                                          {/* <Text
                                            fontSize="0.625rem"
                                            fontWeight="500"
                                            color="#384052"
                                          >
                                            {formatDate_Do_MMM_YYYY(item.followupdate)}
                                          </Text> */}
                                          <Text fontSize='0.75rem' fontWeight='600'>
                                          {item.isfreevisit == 1 ? "Visit Type: Free" : "Visit Type: Paid"}
                                        </Text>

</Box>
                                          {/* <Text fontSize='0.75rem' fontWeight='600'>
                                          Reminder sent: {item.logcount ? item.logcount : 0}
                                        </Text> */}
                                        </Box>
                                        </Box>
                                        {/* <Box
                                          as="button"
                                          border="1px solid #E6E7E9"
                                          borderRadius="full"
                                          w="36px"
                                          h="36px"
                                          p="6px"
                                          display="flex"
                                          justifyContent="center"
                                          alignItems="center"
                                          onClick={() => viewLogs(item.orderid)}
                                          title={item.logcount == 0 ? 'No Logs' : 'View Logs'}
                                          disabled={item.logcount == 0}
                                        >
                                          <Image minW='20px' w="100%" h='16px' src="/assets/svgs/reports-filled.svg" />
                                        </Box> */}

{/* <Box w='fit-content'>
                            {item.isfreevisitbooked && item.isfreevisitbooked === 1 ? (
                              <Text
                              fontSize="0.75rem"
                              borderRadius="full"
                              fontWeight="600"
                              p="0.25rem 0.5rem"
                              border="1px solid #E6E7E9"
                              // bg='#14C585'
                              bg="#E6E7E966"
                              color='rgb(0,151,0)'
                            >
                              Present
                            </Text>
                            ) : (
                              <Text
                                fontSize="0.75rem"
                                borderRadius="full"
                                fontWeight="600"
                                p="0.25rem 0.5rem"
                                border="1px solid #E6E7E9"
                                // bg='#F044383D'
                                bg="#E6E7E966"
                                // color='#E6E7E966'
                                // color='rgb(255,165,0)'
                                // color='#FA594E'
                                // bg='#032217' for approve
                                // color='#14C585' for approve
                              >
                                Past
                              </Text>
                            )}
                           </Box> */}
                                      </Box>
                                      <Box
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems='center'
                                        w="100%"
                                        // alignItems="flex-start"
                                        mt='0.75rem'
                                        //flexDir='column'
                                      >
                                        {/* <Text fontSize='0.75rem' fontWeight='600'>
                                          {item.isfreevisit == 1 ? "Free" : "Paid"}
                                        </Text> */}
                                        
                                        {/* <Text fontSize='0.75rem' fontWeight='600'>
                                          {item.isfreevisitbooked == 1 ? "Present" : "Past"}
                                        </Text> */}
                                      
                                    </Box>
                                    {/* {item.patientacceptedcount > 0 && */}
                                    {/* <Text fontSize='0.75rem' fontWeight='600'>
                                          Followup Date: {item.followupdate ? formatDate_Do_MMM_YYYY_Time(item.followupdate) : ""}
                                        </Text> */}
                                     {/* }  */}

                                     <Box w='fit-content'>
                            {/* {item.isPastFollowup ? ( */}
                            { new Date(item.followupdate) > new Date() ? (
                              <Text
                              fontSize="0.75rem"
                              // borderRadius="full"
                              fontWeight="600"
                              // p="0.25rem 0.5rem"
                              // border="1px solid #E6E7E9"
                              // // bg='#14C585'
                              // bg="#E6E7E966"
                              color='rgb(0,151,0)'
                            >
                              Followup Date: {item.followupdate ? formatDate_Do_MMM_YYYY_Time(item.followupdate) : ""}
                            </Text>
                            ) : (
                              <Text
                                fontSize="0.75rem"
                                // borderRadius="full"
                                fontWeight="600"
                                // p="0.25rem 0.5rem"
                                // border="1px solid #E6E7E9"
                                // bg='#F044383D'
                                // bg="#E6E7E966"
                                // color='grey'
                                color='gray'
                                // color='rgb(255,165,0)'
                                // color='#FA594E'
                                // bg='#032217' for approve
                                // color='#14C585' for approve
                              >
                                Followup Date: {item.followupdate ? formatDate_Do_MMM_YYYY_Time(item.followupdate) : ""}
                              </Text>
                            )}
                           </Box>
                                    </Box>

                                    <Divider my="0.75rem" />

                                    <Box display='flex' flexDir="column">
                                      <Box display="flex" alignItems="center" gap="0.5rem">
                                        <Image w="12px" h="13px" src="/assets/svgs/stethoscope.svg" />
                                        <Text fontSize="0.75rem" fontWeight="500">{item.doctorname}</Text>
                                      </Box>
                                      {/* <Box display="flex" alignItems="center" gap="0.5rem">
                                        <Image filter={COLORS.BLUE_FILTER} w="12px" h="13px" src="/assets/svgs/patient.svg" />
                                        <Text fontSize="0.75rem" fontWeight="500">{item.patientname}</Text>
                                      </Box> */}
                                      {/* <Box display="flex" alignItems="center" gap="0.5rem">
                                        <Image w="13px" h="10px" src="/assets/svgs/hospital.svg" />
                                        <Text fontSize="0.75rem" fontWeight="500">{item.hospital}</Text>
                                      </Box>
                                      <Box display="flex" alignItems="center" gap="0.5rem">
                                        <Image w="13px" h="10px" src="/assets/svgs/location-blue.svg" />
                                        <Text fontSize="0.75rem" fontWeight="500">{(item.address === null || item.address === '') && (item.city === null || item.city === '') && (item.country === null || item.country === '') ? '-' : `${item.address || ''}${item.address && item.city ? ', ' : ''}${item.city || ''}${(item.city && item.country) || (item.address && item.country) ? ', ' : ''}${item.country || ''}`}</Text>


                                      </Box> */}
                                    </Box>

                                    <Box w="100%" display="flex" justifyContent="space-between" gap="10px" mt="15px">
                                      <Box
                                        as="button"
                                        key={index}
                                        w="100%"
                                        border="1px solid #E6E7E9"
                                        p="10px"
                                        borderRadius="10px"
                                        height="50px"
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                        onClick={() => openNotificationModal(
                                          {
                                            patientid: item.patientid,
                                            patientfcmtoken: item.patientfcmtoken,
                                            patientname: item.patientname,
                                            doctorname: item.doctorname,
                                            orderid: item.followupid,
                                            doctorid: item.doctorid,
                                            followupdate: item.followupdate
                                          }
                                        )}
                                      //   onClick={() => openNotificationCategory(item.ordername, {
                                      //     patientid: item.patientid,
                                      //     patientfcmtoken: item.patientfcmtoken,
                                      //     patientname: item.patientname,
                                      //     doctorname: item.doctorname,
                                      //     orderid: item.orderid,
                                      //     entitytype: item.entitytype,
                                      //     aicontent: item.aicontent
                                      // })}
                                      >
                                        <Box display="flex" fontSize="12px" flexDirection="column" justifyContent="center" fontWeight="500">
                                          Send Notification
                                        </Box>
                                      </Box>
                                    </Box>

                                    <Box w="100%">
                                      {/* <Box
                                as="button"
                                // onClick={onClick}
                                w="100%"
                                border="1px solid #E6E7E9"
                                p="10px"
                                borderRadius="10px"
                                mt="15px"
                                height="50px"
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between">
                                <Box
                                  display="flex"
                                  fontSize="12px"
                                  flexDirection="column"
                                  justifyContent="center"
                                  fontWeight="500"
                                >
                                2 documents
                                </Box>
                                <Box borderRadius="full" p="10px">
                                  <Image w="8px" src="/assets/imgs/right-icon.png" />
                                </Box>
                              </Box> */}
                                    </Box>
                                  </>
                                }
                              />
                            )})
                          ) : (
                            <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center" height="calc(100vh - 300px)" width="100%">
                              <Image boxSize="64px" opacity="0.5" src="/assets/svgs/prescriptions.svg" />
                              <Text>No Followups found</Text>
                            </Box>
                          )}
                        </SimpleGrid>
                        {/* Pagination Section */}
                      </Box>
                      {/* Table end */}
                    </>
                  )}

            {/* Labs Tab */}
            {activeTab == "labs" && (
              <>
                <Box gap='10px' p='1rem' w='100%' borderBottom="1px solid #E6E7E9" display='flex' flexDirection='row' justifyContent='center' alignItems='center'>
                  <PrimaryInput
                    variant="fullRound"
                    title="Name"
                    inputPlace="Name"
                    id="yourName"
                    onKeyDown={handleKeyDown}
                    onChange={handleChangelabName}
                    inputValue={userNameLab}
                  />
                  <Box onClick={onToggle}>
                    <Image
                      w='50px'
                      cursor='pointer'
                      src={isOpen ? "assets/svgs/outline-f.svg" : "assets/svgs/filled-f.svg"}
                    />
                  </Box>
                  <Box w='100%' display='flex' flexDirection='row' justifyContent='center' alignItems='center' gap='0.875rem'>
                    <PrimaryButton buttonText="Filter" id="filterButton"
                      onClick={handleLabsApplyFilters}
                    />
                    <PrimaryButton buttonText="Reset" id="resetButton" variant="grayBtnFull" btnStyle={{ color: "#AA2F27" }}
                      onClick={labResetFields}
                    />
                  </Box>
                </Box>
                <Collapse in={isOpen} animateOpacity style={{ overflow: 'visible' }}>
                  <Box w="100%" display="flex" p='1rem' flexDir='column' gap="10px">
                    <DropdownInput
                      variant="fullSide"
                      dropDownPlace="Age Group"
                      options={['1-5', '6-10', '11-15', '16-20', '21-25', '26-30', '31-35', '36-40', '41-45', '46+']}
                      readOnly={true}
                      onClick={handleChangeAgeGroup}
                      value={ageGroupType}
                      menuList={{ pos: "absolute", right: "-45px", minW: "115px" }}
                    // inputStyleCss={{w: "80%"}}
                    />
                    <DropdownInput
                      variant="fullSide"
                      dropDownPlace="Time Factor"
                      options={['Last 15 Days', 'Last 30 Days', 'Last 45 Days', 'Last 60 Days', 'Last 75 Days', 'Last 90 Days']}
                      readOnly={true}
                      onClick={handleChangeTimeFactor}
                      value={timeFactor}
                      menuList={{ pos: "absolute", right: "-45px", minW: "135px" }}
                    // inputStyleCss={{w: "80%"}}
                    />

                    <Box w='100%' display='flex' flexDirection='row' justifyContent='center' alignItems='center' gap='0.875rem'>
                      <PrimaryButton buttonText="Filter" id="filterButton"
                        onClick={handleLabsApplyFilters}
                      />
                      <PrimaryButton buttonText="Reset" id="resetButton" variant="grayBtnFull" btnStyle={{ color: "#AA2F27" }}
                        onClick={labResetFields}
                      />
                    </Box>
                  </Box>
                </Collapse>

                <Box w='100%' p="1rem" maxH="calc(100vh - 340px)" overflowY="auto" className="labContainer">
                  <SimpleGrid columns={{ base: 1, md: 2 }} spacing="1rem">
                    {labsViewdata && labsViewdata.length > 0 ? (
                      labsViewdata.map((item, index) => (
                        <DoctorCard
                          hasFooter={false}
                          cardBody={
                            <>
                              <Box
                                key={index}
                                display="flex"
                                justifyContent="space-between"
                                w="100%"
                                alignItems="flex-start"
                              >
                                <Box display="flex" gap="0.75rem">
                                  <Box>
                                    <Text
                                      fontSize="0.875rem"
                                      fontWeight="600"
                                      color="#061027"
                                    >
                                      {item.ordername}
                                    </Text>
                                    <Text
                                      fontSize="0.625rem"
                                      fontWeight="500"
                                      color="#384052"
                                    >
                                      {formatDate_Do_MMM_YYYY(item.orderdate)}
                                    </Text>
                                  </Box>
                                </Box>
                              </Box>

                              <Divider my="0.75rem" />

                              <Box display='flex' flexDir="column">
                                <Box display="flex" alignItems="center" gap="0.5rem">
                                  <Image w="12px" h="13px" src="/assets/svgs/stethoscope.svg" />
                                  <Text fontSize="0.75rem" fontWeight="500">{item.doctorname}</Text>
                                </Box>
                                <Box display="flex" alignItems="center" gap="0.5rem">
                                  <Image filter={COLORS.BLUE_FILTER} w="12px" h="13px" src="/assets/svgs/patient.svg" />
                                  <Text fontSize="0.75rem" fontWeight="500">{item.patientname}</Text>
                                </Box>
                                <Box display="flex" alignItems="center" gap="0.5rem">
                                  <Image w="13px" h="10px" src="/assets/svgs/hospital.svg" />
                                  <Text fontSize="0.75rem" fontWeight="500">{item.hospital}</Text>
                                </Box>
                                <Box display="flex" alignItems="center" gap="0.5rem">
                                  <Image w="13px" h="10px" src="/assets/svgs/location-blue.svg" />
                                  <Text fontSize="0.75rem" fontWeight="500">{(item.address === null || item.address === '') && (item.city === null || item.city === '') && (item.country === null || item.country === '') ? '-' : `${item.address || ''}${item.address && item.city ? ', ' : ''}${item.city || ''}${(item.city && item.country) || (item.address && item.country) ? ', ' : ''}${item.country || ''}`}</Text>


                                </Box>
                              </Box>

                              <Box w="100%">
                                {/* <Box
                                as="button"
                                // onClick={onClick}
                                w="100%"
                                border="1px solid #E6E7E9"
                                p="10px"
                                borderRadius="10px"
                                mt="15px"
                                height="50px"
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between">
                                <Box
                                  display="flex"
                                  fontSize="12px"
                                  flexDirection="column"
                                  justifyContent="center"
                                  fontWeight="500"
                                >
                                2 documents
                                </Box>
                                <Box borderRadius="full" p="10px">
                                  <Image w="8px" src="/assets/imgs/right-icon.png" />
                                </Box>
                              </Box> */}
                              </Box>
                            </>
                          }
                        />
                      ))
                    ) : (
                      <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center" height="calc(100vh - 300px)" width="100%">
                        <Image boxSize="64px" opacity="0.5" src="/assets/svgs/prescriptions.svg" />
                        <Text>No Labs found</Text>
                      </Box>
                    )}
                  </SimpleGrid>
                </Box>
                {/* Table end */}
              </>
            )}

            {/* Imagings Tab */}
            {activeTab == "imaging" && (
              <>
                <Box gap='10px' p='1rem' w='100%' borderBottom="1px solid #E6E7E9" display='flex' flexDirection='row' justifyContent='center' alignItems='center'>
                  <PrimaryInput
                    variant="fullRound"
                    title="Name"
                    inputPlace="Name"
                    id="yourName"
                    onKeyDown={handleKeyDown}
                    onChange={handleChangeImagingName}
                    inputValue={userNameImaging}
                  />
                  <Box onClick={onToggle}>
                    <Image
                      w='50px'
                      cursor='pointer'
                      src={isOpen ? "assets/svgs/outline-f.svg" : "assets/svgs/filled-f.svg"}
                    />
                  </Box>
                  <Box w='100%' display='flex' flexDirection='row' justifyContent='center' alignItems='center' gap='0.875rem'>
                    <PrimaryButton buttonText="Filter" id="filterButton"
                      onClick={handleImagingApplyFilters}
                    />
                    <PrimaryButton buttonText="Reset" id="resetButton" variant="grayBtnFull" btnStyle={{ color: "#AA2F27" }}
                      onClick={imagingResetFields}
                    />
                  </Box>
                </Box>
                <Collapse in={isOpen} animateOpacity style={{ overflow: 'visible' }}>
                  <Box w="100%" display="flex" p='1rem' flexDir='column' gap="10px">
                    <DropdownInput
                      variant="fullSide"
                      dropDownPlace="Age Group"
                      options={['1-5', '6-10', '11-15', '16-20', '21-25', '26-30', '31-35', '36-40', '41-45', '46+']}
                      readOnly={true}
                      onClick={handleImagingAgeGroup}
                      value={imagingAgeGroup}
                      menuList={{ pos: "absolute", right: "-45px", minW: "115px" }}
                    // inputStyleCss={{w: "80%"}}
                    />
                    <DropdownInput
                      variant="fullSide"
                      dropDownPlace="Time Factor"
                      options={['Last 15 Days', 'Last 30 Days', 'Last 45 Days', 'Last 60 Days', 'Last 75 Days', 'Last 90 Days']}
                      readOnly={true}
                      onClick={handleImagingTimeFactor}
                      value={imagingTimeFactor}
                      menuList={{ pos: "absolute", right: "-45px", minW: "135px" }}
                    // inputStyleCss={{w: "80%"}}
                    />

                    <Box w='100%' display='flex' flexDirection='row' justifyContent='center' alignItems='center' gap='0.875rem'>
                      <PrimaryButton buttonText="Filter" id="filterButton"
                        onClick={handleImagingApplyFilters}
                      />
                      <PrimaryButton buttonText="Reset" id="resetButton" variant="grayBtnFull" btnStyle={{ color: "#AA2F27" }}
                        onClick={imagingResetFields}
                      />
                    </Box>
                  </Box>
                </Collapse>

                <Box w='100%' p="1rem" maxH="calc(100vh - 340px)" overflowY="auto" className="labContainer">
                  <SimpleGrid columns={{ base: 1, md: 2 }} spacing="1rem">
                    {imagingViewdata && imagingViewdata.length > 0 ? (
                      imagingViewdata.map((item, index) => (
                        <DoctorCard
                          hasFooter={false}
                          cardBody={
                            <>
                              <Box
                                key={index}
                                display="flex"
                                justifyContent="space-between"
                                w="100%"
                                alignItems="flex-start"
                              >
                                <Box display="flex" gap="0.75rem">
                                  <Box>
                                    <Text
                                      fontSize="0.875rem"
                                      fontWeight="600"
                                      color="#061027"
                                    >
                                      {item.ordername}
                                    </Text>
                                    <Text
                                      fontSize="0.625rem"
                                      fontWeight="500"
                                      color="#384052"
                                    >
                                      {formatDate_Do_MMM_YYYY(item.orderdate)}
                                    </Text>
                                  </Box>
                                </Box>
                              </Box>

                              <Divider my="0.75rem" />

                              <Box display='flex' flexDir="column">
                                <Box display="flex" alignItems="center" gap="0.5rem">
                                  <Image w="12px" h="13px" src="/assets/svgs/stethoscope.svg" />
                                  <Text fontSize="0.75rem" fontWeight="500">{item.doctorname}</Text>
                                </Box>
                                <Box display="flex" alignItems="center" gap="0.5rem">
                                  <Image filter={COLORS.BLUE_FILTER} w="12px" h="13px" src="/assets/svgs/patient.svg" />
                                  <Text fontSize="0.75rem" fontWeight="500">{item.patientname}</Text>
                                </Box>

                                <Box display="flex" alignItems="center" gap="0.5rem">
                                  <Image w="13px" h="10px" src="/assets/svgs/hospital.svg" />
                                  <Text fontSize="0.75rem" fontWeight="500">{item.hospital}</Text>
                                </Box>
                                <Box display="flex" alignItems="center" gap="0.5rem">
                                  <Image w="13px" h="10px" src="/assets/svgs/location-blue.svg" />
                                  <Text fontSize="0.75rem" fontWeight="500">{(item.address === null || item.address === '') && (item.city === null || item.city === '') && (item.country === null || item.country === '') ? '-' : `${item.address || ''}${item.address && item.city ? ', ' : ''}${item.city || ''}${(item.city && item.country) || (item.address && item.country) ? ', ' : ''}${item.country || ''}`}</Text>


                                </Box>
                              </Box>

                              <Box w="100%">
                                {/* <Box
                                as="button"
                                // onClick={onClick}
                                w="100%"
                                border="1px solid #E6E7E9"
                                p="10px"
                                borderRadius="10px"
                                mt="15px"
                                height="50px"
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between">
                                <Box
                                  display="flex"
                                  fontSize="12px"
                                  flexDirection="column"
                                  justifyContent="center"
                                  fontWeight="500"
                                >
                                2 documents
                                </Box>
                                <Box borderRadius="full" p="10px">
                                  <Image w="8px" src="/assets/imgs/right-icon.png" />
                                </Box>
                              </Box> */}
                              </Box>
                            </>
                          }
                        />
                      ))
                    ) : (
                      <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center" height="calc(100vh - 300px)" width="100%">
                        <Image boxSize="64px" opacity="0.5" src="/assets/svgs/prescriptions.svg" />
                        <Text>No Imagings found</Text>
                      </Box>
                    )}
                  </SimpleGrid>
                  {/* {prescriptionViewdata == null && (
          <Box display='flex' justifyContent='center' flexDirection='column' alignItems='center' height='100vh' width='100%'>
          <Image boxSize='64px' opacity='0.5' src='/assets/svgs/prescriptions.svg'/>
          <Text>No Prescriptions</Text>
        </Box>
        )} */}
                  {/* Pagination Section */}
                </Box>
                {/* Table end */}
              </>
            )}

            {/* Procedures Tab */}
            {activeTab == "procedures" && (
              <>
                <Box gap='10px' p='1rem' w='100%' borderBottom="1px solid #E6E7E9" display='flex' flexDirection='row' justifyContent='center' alignItems='center'>
                  <PrimaryInput
                    variant="fullRound"
                    title="Name"
                    inputPlace="Name"
                    id="yourName"
                    onKeyDown={handleKeyDown}
                    onChange={handleChangeProcedureName}
                    inputValue={userNameProcedure}
                  />
                  <Box onClick={onToggle}>
                    <Image
                      w='50px'
                      cursor='pointer'
                      src={isOpen ? "assets/svgs/outline-f.svg" : "assets/svgs/filled-f.svg"}
                    />
                  </Box>
                  <Box w='100%' display='flex' flexDirection='row' justifyContent='center' alignItems='center' gap='0.875rem'>
                    <PrimaryButton buttonText="Filter" id="filterButton"
                      onClick={handleProcedureApplyFilters}
                    />
                    <PrimaryButton buttonText="Reset" id="resetButton" variant="grayBtnFull" btnStyle={{ color: "#AA2F27" }}
                      onClick={procedureResetFields}
                    />
                  </Box>
                </Box>
                <Collapse in={isOpen} animateOpacity style={{ overflow: 'visible' }}>
                  <Box w="100%" display="flex" p='1rem' flexDir='column' gap="10px">
                    <DropdownInput
                      variant="fullSide"
                      dropDownPlace="Age Group"
                      options={['1-5', '6-10', '11-15', '16-20', '21-25', '26-30', '31-35', '36-40', '41-45', '46+']}
                      readOnly={true}
                      onClick={handleProcedureAgeGroup}
                      value={procedureAgeGroup}
                      menuList={{ pos: "absolute", right: "-45px", minW: "115px" }}
                    // inputStyleCss={{w: "80%"}}
                    />
                    <DropdownInput
                      variant="fullSide"
                      dropDownPlace="Time Factor"
                      options={['Last 15 Days', 'Last 30 Days', 'Last 45 Days', 'Last 60 Days', 'Last 75 Days', 'Last 90 Days']}
                      readOnly={true}
                      onClick={handleProcedureTimeFactor}
                      value={procedureTimeFactor}
                      menuList={{ pos: "absolute", right: "-45px", minW: "135px" }}
                    // inputStyleCss={{w: "80%"}}
                    />

                    <Box w='100%' display='flex' flexDirection='row' justifyContent='center' alignItems='center' gap='0.875rem'>
                      <PrimaryButton buttonText="Filter" id="filterButton"
                        onClick={handlePrescriptionsApplyFilters}
                      />
                      <PrimaryButton buttonText="Reset" id="resetButton" variant="grayBtnFull" btnStyle={{ color: "#AA2F27" }}
                        onClick={prescriptionResetFields}
                      />
                    </Box>
                  </Box>
                </Collapse>

                <Box w='100%' p="1rem" maxH="calc(100vh - 340px)" overflowY="auto" className="labContainer">
                  <SimpleGrid columns={{ base: 1, md: 2 }} spacing="1rem">
                    {procedureViewdata && procedureViewdata.length > 0 ? (
                      procedureViewdata.map((item, index) => (
                        <DoctorCard
                          hasFooter={false}
                          cardBody={
                            <>
                              <Box
                                key={index}
                                display="flex"
                                justifyContent="space-between"
                                w="100%"
                                alignItems="flex-start"
                              >
                                <Box display="flex" justifyContent='space-between' w='100%' gap="0.75rem">
                                  <Box>
                                    <Text
                                      fontSize="0.875rem"
                                      fontWeight="600"
                                      color="#061027"
                                    >
                                      {item.ordername}
                                    </Text>
                                    <Text
                                      fontSize="0.625rem"
                                      fontWeight="500"
                                      color="#384052"
                                    >
                                      {formatDate_Do_MMM_YYYY(item.orderdate)}
                                    </Text>
                                    <Text fontSize='0.75rem' fontWeight='600'>
                                      Reminder sent: {item.logcount ? item.logcount : 0}
                                    </Text>
                                  </Box>
                                  <Box
                                    as="button"
                                    border="1px solid #E6E7E9"
                                    borderRadius="full"
                                    w="36px"
                                    h="36px"
                                    p="6px"
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    onClick={() => viewLogs(item.orderid)}
                                    title={item.logcount == 0 ? 'No Logs' : 'View Logs'}
                                    disabled={item.logcount == 0}
                                  >
                                    <Image minW='20px' w="100%" h='16px' src="/assets/svgs/reports-filled.svg" />
                                  </Box>
                                </Box>
                              </Box>

                              <Divider my="0.75rem" />

                              <Box display='flex' flexDir="column">
                                <Box display="flex" alignItems="center" gap="0.5rem">
                                  <Image w="12px" h="13px" src="/assets/svgs/stethoscope.svg" />
                                  <Text fontSize="0.75rem" fontWeight="500">{item.doctorname}</Text>
                                </Box>
                                <Box display="flex" alignItems="center" gap="0.5rem">
                                  <Image filter={COLORS.BLUE_FILTER} w="12px" h="13px" src="/assets/svgs/patient.svg" />
                                  <Text fontSize="0.75rem" fontWeight="500">{item.patientname}</Text>
                                </Box>
                                <Box display="flex" alignItems="center" gap="0.5rem">
                                  <Image w="13px" h="10px" src="/assets/svgs/hospital.svg" />
                                  <Text fontSize="0.75rem" fontWeight="500">{item.hospital}</Text>
                                </Box>
                                <Box display="flex" alignItems="center" gap="0.5rem">
                                  <Image w="13px" h="10px" src="/assets/svgs/location-blue.svg" />
                                  <Text fontSize="0.75rem" fontWeight="500">{(item.address === null || item.address === '') && (item.city === null || item.city === '') && (item.country === null || item.country === '') ? '-' : `${item.address || ''}${item.address && item.city ? ', ' : ''}${item.city || ''}${(item.city && item.country) || (item.address && item.country) ? ', ' : ''}${item.country || ''}`}</Text>


                                </Box>
                              </Box>

                              <Box w="100%">
                                {/* <Box
                                as="button"
                                // onClick={onClick}
                                w="100%"
                                border="1px solid #E6E7E9"
                                p="10px"
                                borderRadius="10px"
                                mt="15px"
                                height="50px"
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between">
                                <Box
                                  display="flex"
                                  fontSize="12px"
                                  flexDirection="column"
                                  justifyContent="center"
                                  fontWeight="500"
                                >
                                2 documents
                                </Box>
                                <Box borderRadius="full" p="10px">
                                  <Image w="8px" src="/assets/imgs/right-icon.png" />
                                </Box>
                              </Box> */}
                              </Box>
                            </>
                          }
                        />
                      ))
                    ) : (
                      <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center" height="calc(100vh - 300px)" width="100%">
                        <Image boxSize="64px" opacity="0.5" src="/assets/svgs/prescriptions.svg" />
                        <Text>No Procedures found</Text>
                      </Box>
                    )}
                  </SimpleGrid>
                  {/* Pagination Section */}
                </Box>
                {/* Table end */}
              </>
            )}

            {/* Discharge Tab */}
            {activeTab == "discharge" && (
              <>
                <Box gap='10px' p='1rem' w='100%' borderBottom="1px solid #E6E7E9" display='flex' flexDirection='row' justifyContent='center' alignItems='center'>
                  <DatePicker
                    onDateChange={(selectedDateValue) =>
                      handleDischargeFromDate(selectedDateValue)
                    }
                    placeholderProp="From Date"
                    datePickerInputStyle={{ borderRadius: "10px 10px 10px 10px" }}
                    value={dischargeFromDate}
                    clearValue={true}

                    CUSTOM_DISABLE={true}
                    disableFutureDates={true}
                    maxDate={dischargeToDateMinMax}
                  />

                  <DatePicker
                    onDateChange={(selectedDateValue) =>
                      handleDischargeToDate(selectedDateValue)
                    }
                    placeholderProp="To Date"
                    datePickerInputStyle={{ borderRadius: "10px 10px 10px 10px " }}
                    value={dischargeToDate}
                    clearValue={true}

                    CUSTOM_DISABLE={true}
                    maxDate={new Date().toISOString()}
                    minDate={dischargeFromDateMinMax}

                  />
                  {/* <Box onClick={onToggle}>
                    <Image
                      w='50px'
                      cursor='pointer'
                      src={isOpen ? "assets/svgs/outline-f.svg" : "assets/svgs/filled-f.svg"}
                    />
                  </Box> */}
                  <Box w='100%' display='flex' flexDirection='row' justifyContent='center' alignItems='center' gap='0.875rem'>
                    <PrimaryButton buttonText="Filter" id="filterButton"
                      onClick={handleDischargeApplyFilters}
                    />
                    <PrimaryButton buttonText="Reset" id="resetButton" variant="grayBtnFull" btnStyle={{ color: "#AA2F27" }}
                      onClick={dischargeResetFields}
                    />
                  </Box>
                </Box>
                <Collapse in={isOpen} animateOpacity style={{ overflow: 'visible' }}>
                  <Box w="100%" display="flex" p='1rem' flexDir='column' gap="10px">
                    <DropdownInput
                      variant="fullSide"
                      dropDownPlace="Age Group"
                      options={['1-5', '6-10', '11-15', '16-20', '21-25', '26-30', '31-35', '36-40', '41-45', '46+']}
                      readOnly={true}
                      onClick={handleProcedureAgeGroup}
                      value={procedureAgeGroup}
                      menuList={{ pos: "absolute", right: "-45px", minW: "115px" }}
                    // inputStyleCss={{w: "80%"}}
                    />
                    <DropdownInput
                      variant="fullSide"
                      dropDownPlace="Time Factor"
                      options={['Last 15 Days', 'Last 30 Days', 'Last 45 Days', 'Last 60 Days', 'Last 75 Days', 'Last 90 Days']}
                      readOnly={true}
                      onClick={handleProcedureTimeFactor}
                      value={procedureTimeFactor}
                      menuList={{ pos: "absolute", right: "-45px", minW: "135px" }}
                    // inputStyleCss={{w: "80%"}}
                    />

                    <Box w='100%' display='flex' flexDirection='row' justifyContent='center' alignItems='center' gap='0.875rem'>
                      <PrimaryButton buttonText="Filter" id="filterButton"
                        onClick={handlePrescriptionsApplyFilters}
                      />
                      <PrimaryButton buttonText="Reset" id="resetButton" variant="grayBtnFull" btnStyle={{ color: "#AA2F27" }}
                        onClick={prescriptionResetFields}
                      />
                    </Box>
                  </Box>
                </Collapse>

                <Box w='100%' p="1rem" maxH="calc(100vh - 340px)" overflowY="auto" className="labContainer">
                  <SimpleGrid columns={{ base: 1, md: 2 }} spacing="1rem">
                    {dischargeSummary && dischargeSummary.length > 0 ? (
                      dischargeSummary.map((item, index) => (
                        <DoctorCard
                          hasFooter={false}
                          cardBody={
                            <>
                              <Box
                                key={index}
                                display="flex"
                                justifyContent="space-between"
                                w="100%"
                                alignItems="flex-start"
                              >
                                <Box display="flex" justifyContent='space-between' w='100%' gap="0.75rem">
                                  <Box>
                                  <Text
                                      fontSize="0.875rem"
                                      fontWeight="600"
                                      color="#061027"
                                    >
                                      {formatDate_Do_MMM_YYYY_Time(item.createddate)}
                                    </Text>
                                    <Text
                                      fontSize="0.875rem"
                                      fontWeight="600"
                                      color="#061027"
                                    >
                                      {item.guid ? item.guid : ""}
                                    </Text>
                                    {/* {summaryStatus == 1 && (
                                    <Text
                                      fontSize="0.875rem"
                                      fontWeight="600"
                                      color="#061027"
                                    >
                                      This is still in process...
                                    </Text>
                                    )} */}
                                  </Box>
                                </Box>
                              </Box>
                              {/* {summaryStatus == 1 && item.ailog && item.ailog !== null ? ( */}
                                {item.iscomplete == 1 &&
                                <Box w="100%" display="flex" justifyContent="space-between" gap="10px" mt="15px">
                                  <Box
                                    as="button"
                                    w="50%"
                                    border="1px solid #E6E7E9"
                                    p="10px"
                                    borderRadius="10px"
                                    height="50px"
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    onClick={() => aiLogPreview(item.ailog)}
                                    // onClick={() => aiLogPreview(ailog)}
                                  >
                                    <Box display="flex" fontSize="12px" flexDirection="column" justifyContent="center" fontWeight="500">
                                      Preview
                                    </Box>
                                  </Box>
                                  {/* {item.downloadedpdf && ( */}
                                    <Box
                                      as="button"
                                      w="50%"
                                      border="1px solid #E6E7E9"
                                      p="10px"
                                      borderRadius="10px"
                                      height="50px"
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      onClick={() => downloadSummary(item.ailog)}
                                    >
                                      <Box display="flex" fontSize="12px" flexDirection="column" justifyContent="center" fontWeight="500">
                                        Download
                                      </Box>
                                    </Box>
                                  {/* )} */}
                                </Box>
                                }
                                {item.iscomplete == 0 && item.issingledocument != 1 &&
                                    <Box>
                                      <Text fontSize="0.875rem" fontWeight="600" color="#061027">
                                        This is still in process...
                                      </Text>
                                  </Box>
                                }

                            </>
                          }
                        />
                      ))
                    ) : (
                      <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center" height="calc(100vh - 300px)" width="100%">
                        <Image boxSize="64px" opacity="0.5" src="/assets/svgs/prescriptions.svg" />
                        <Text>No Discharge summary logs found</Text>
                      </Box>
                    )}
                  </SimpleGrid>
                  {/* Pagination Section */}
                </Box>
                {/* Table end */}
              </>
            )}

          </>
        )}
      </Box>
      <ModalRight
        ref={showProcedureLogs}
        modalWidth="calc(100vw - 40%)"
        header="Notification Log Details"
        bodyStyle={{ padding: "0" }}
        body={
          <>
            {logsData && logsData?.patientinfo &&
             <Box flex="1" p="24px" bg="white" borderRadius="8px">
             <Flex justify="space-between" align="start" gap="24px">
               {/* Order Name */}
               <Box w='300px'>
                 <Text fontSize="1rem" fontWeight="bold" color="gray.700">Procedure Name</Text>
                 <Box w="100%" maxW="20rem" isTruncated>
                    <Text
                    // fontSize="0.875rem"
                    // fontWeight="600"
                    // color="#061027"
                    className="textOverflow"
                    title={logsData?.patientinfo?.ordername}
                    >
                     {logsData?.patientinfo?.ordername?logsData?.patientinfo?.ordername:""}
                    </Text>
                  </Box>                 
               </Box>
               <Box w='300px'>
                 <Text fontSize="1rem" fontWeight="bold" color="gray.700">Recommended Date&Time</Text>
                 <Text fontSize=".875rem" fontWeight="500" color="gray.600">{logsData?.patientinfo?.orderdate? formatDate_Do_MMM_YYYY_Time(logsData?.patientinfo?.orderdate):""}</Text>
               </Box>
               {/* Patient Name */}
               <Box w='300px'>
                 <Text fontSize="1rem" fontWeight="bold" color="gray.700">Patient Name</Text>
                 <Text fontSize=".875rem" fontWeight="500" color="gray.600">{logsData?.patientinfo?.firstname + ' ' + logsData?.patientinfo?.lastname}</Text>
               </Box>
               <Box w='300px'>
                 <Text fontSize="1rem" fontWeight="bold" color="gray.700">Doctor Name</Text>
                 <Text fontSize=".875rem" fontWeight="500" color="gray.600">{logsData?.patientinfo?.doctorname?logsData?.patientinfo?.doctorname:"-"}</Text>
               </Box>
             </Flex>
           </Box>
           
           
            }
            {logsData && logsData.data?.length > 0 ? (
              <Box flex="1" p="24px">
                <Box
                  border="1px solid #E6E7E9"
                  ref={tableRef}
                >
                  <SimpleTable
                    headers={ModalTableHeader}
                    className='tableContainer'
                    isDataPresent={true}
                    ref={tableRef}
                    // currentPage={currentPage} onPageChange={handlePageChange}
                    footerStyle={{ pos: "sticky", bottom: "-1px", boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px" }}
                    tableStyle={{ maxH: "calc(100vh - 175px)", overflowY: "auto", tableLayout: "fixed", width: "100%" }}
                    tableBody={
                      <>
                        {
                          logsData.data?.map((step, index) => (
                            <Tr w="100%" index={index}>
                              {/* <Td maxW="180px">
                                <Box
                                  w="100%"
                                  display="flex"
                                  gap="0.5rem"
                                  alignItems="center"
                                >
                                  <Box w="80%" maxW="8rem" isTruncated>
                                    <Text
                                      className="textOverflow"
                                      fontSize=".875rem"
                                      fontWeight="600"
                                    >
                                      {step.createddate? formatDate_Do_MMM_YYYY_Time(step.createddate):""}
                                    </Text>
                                  </Box>
                                </Box>
                              </Td> */}

                              <Td maxW="130px">
                                <Text fontSize=".875rem" fontWeight="500" isTruncated>
                                {step.createddate? formatDate_Do_MMM_YYYY_Time(step.createddate):""}
                                </Text>
                              </Td>
                              <Td maxW="250px">
                                <Text fontSize=".875rem" fontWeight="500" whiteSpace='wrap'>
                                  {step.notificationcontent ? step.notificationcontent : ('-')}
                                </Text>
                              </Td>
                            </Tr>
                          ))}
                      </>
                    }
                  />
                </Box>
              </Box>
            ) : (
              <Box display='flex' justifyContent='center' alignItems='center' height='100%' width='100%'>
                <Text>No data available</Text>
              </Box>
            )}
          </>
        }
        hasFooter={false}
      />

      <DynamicModal
        ref={customMessageSelection}
        modalWidth="60%"
        // modalHeight="100%"
        // modalMaxHeight="97vh"
        // modalMaxHeight="90vh"
        modalHeader={`Custom Message Selection`}
        modalBody={
          <>
            {categoryDescription.map((response, index) => (
              <Box
                key={index}
                borderWidth="1px"
                borderRadius="lg"
                overflow="hidden"
                p={4}
                mb={4}
                display="flex"
                // as="button"
                boxShadow="rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px"
                // onClick={() => handleCheckboxChange(index)}
                onClick={() => handleCheckboxChange(index, response.template)}
                alignItems="center"
              >
                <Checkbox
                  isChecked={selectedMessageIndex === index}
                  onChange={() => handleCheckboxChange(index, response.template)}
                  mr={4}
                  alignSelf="center" // Vertically center the checkbox
                ></Checkbox>
                <Box
                  // key={index}
                  // borderBottom="1px solid #E6E7E9"
                  // py="0.875rem"
                  display="flex"
                  flexDir="column"
                  gap="0.5rem"
                >
                  <Text fontSize="16px" fontWeight="600">
                    {/* {response.title} */}
                    Procedure Alert
                  </Text>
                  <Box
                    as="p"
                    p="0.5rem"
                    bg="#F9FAFB"
                    borderLeft="4px solid #14C585"
                    fontSize="0.875rem"
                    fontWeight="500"
                  >
                    {response.template}
                  </Box>
                </Box>
              </Box>
            ))}


          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              buttonText="Send"
              btnStyle={{
                w: "100%",
                h: "2.5rem",
              }}
              onClick={() => {
                sendNotification();
              }}
            />
          </>
        }
      />
      {/* <DynamicModal
        ref={customMessageSelection}
        modalWidth="60%"
        modalHeader={`Custom Message Selection`}
        modalBody={
          <>
            {data.map((response, index) => (
              <Box
                key={index}
                borderWidth="1px"
                borderRadius="lg"
                overflow="hidden"
                p={4}
                mb={4}
                display="flex"
                // as="button"
                boxShadow="rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px"
                // onClick={() => handleCheckboxChange(index)}
                alignItems="center"
              >
                <Checkbox
                  isChecked={selectedMessageIndex === index}
                  onChange={() => handleCheckboxChange(index)}
                  mr={4}
                  alignSelf="center" // Vertically center the checkbox
                ></Checkbox>
                <Box
                  key={index}
                  borderBottom="1px solid #E6E7E9"
                  py="0.875rem"
                  display="flex"
                  flexDir="column"
                  gap="0.5rem"
                >
                  <Text fontSize="16px" fontWeight="600">
                    {response.title}
                  </Text>
                  <Box
                    as="p"
                    p="0.5rem"
                    bg="#F9FAFB"
                    borderLeft="4px solid #14C585"
                    fontSize="0.875rem"
                    fontWeight="500"
                  >
                    {response.description}
                  </Box>
                </Box>
              </Box>
            ))}


          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              buttonText="Save"
              btnStyle={{
                w: "100%",
                h: "2.5rem",
              }}
              onClick={() => {
                sendNotification();
                customMessageSelection.current.closeModal();
              }}
            />
          </>
        }
      /> */}

      <DynamicModal
        ref={categorySelection}
        modalWidth="60%"
        modalHeader={`Category Selection`}
        modalBody={
          <>
            {categoriesList.map((response, index) => (
              <Box
                key={index}
                borderWidth="1px"
                borderRadius="lg"
                overflow="hidden"
                p={4}
                mb={4}
                display="flex"
                // as="button"
                boxShadow="rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px"
                // onClick={() => handleCheckboxChange(index)}
                onClick={() => handleCategoryCheckboxChange(index)}
                alignItems="center"
              >
                <Checkbox
                  isChecked={selectedCategoryIndex === index}
                  onChange={() => handleCategoryCheckboxChange(index)}
                  mr={4}
                  alignSelf="center"
                ></Checkbox>
                <Box
                  // key={index}
                  // borderBottom="1px solid #E6E7E9"
                  // py="0.875rem"
                  display="flex"
                  flexDir="column"
                  gap="0.5rem"
                >
                  <Text fontSize="16px" fontWeight="600">
                    {response.display}
                  </Text>
                  {/* <Box
                    as="p"
                    p="0.5rem"
                    bg="#F9FAFB"
                    borderLeft="4px solid #14C585"
                    fontSize="0.875rem"
                    fontWeight="500"
                  >
                    {response.description}
                  </Box> */}
                </Box>
              </Box>
            ))}


          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              buttonText="Save"
              btnStyle={{
                w: "100%",
                h: "2.5rem",
              }}
              onClick={() => {
                // sendNotification();
                openNotificationCustomMessage();
                // categorySelection.current.closeModal();
              }}
            />
          </>
        }
      />

<ModalRight
        ref={showAiLogData}
        modalWidth="calc(100vw - 60%)"
        header="Disharge Summary Log Details"
        bodyStyle={{ padding: "0" }}
        body={
          <>
            {logPreviewData?.map((item, index) => (
              <Box flex="1" p="12px 24px" key={index}>

                        {/* <Box mb={4} id="content-to-download"> */}
                          <Flex
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Heading as="h4" size="md">
                              {/* Chief Complaint */}
                              {item.header}
                            </Heading>
                            <Spacer />
                           
                          </Flex>
                          <Textarea
                            value={item.text}
                            // onChange={(e) => handlechangetext(e.target.value, index)} // Update state on change
                            //resize="none"
                          />
                        {/* </Box> */}
                        </Box>
                      ))}
          </>
        }
      />

      {/* DynamicModal for Confirmation for followup Notification */}
            <DynamicModal
              ref={followupNotification}
              modalHeader="Followup Notification?"
              modalBody={
                <>
                  <Text fontSize="14px" fontWeight="600">
                  {`Are you sure you want to send Notification to "${followupPatientName}"?`}
                     {/* "{vaccinationName}"? */}
                  </Text>
                </>
              }
              modalFooterBtn={
                <>
                  <PrimaryButton
                    // variant="deleteBtn"
                    buttonText="Send"
                    onClick={sendFollowupNotification}
                  />
                </>
              }
            />

      {/* Update Status Modal */}
      <DynamicModal
            ref={statusmodal}
            modalHeader={`Update Appointment status`} 
            modalBody={
              <>
                <Box>
                    <DropdownInput
                          variant="bothSide"
                          // defaultOption={appointmentOrderStatus}
                          value={appointmentOrderStatus}
                          dropDownPlace={
                            <>
                              Status <Box as="span" color="red">*</Box>
                            </>
                          }
                          options={["Prescribed", "Registered", "Sample Collected", "In Transit", "Processing", "Validation Pending", "Under Review", "Provisional Report Ready", "Signed Off", "Report Available", "Notified"]}
                          onClick={handlestatusSelect}
                        />
                  
                </Box>
              </>
            }
            modalFooterBtn={
              <>
                <PrimaryButton buttonText="Update" 
                onClick={handleStatusChanges} 
                />
              </>
            }
          />


      {/* Book Appointment Modal */}
  <DynamicModal
  ref={bookAppointmentModal}
  modalHeader="Book an Appointment"
  modalWidth="50%"
  modalBody={
    <>
      <Box>
        {/* Patient Details Section - Read Only */}
        <Box mb="1.5rem">
          {/* <Text fontSize="1.1rem" fontWeight="600" mb="1rem">Patient Details</Text> */}
          
          <Box display="grid" gridTemplateColumns="repeat(2, 1fr)" gap="1rem">
            <Box>
              <Text fontWeight="600">Patient Name:</Text>
              <Text>{patientAppointmentDetails?.patientname || "-"}</Text>
            </Box>
            <Box>
              <Text fontWeight="600">Email:</Text>
              <Text>{patientAppointmentDetails?.email || "-"}</Text>
            </Box>
            <Box>
              <Text fontWeight="600">Lab Work:</Text>
              <Text>{patientAppointmentDetails?.ordername || "-"}</Text>
            </Box>
            <Box>
              <Text fontWeight="600">Doctor:</Text>
              <Text>{patientAppointmentDetails?.doctorname || "-"}</Text>
            </Box>
            <Box>
              <Text fontWeight="600">Hospital:</Text>
              <Text>{patientAppointmentDetails?.hospital || "-"}</Text>
            </Box>
            <Box>
              <Text fontWeight="600">Address:</Text>
              <Text>
                {`${patientAppointmentDetails?.address || ""}${patientAppointmentDetails?.city ? `, ${patientAppointmentDetails.city}` : ""}${patientAppointmentDetails?.country ? `, ${patientAppointmentDetails.country}` : ""}` || "-"}
              </Text>
            </Box>
          </Box>
        </Box>

        {/* Appointment Date/Time Section - Editable */}
        <Box mb="1.5rem">
          {/* <Text fontSize="1.1rem" fontWeight="600" mb="1rem">Appointment Details</Text> */}
          
          <Box display="flex" gap="1rem" flexWrap="wrap">
            <Box flex="1" >
              <Text fontWeight="600" mb="0.5rem">Appointment Date*</Text>
              <DatePicker
                value={appointmentDate}
                datePickerInputStyle={{ borderRadius: "10px 10px 10px 10px" }}
                onDateChange={(selectedDateValue) =>
                  handleAppointmentDate(selectedDateValue)
                }
                placeholderProp="Appointment Date*"
                minDate={new Date()}
              />
            </Box>
            
            <Box flex="1" >
              <Text fontWeight="600" mb="0.5rem">Appointment Time*</Text>
              {/* <DropdownInput
                variant="fullSide"
                dropDownPlace="Age Group"
                options={timeSlots}
                readOnly={true}
                onClick={(e) => setAppointmentTime(e)}
                value={appointmentTime}
                menuList={{ pos: "absolute", right: "-45px", minW: "250px" }}
                // inputStyleCss={{w: "80%"}}
              /> */}

              <DropdownInput
  variant="fullSide"
  dropDownPlace="Select Time Slot"
  options={timeSlots.map(slot => slot.label)} // Show full range in dropdown
  readOnly={true}
  onClick={(selectedDisplayTime) => handleTimeSelect(selectedDisplayTime)}
  value={appointmentTime} // Show full range in input
  menuList={{ pos: "absolute", right: "-45px", minW: "250px" }}
/>
            </Box>
          </Box>
        </Box>

        {/* Consent Section */}
        {/* <Box display="flex" alignItems="center" mt="1.5rem">
          <Checkbox
            isChecked={isConsentGiven}
            onChange={(e) => setIsConsentGiven(e.target.checked)}
            size="lg"
            colorScheme="green"
            mr="0.5rem"
          />
          <Text>Patient Consent is taken and agreed</Text>
          <Text>I agree</Text>
        </Box> */}
      </Box>
    </>
  }
  modalFooterBtn={
    <Flex gap="1rem" w="100%">
      <PrimaryButton
        variant="grayBtn"
        buttonText="Cancel"
        btnStyle={{
          h: "2.5rem",
          w: "100%",
          p: "0",
          m: "0",
          bg: COLORS.GRAY_100,
          color: COLORS.PRIMARY_WHITE,
          _hover: { bg: COLORS.GRAY_200 },
        }}
        onClick={() => bookAppointmentModal.current.closeModal()}
      />
      <PrimaryButton
        variant="blueBtn"
        buttonText="Confirm Appointment"
        btnStyle={{
          h: "2.5rem",
          w: "100%",
          p: "0",
          m: "0",
          bg: COLORS.PRIMARY_GRADIENT,
          color: COLORS.PRIMARY_WHITE,
          _hover: { bg: COLORS.PRIMARY_COLOR },
        }}
        // isDisabled={!isConsentGiven || !appointmentDate || !appointmentTime}
        onClick={handleConfirmAppointment}
      />
    </Flex>
  }
/>

<ModalRight
        ref={showLabLogs}
        modalWidth="calc(100vw - 40%)"
        header="Notification Log Details"
        bodyStyle={{ padding: "0" }}
        body={
          <>
            {logsData && logsData?.patientinfo &&
             <Box flex="1" p="24px" bg="white" borderRadius="8px">
             <Flex justify="space-between" align="start" gap="24px">
               {/* Order Name */}
               <Box w='300px'>
                 <Text fontSize="1rem" fontWeight="bold" color="gray.700">Lab Name</Text>
                 <Box w="100%" maxW="20rem" isTruncated>
                    <Text
                    // fontSize="0.875rem"
                    // fontWeight="600"
                    // color="#061027"
                    className="textOverflow"
                    title={logsData?.patientinfo?.ordername}
                    >
                     {logsData?.patientinfo?.ordername?logsData?.patientinfo?.ordername:""}
                    </Text>
                  </Box>                 
               </Box>
               <Box w='300px'>
                 <Text fontSize="1rem" fontWeight="bold" color="gray.700">Recommended Date&Time</Text>
                 <Text fontSize=".875rem" fontWeight="500" color="gray.600">{logsData?.patientinfo?.orderdate? formatDate_Do_MMM_YYYY_Time(logsData?.patientinfo?.orderdate):""}</Text>
               </Box>
               {/* Patient Name */}
               <Box w='300px'>
                 <Text fontSize="1rem" fontWeight="bold" color="gray.700">Patient Name</Text>
                 <Text fontSize=".875rem" fontWeight="500" color="gray.600">{logsData?.patientinfo?.firstname + ' ' + logsData?.patientinfo?.lastname}</Text>
               </Box>
               <Box w='300px'>
                 <Text fontSize="1rem" fontWeight="bold" color="gray.700">Doctor Name</Text>
                 <Text fontSize=".875rem" fontWeight="500" color="gray.600">{logsData?.patientinfo?.doctorname?logsData?.patientinfo?.doctorname:"-"}</Text>
               </Box>
             </Flex>
           </Box>
           
           
            }
            {logsData && logsData.data?.length > 0 ? (
              <Box flex="1" p="24px">
                <Box
                  border="1px solid #E6E7E9"
                  ref={tableRef}
                >
                  <SimpleTable
                    headers={ModalLabTableHeader}
                    className='tableContainer'
                    isDataPresent={true}
                    ref={tableRef}
                    // currentPage={currentPage} onPageChange={handlePageChange}
                    footerStyle={{ pos: "sticky", bottom: "-1px", boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px" }}
                    tableStyle={{ maxH: "calc(100vh - 175px)", overflowY: "auto", tableLayout: "fixed", width: "100%" }}
                    tableBody={
                      <>
                        {
                          logsData.data?.map((step, index) => (
                            <Tr w="100%" index={index}>
                              <Td maxW="130px">
                                <Text fontSize=".875rem" fontWeight="500" isTruncated>
                                {step.createddate? formatDate_Do_MMM_YYYY_Time(step.createddate):""}
                                </Text>
                              </Td>
                              <Td maxW="250px">
                                <Text fontSize=".875rem" fontWeight="500" whiteSpace='wrap'>
                                  {step.notificationcontent ? step.notificationcontent : ('-')}
                                </Text>
                              </Td>
                            </Tr>
                          ))}
                      </>
                    }
                  />
                </Box>
              </Box>
            ) : (
              <Box display='flex' justifyContent='center' alignItems='center' height='100%' width='100%'>
                <Text>No data available</Text>
              </Box>
            )}
          </>
        }
        hasFooter={false}
      />


<ModalRight
        ref={showImagingLogs}
        modalWidth="calc(100vw - 40%)"
        header="Notification Log Details"
        bodyStyle={{ padding: "0" }}
        body={
          <>
            {logsData && logsData?.patientinfo &&
             <Box flex="1" p="24px" bg="white" borderRadius="8px">
             <Flex justify="space-between" align="start" gap="24px">
               {/* Order Name */}
               <Box w='300px'>
                 <Text fontSize="1rem" fontWeight="bold" color="gray.700">Imaging Name</Text>
                 <Box w="100%" maxW="20rem" isTruncated>
                    <Text
                    // fontSize="0.875rem"
                    // fontWeight="600"
                    // color="#061027"
                    className="textOverflow"
                    title={logsData?.patientinfo?.ordername}
                    >
                     {logsData?.patientinfo?.ordername?logsData?.patientinfo?.ordername:""}
                    </Text>
                  </Box>                 
               </Box>
               <Box w='300px'>
                 <Text fontSize="1rem" fontWeight="bold" color="gray.700">Recommended Date&Time</Text>
                 <Text fontSize=".875rem" fontWeight="500" color="gray.600">{logsData?.patientinfo?.orderdate? formatDate_Do_MMM_YYYY_Time(logsData?.patientinfo?.orderdate):""}</Text>
               </Box>
               {/* Patient Name */}
               <Box w='300px'>
                 <Text fontSize="1rem" fontWeight="bold" color="gray.700">Patient Name</Text>
                 <Text fontSize=".875rem" fontWeight="500" color="gray.600">{logsData?.patientinfo?.firstname + ' ' + logsData?.patientinfo?.lastname}</Text>
               </Box>
               <Box w='300px'>
                 <Text fontSize="1rem" fontWeight="bold" color="gray.700">Doctor Name</Text>
                 <Text fontSize=".875rem" fontWeight="500" color="gray.600">{logsData?.patientinfo?.doctorname?logsData?.patientinfo?.doctorname:"-"}</Text>
               </Box>
             </Flex>
           </Box>
           
           
            }
            {logsData && logsData.data?.length > 0 ? (
              <Box flex="1" p="24px">
                <Box
                  border="1px solid #E6E7E9"
                  ref={tableRef}
                >
                  <SimpleTable
                    headers={ModalLabTableHeader}
                    className='tableContainer'
                    isDataPresent={true}
                    ref={tableRef}
                    // currentPage={currentPage} onPageChange={handlePageChange}
                    footerStyle={{ pos: "sticky", bottom: "-1px", boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px" }}
                    tableStyle={{ maxH: "calc(100vh - 175px)", overflowY: "auto", tableLayout: "fixed", width: "100%" }}
                    tableBody={
                      <>
                        {
                          logsData.data?.map((step, index) => (
                            <Tr w="100%" index={index}>
                              <Td maxW="130px">
                                <Text fontSize=".875rem" fontWeight="500" isTruncated>
                                {step.createddate? formatDate_Do_MMM_YYYY_Time(step.createddate):""}
                                </Text>
                              </Td>
                              <Td maxW="250px">
                                <Text fontSize=".875rem" fontWeight="500" whiteSpace='wrap'>
                                  {step.notificationcontent ? step.notificationcontent : ('-')}
                                </Text>
                              </Td>
                            </Tr>
                          ))}
                      </>
                    }
                  />
                </Box>
              </Box>
            ) : (
              <Box display='flex' justifyContent='center' alignItems='center' height='100%' width='100%'>
                <Text>No data available</Text>
              </Box>
            )}
          </>
        }
        hasFooter={false}
      />

      <DynamicModal
        ref={labNotification}
        modalHeader="Confirm Notification?"
        modalBody={
          <>
            <Text fontSize="14px" fontWeight="600">
              Are you sure you want to send a Notification to  <strong>"{labPatientName}"</strong> ?
            </Text>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              // variant="deleteBtn"
              buttonText="Send"
              onClick={sendLabNotification}
            />
          </>
        }
      />

      <DynamicModal
        ref={imagingNotification}
        modalHeader="Confirm Notification?"
        modalBody={
          <>
            <Text fontSize="14px" fontWeight="600">
              Are you sure you want to send a Notification to <strong>"{imagingPatientName}"</strong> ?
            </Text>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              // variant="deleteBtn"
              buttonText="Send"
              onClick={sendImagingNotification}
            />
          </>
        }
      />


      <DynamicModal
        ref={procedureNotification}
        modalHeader="Confirm Notification?"
        modalBody={
          <>
            <Text fontSize="14px" fontWeight="600">
              Are you sure you want to send a Notification to <strong>"{procedurePatientName}"</strong> ?
            </Text>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              // variant="deleteBtn"
              buttonText="Send"
              onClick={sendProcedureNotification}
            />
          </>
        }
      />

      <DynamicModal
        ref={vaccineNotification}
        modalHeader="Confirm Notification?"
        modalBody={
          <>
            <Text fontSize="14px" fontWeight="600">
              Are you sure you want to send a Notification to  <strong>"{vaccinePatientName}"</strong> ?
            </Text>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              // variant="deleteBtn"
              buttonText="Send"
              onClick={sendVaccineNotification}
            />
          </>
        }
      />

      <ModalRight
              ref={generateReport}
              // modalWidth={showpatientinfo ? "600px": "70vw"}
              modalWidth={{ base: "100%", lg: "calc(100vw - 50%)" }}
              bodyStyle={{ overflow: "hidden" }}
              header="Generate Report"
              hasFooter={true}
              body={
                <>
                <Box w="100%" display="flex" mt='2rem'>
                <SimpleTableLabs
                NoDataHeader={false}
                isDataPresent={true}
                ThStyle={{ textAlign: "center", bg: "#FAFAFA" }}
                tableStyle={{
                  h: "calc(100vh - 170px)",
                  maxH: "calc(100vh - 170px)",
                  overflowY: "auto",
                  overflowX: "auto",
                  width: "100%",
                  border: "1px solid #E6E7E9",
                  borderBottom: "none",
                }}
                tableHeaders={
                  <Tr bg='white' zIndex='9999' pos='relative'>
                    <Th fontSize="0.87rem" fontWeight="500" pl="10px">
                      Metric name
                    </Th>
                    <Th fontSize="0.87rem" fontWeight="500" pl="10px">
                      Unit
                    </Th>
                    <Th fontSize="0.87rem" fontWeight="500" pl="10px">
                      Low Range
                    </Th>
                    <Th fontSize="0.87rem" fontWeight="500" pl="10px">
                      High Range
                    </Th>
                    <Th fontSize="0.87rem" fontWeight="500" pl="10px">
                      Formula
                    </Th>
                    {/* <Th fontSize="0.87rem" fontWeight="500" pl="10px">
                      Result
                    </Th> */}
                    <Th fontSize="0.87rem" fontWeight="500" >
                      <Flex w="100%" justifyContent="center" alignItems="center">
                        <PrimaryButton
                          btnIcon="/assets/svgs/add-white.svg"
                          iconSrc={true}
                          btnStyle={{ w: "25px", h: "25px", p: "0",m:"0" }}
                          iconSrcStyle={{ mr: "0", w: "10px" }}
                          onClick={AddAnotherRowLabTest}
                        />
                      </Flex>
                    </Th>
                  </Tr>
                }
                tableBody={
                  <>
                    {rows?.map((row, index) => (
                      <Tr w="100%" key={index}>
                        <Td p="0">
                          <Box w="100%" pos="relative" cursor="pointer">
                            <PrimaryInput
                              variant="bothSide"
                              inputPlace="Metric name"
                              inputValue={row.metricname}
                              id={index === rows.length - 1 ? "LabNameInAdd" : ""}
                              onChange={(e) =>
                                handleMetricNameChange(e.target.value, index)
                              }
                              autocomplete="off"
                              inputCssStyle={{
                                _hover: {
                                  border: "1px solid",
                                  borderRadius: "10px",
                                },
                              }}
                              maxLength={100}
                            />
                          </Box>
                        </Td>
                        <Td p="0">
                          <PrimaryInput
                            variant="bothSide"
                            inputPlace='Unit'
                            inputValue={row.unit}
                            onChange={(e) =>
                              handleUnitChange(e.target.value, index)
                            }
                            maxLength={10}
                            inputCssStyle={{
                              _hover: { border: "1px solid", borderRadius: "10px" },
                            }}
                          />
                        </Td>
                        <Td p="0">
                          <PrimaryInput
                            variant="bothSide"
                            inputPlace="Low Range"
                            inputValue={row.lowrange}
                            onChange={(e) =>
                              handleLowRangeChange(e.target.value, index)
                            }
                            inputCssStyle={{
                              _hover: { border: "1px solid", borderRadius: "10px" },
                            }}
                            maxLength={30}
                          />
                        </Td>
                        <Td p="0">
                          <PrimaryInput
                            variant="bothSide"
                            inputPlace="High Range"
                            inputValue={row.highrange}
                            onChange={(e) =>
                              handleHighRangeChange(e.target.value, index)
                            }
                            inputCssStyle={{
                              _hover: { border: "1px solid", borderRadius: "10px" },
                            }}
                            maxLength={30}
                          />
                        </Td>
                        <Td p="0">
                          <PrimaryInput
                            variant="bothSide"
                            inputPlace="Formula"
                            inputValue={row.formula}
                            onChange={(e) =>
                              handleFormulaChange(e.target.value, index)
                            }
                            inputCssStyle={{
                              _hover: { border: "1px solid", borderRadius: "10px" },
                            }}
                            maxLength={30}
                          />
                        </Td>
                        <Td p="0">
                          <Box
                            as="button"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            w="100%"
                            onClick={() => confirmDeleteRow(index)}
                          >
                            <Image src="/assets/svgs/delete.svg" opacity="0.7" />
                          </Box>
                        </Td>
                      </Tr>
                    ))}
                  </>
                }
            />
              </Box>
                  
                  {/* Table data end */}
                </>
              }
              footerActions={
                <>
                {/* {showpatientinfo ?(
                  <PrimaryButton buttonText="Next" onClick={SubmitPatientForm}/>
                ):( */}
                  <PrimaryButton buttonText="Submit" 
                  onClick={handleSubmitGenerateReport}
                  // onClick={SubmitForm}
                  />
                {/* )} */}
                </>
              }
            />

            <DynamicModal
                      ref={deleteRowModal}
                      modalHeader="Delete row"
                      modalBody={
                        <>
                          <Text fontSize="14px" fontWeight="600">
                            Are you sure you want to delete?
                          </Text>
                        </>
                      }
                      modalFooterBtn={
                        <>
                          <PrimaryButton
                            variant="deleteBtn"
                            buttonText="Delete"
                            onClick={deleteRowHandler}
                          />
                        </>
                      }
                    />

<DynamicModal
  ref={previewModal}
  modalHeader="Aira: IPD Discharge Notes"
  modalWidth={"50vw"}
  hasFooter={false}
  modalBody={
    <>
      <Box
        width='100%'
        overflowY="scroll"
        sx={{
          "::-webkit-scrollbar": {
            display: "none",
          },
          msOverflowStyle: "none",
          scrollbarWidth: "none",
        }}
      >
        <>
          <Tabs>
            <TabList height={"3rem"} borderBottom={"1px solid gray"}>
              <Tab
                onClick={() => handleTabChange("discharge")}
                _selected={{ color: "black", borderBottom: "2px solid black" }}
                fontSize={{ base: "12px", lg: "initial" }}
              >
                Discharge Summary
              </Tab>
              <Tab
                onClick={() => handleTabChange("share")}
                _selected={{ color: "black", borderBottom: "2px solid black" }}
                fontSize={{ base: "12px", lg: "initial" }}
              >
                Share Details
              </Tab>
            </TabList>

            <TabPanels
              height="calc(77vh - 2.5rem)"
              overflowY="auto"
              mt="2rem"
              sx={{
                "::-webkit-scrollbar": { display: "none" },
                msOverflowStyle: "none",
                scrollbarWidth: "none"
              }}
            >
              {/* Discharge Summary Tab */}
              <TabPanel p={{ base: "0" }}>
                <Flex w='100%' gap='1rem'>
                  {/* Patient Information */}
                  <Box w='100%' mb={4}>
                    <Flex justifyContent="space-between" alignItems="center">
                      <Heading as="h4" size="md">Patient Information</Heading>
                      <Spacer />
                      <IconButton
                        aria-label="Copy Patient Info"
                        icon={<CopyIcon />}
                        onClick={() => copyToClipboard(formatPatientInfo(aiDischargeResponse?.patient_info))}
                        variant="ghost"
                      />
                    </Flex>
                    <Textarea
                      value={editableSections.patientInfo || formatPatientInfo(aiDischargeResponse?.patient_info)}
                      isReadOnly // Added read-only
                      resize="none"
                      h='100px'
                      placeholder="Enter patient information..."
                    />
                  </Box>
      
                  {/* Admission Details */}
                  <Box w='100%' mb={4}>
                    <Flex justifyContent="space-between" alignItems="center">
                      <Heading as="h4" size="md">Admission Details</Heading>
                      <Spacer />
                      <IconButton
                        aria-label="Copy Admission Details"
                        icon={<CopyIcon />}
                        onClick={() => copyToClipboard(formatAdmissionDetails(aiDischargeResponse?.admission_details))}
                        variant="ghost"
                      />
                    </Flex>
                    <Textarea
                      value={editableSections.admissionDetails || formatAdmissionDetails(aiDischargeResponse?.admission_details)}
                      isReadOnly // Added read-only
                      resize="none"
                      h='100px'
                      placeholder="Admitted: [date]\nDischarged: [date]"
                    />
                  </Box>
                </Flex>
      
                {/* Diagnosis */}
                {/* {dischargeDisplaySettings && dischargeDisplaySettings.diagnosis == 1 && ( */}
                <Box mt={8} mb={4}>
                  <Flex justifyContent="space-between" alignItems="center">
                    <Heading as="h4" size="md">Diagnosis</Heading>
                    <Spacer />
                    <IconButton
                      aria-label="Copy Diagnosis"
                      icon={<CopyIcon />}
                      onClick={() => copyToClipboard(formatDiagnosis(aiDischargeResponse?.diagnosis))}
                      variant="ghost"
                    />
                  </Flex>
                  <Textarea
                    value={editableSections.diagnosis || formatDiagnosis(aiDischargeResponse?.diagnosis)}
                    isReadOnly // Added read-only
                    resize="none"
                    h='100px'
                    placeholder="Enter one diagnosis per line..."
                  />
                </Box>
                {/* )} */}
      
                {/* Presenting Complaints */}
                {/* {dischargeDisplaySettings && dischargeDisplaySettings.complaints == 1 && ( */}
                <Box my={4}>
                  <Flex justifyContent="space-between" alignItems="center">
                    <Heading as="h4" size="md">Presenting Complaints</Heading>
                    <Spacer />
                    <IconButton
                      aria-label="Copy Presenting Complaints"
                      icon={<CopyIcon />}
                      onClick={() => copyToClipboard(formatComplaints(aiDischargeResponse?.presenting_complaints))}
                      variant="ghost"
                    />
                  </Flex>
                  <Textarea
                    value={editableSections.presentingComplaints || formatComplaints(aiDischargeResponse?.presenting_complaints)}
                    isReadOnly // Added read-only
                    resize="none"
                    h='100px'
                    placeholder="Description - Onset (one per line)"
                  />
                </Box>
                {/* )} */}
      
                {/* Clinical Findings */}
                {/* {dischargeDisplaySettings && dischargeDisplaySettings.findings == 1 && ( */}
                <Box my={4}>
                  <Flex justifyContent="space-between" alignItems="center">
                    <Heading as="h4" size="md">Clinical Findings</Heading>
                    <Spacer />
                    <IconButton
                      aria-label="Copy Clinical Findings"
                      icon={<CopyIcon />}
                      onClick={() => copyToClipboard(formatClinicalFindings(aiDischargeResponse?.clinical_findings))}
                      variant="ghost"
                    />
                  </Flex>
                  <Textarea
                    value={editableSections.clinicalFindings || formatClinicalFindings(aiDischargeResponse?.clinical_findings)}
                    isReadOnly // Added read-only
                    resize="none"
                    h='200px'
                    placeholder="General Condition: [text]\nVitals:\n- [name]: [value] [unit]\nSystemic Exam:\n- [system]: [finding]"
                  />
                </Box>
                {/* )} */}
      
                {/* History */}
                {/* {dischargeDisplaySettings && dischargeDisplaySettings.history == 1 && ( */}
                <Box mb={4}>
                  <Flex justifyContent="space-between" alignItems="center">
                    <Heading as="h4" size="md">History</Heading>
                    <Spacer />
                    <IconButton
                      aria-label="Copy History"
                      icon={<CopyIcon />}
                      onClick={() => copyToClipboard(formatHistory(aiDischargeResponse?.history))}
                      variant="ghost"
                    />
                  </Flex>
                  <Textarea
                    value={editableSections.history || formatHistory(aiDischargeResponse?.history)}
                    isReadOnly // Added read-only
                    resize="none"
                    h='150px'
                    placeholder="Personal History:\n- [history]\n\nPast Medical History:\n- [history]\n\nPast Surgical History:\n- [history]\n\nChronic Medications:\n- [medication]"
                  />
                </Box>
                {/* )} */}
      
                {/* Investigations */}
                {/* {dischargeDisplaySettings && dischargeDisplaySettings.investigation == 1 && ( */}
                <Box mb={4}>
                  <Flex justifyContent="space-between" alignItems="center">
                    <Heading as="h4" size="md">Investigations</Heading>
                    <Spacer />
                    <IconButton
                      aria-label="Copy Investigations"
                      icon={<CopyIcon />}
                      onClick={() => copyToClipboard(formatInvestigations(aiDischargeResponse?.investigations))}
                      variant="ghost"
                    />
                  </Flex>
                  <Textarea
                    value={editableSections.investigations || formatInvestigations(aiDischargeResponse?.investigations)}
                    isReadOnly // Added read-only
                    resize="none"
                    h='100px'
                    placeholder="[Name]: [Value] [Unit]\nExample:\nHemoglobin: 9.6 g/dL\nBlood Urea: 68 mg/dL"
                  />
                </Box>
                {/* )} */}
      
                {/* Procedures */}
                {/* {dischargeDisplaySettings && dischargeDisplaySettings.procedure == 1 && ( */}
                <Box mb={4}>
                  <Flex justifyContent="space-between" alignItems="center">
                    <Heading as="h4" size="md">Procedures</Heading>
                    <Spacer />
                    <IconButton
                      aria-label="Copy Procedures"
                      icon={<CopyIcon />}
                      onClick={() => copyToClipboard(formatProcedures(aiDischargeResponse?.procedures))}
                      variant="ghost"
                    />
                  </Flex>
                  <Textarea
                    value={editableSections.procedures || formatProcedures(aiDischargeResponse?.procedures)}
                    isReadOnly // Added read-only
                    resize="none"
                    h='100px'
                    placeholder="[Procedure Name] - [Date]\n[Details]\n\nExample:\nECG - 10/07/2025\nNormal sinus rhythm"
                  />
                </Box>
                {/* )} */}
      
                {/* Hospital Course */}
                {/* {dischargeDisplaySettings && dischargeDisplaySettings.course == 1 && ( */}
                <Box mb={4}>
                  <Flex justifyContent="space-between" alignItems="center">
                    <Heading as="h4" size="md">Hospital Course</Heading>
                    <Spacer />
                    <IconButton
                      aria-label="Copy Hospital Course"
                      icon={<CopyIcon />}
                      onClick={() => copyToClipboard(formatHospitalCourse(aiDischargeResponse?.hospital_course))}
                      variant="ghost"
                    />
                  </Flex>
                  <Textarea
                    value={editableSections.hospitalCourse || formatHospitalCourse(aiDischargeResponse?.hospital_course)}
                    isReadOnly // Added read-only
                    resize="none"
                    h='120px'
                    placeholder="Summary: [text]\nInterventions:\n- [name]: [notes]"
                  />
                </Box>
                {/* )} */}
      
                {/* Discharge Medications */}
                {/* {dischargeDisplaySettings && dischargeDisplaySettings.medication == 1 && ( */}
                <Box mb={4}>
                  <Flex justifyContent="space-between" alignItems="center">
                    <Heading as="h4" size="md">Discharge Medications</Heading>
                    <Spacer />
                    <IconButton
                      aria-label="Copy Discharge Medications"
                      icon={<CopyIcon />}
                      onClick={() => copyToClipboard(formatMedications(aiDischargeResponse?.medications_on_discharge))}
                      variant="ghost"
                    />
                  </Flex>
                  <Textarea
                    value={editableSections.dischargeMeds || formatMedications(aiDischargeResponse?.medications_on_discharge)}
                    isReadOnly // Added read-only
                    resize="none"
                    h='120px'
                    placeholder="[Name] [Dose] [Frequency] [Route]\nExample:\nTelma 40 40mg once daily oral"
                  />
                </Box>
                {/* )} */}
      
                {/* Instructions */}
                {/* {dischargeDisplaySettings && dischargeDisplaySettings.instruction == 1 && ( */}
                <Box mb={4}>
                  <Flex justifyContent="space-between" alignItems="center">
                    <Heading as="h4" size="md">Instructions</Heading>
                    <Spacer />
                    <IconButton
                      aria-label="Copy Instructions"
                      icon={<CopyIcon />}
                      onClick={() => copyToClipboard(formatInstructions(aiDischargeResponse?.instructions))}
                      variant="ghost"
                    />
                  </Flex>
                  <Textarea
                    value={editableSections.instructions || formatInstructions(aiDischargeResponse?.instructions)}
                    isReadOnly // Added read-only
                    resize="none"
                    h='120px'
                    placeholder="To Do:\n- [instruction]\nNot To Do:\n- [instruction]"
                  />
                </Box>
                {/* )} */}
      
                {/* Follow Up Plan */}
                {/* {dischargeDisplaySettings && dischargeDisplaySettings.followup == 1 && ( */}
                <Box mb={4}>
                  <Flex justifyContent="space-between" alignItems="center">
                    <Heading as="h4" size="md">Follow Up Plan</Heading>
                    <Spacer />
                    <IconButton
                      aria-label="Copy Follow Up Plan"
                      icon={<CopyIcon />}
                      onClick={() => copyToClipboard(formatFollowUpPlan(aiDischargeResponse?.follow_up_plan))}
                      variant="ghost"
                    />
                  </Flex>
                  <Textarea
                    value={editableSections.followUpPlan || formatFollowUpPlan(aiDischargeResponse?.follow_up_plan)}
                    isReadOnly // Added read-only
                    resize="none"
                    h='100px'
                    placeholder="Follow up after: [days] days\nLocation: [location]\nDoctor: [doctor]\nContact: [contact]"
                  />
                </Box>
                {/* )} */}

                {/* Dynamic Custom Attributes Section */}
                {aiDischargeResponse?.custom_attributes && Object.keys(aiDischargeResponse.custom_attributes).length > 0 && (
                  <Box mb={4}>
                    <Heading as="h4" size="md" mb={4} color="gray.600">
                      {/* Additional Information */}
                      Dynamic Attributes
                    </Heading>
                    
                    {Object.entries(aiDischargeResponse.custom_attributes).map(([key, value]) => {
                      const formattedKey = formatAttributeKey(key);
                      const formattedValue = formatValue(value);
                      
                      return (
                        <Box key={key} mb={4}>
                          <Flex justifyContent="space-between" alignItems="center">
                            <Heading as="h5" size="sm">{formattedKey}</Heading>
                            <Spacer />
                            <IconButton
                              aria-label={`Copy ${formattedKey}`}
                              icon={<CopyIcon />}
                              onClick={() => copyToClipboard(formattedValue)}
                              variant="ghost"
                              size="sm"
                            />
                            <IconButton
                              aria-label={`Clear ${formattedKey}`}
                              icon={<CgRemove />}
                              onClick={() => setEditableSections(prev => ({
                                ...prev,
                                [key]: ""
                              }))}
                              variant="ghost"
                              size="sm"
                            />
                          </Flex>
                          <Textarea
                            value={editableSections[key] !== undefined ? editableSections[key] : formattedValue}
                            onChange={(e) => setEditableSections(prev => ({
                              ...prev,
                              [key]: e.target.value
                            }))}
                            resize="none"
                            h='100px'
                            placeholder={`Enter ${formattedKey.toLowerCase()}...`}
                          />
                        </Box>
                      );
                    })}
                  </Box>
                )}
      
                <Text fontWeight="bold" color="black" fontSize="sm">
                  AIRA strives to be as accurate as possible, but occasional
                  errors may occur. Please verify its responses to ensure the
                  information meets your needs.
                </Text>
              </TabPanel>

              {/* Share Details Tab */}
              <TabPanel p={{ base: "0" }}>
                <Box mb={4}>
                  <Flex justifyContent="space-between" alignItems="center">
                    <Heading as="h4" size="md">Email Information</Heading>
                    <Spacer />
                    <IconButton
                      aria-label="Copy Email"
                      icon={<CopyIcon />}
                      onClick={() => copyToClipboard(shareReportDoctorEmail)}
                      variant="ghost"
                    />
                  </Flex>
                  <Textarea
                    value={shareReportDoctorEmail}
                    isReadOnly // Added read-only
                    resize="none"
                  />
                  <Heading as="h4" size="md" mt={6}>Details:</Heading>
                  <Stack spacing={2} mt={2}>
                    <Checkbox
                      isChecked={shareChatSummary}
                      isReadOnly // Added read-only for checkboxes
                    >
                      Share chat summary
                    </Checkbox>
                    <Checkbox
                      isChecked={shareChatHistory}
                      isReadOnly // Added read-only for checkboxes
                    >
                      Share chat history
                    </Checkbox>
                    <Checkbox
                      isChecked={shareDoctorNotes}
                      isReadOnly // Added read-only for checkboxes
                    >
                      Share Discharge Summary Notes
                    </Checkbox>
                  </Stack>
                  <Button
                    className="primary-button-icon" 
                    sx={{
                      h: "2.5rem",
                      w: "8rem",
                      p: "1rem",
                      m: "0",
                      mr:'1rem',
                      mt: "48px",
                      bg: COLORS.PRIMARY_GRADIENT,
                      color: COLORS.PRIMARY_WHITE,
                      _hover: { bg: COLORS.PRIMARY_COLOR },
                    }}
                  >
                    <Box className="icon-img" as="span" sx={{ mr: "0.5rem" }}>
                      <Image src="/assets/imgs/email-icon.png" h={"24px"} w={"24px"} />
                    </Box>
                    <Text>Share</Text>
                  </Button>
                  <Button
                    className="primary-button-icon" 
                    onClick={downloadSummary}
                    sx={{
                      h: "2.5rem",
                      w: "8rem",
                      p: "1rem",
                      m: "0",
                      mt: "48px",
                      bg: COLORS.PRIMARY_GRADIENT,
                      color: COLORS.PRIMARY_WHITE,
                      _hover: { bg: COLORS.PRIMARY_COLOR },
                    }}
                  >
                    <Box className="icon-img" as="span" sx={{ mr: "0.5rem" }}>
                      <Image src="/assets/imgs/email-icon.png" h={"24px"} w={"24px"} />
                    </Box>
                    <Text>Download</Text>
                  </Button>
                </Box>
              </TabPanel>
            </TabPanels>
          </Tabs>
        </>
      </Box>
    </>
  }
/>
    </>
  );
};

export default PrescriptionViewIndex;
